// ImportEmployeeModal.js
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./addEmployeeModal.css"; // External CSS file
import cancelIcon from "../../../../assets/images/cancelArrow.svg";
import { Field, FieldArray, Form, Formik } from "formik";
import { notifySuccess, notifyWarn } from "../../../../assets/elements/Toast";
import * as Yup from "yup";
import CustomErrorMessage from "../../../../assets/common/CustomeErrorMessage";
import dateIcon from "../../../../assets/images/dateIcon.svg";
import arrowIcon from "../../../../assets/images/arrowIcon.svg";
import addIcon from "../../../../assets/images/addIcon.svg";
import MainServices from "../../../../services/MainServices";
import AsyncSelect from "react-select/async";
import moment from "moment";
import { toast } from "react-toastify";
import axios from "axios";
import CustomErrorMsgArray from "../../../../assets/common/CustomErrorMsgArray";
import { SalaryComponent } from "./SalaryComponent";
import ButtonLoading from "../../../../assets/loaders/ButtonLoading";
import HijriDatePicker from "./HijriDatePicker";
import DropDownIcon from "../../../../assets/common/dropdownicon";
import HijriDate from "hijri-date";
import { toGregorian, toHijri } from "hijri-converter";
import TimingFunctions from "../../../../assets/functions/TimingFunctions";
import CustomCheckbox from "../table/CustomCheckbox";
import PageLoader from "../../../../assets/loaders/PageLoading";
import useRTLContext from "../../../../hooks/useRTLContext";
import { useTranslation } from "react-i18next";
import DocumentUploadDisplay from "./DocumentUploadDisplay";
import { useDebounceSearch } from "../../../../hooks/useDebounceSearch";
import ValidateIndicators from "./ValidateIndicators";
import apiServices from "../../../../services/ApiServices";
import { useAggregatedValidation } from "../../../../context/useAggregatedValidation";
import { useMultiStepValidation } from "./useMultiStepValidation";
import {
  getAsyncSelectPortalProps,
  getAsyncSelectStylesForm,
} from "../../../../utils/asynSelectStyles";
import { documentValidation } from "./validation";
import DocumentViewerDemo from "../employeesNew/DocumentViewerNew";
import DocumentViewerNew from "../employeesNew/DocumentViewerNew";

export default function AddEmployeeModal({
  isOpen,
  onClose,
  onCloseWarning,
  handleOnSubmit,
  empPublicId,
  handleGetTableData,
  handleDraftSubmit,
  handleSaveSubmit,
  handleSaveAndSubmitWhenUpdate,
  getEmployeeStats,
  getAdditionalStats,
  invitePending,
  handleOnSubmitInvited,
  handleOnUpdateInvited,
  currentEmployeeEditing = false,
}) {
  const {
    getReligionMaster,
    getCountryMaster,
    getStateMaster,
    getNationalityMaster,
    getRolesMaster,
    getJobTitleData,
    getJobGradeData,
    getDepartmentMaster,
    getDesignationMaster,
    getEmployeesMasterData,
    getPersonalInfoById,
    getJobGradeMaster,
    getContractTypeMaster,
    getProbationPeriodMaster,
    getEmployementTypeMaster,
    getBranchMaster,
    getIqamaProfessionMaster,
    getBankMaster,
    getInsuranceClassMaster,
    getRelationMaster,
    addEmployeeMaster,
    getVisaTypeMaster,
    addIqamaDocMaster,
    addDocumentsMaster,
    fileUpload,
    updateEmployeeRegistrationMaster,
    fetchEmployeeRegistrationDataById,
  } = MainServices();
  const activeFilter = { key: "status", eq: "active" };
  const { isRTL, direction } = useRTLContext();
  const { t, i18n } = useTranslation();
  const noEditingMsg = t("Read-only");
  const [docUploadLoading, setDocUploadLoading] = useState(false);

  const [draftAndExit, setDraftAndExit] = useState(false);
  const [saveAndExit, setSaveAndExit] = useState(false);
  const { deBounce } = TimingFunctions();
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef1Gosi = useRef(null);
  const fileInputRef2Gosi = useRef(null);
  const addMemberRef = useRef(null);
  const [activeMemberIndex, setActiveMemberIndex] = useState(null);
  const [dependentEditing, setDependentEditing] = useState(false);
  const [totalSalary, setTotalSalary] = useState("");

  const [detailsStep, setDetailsStep] = useState(1);
  const [documentTab, setDocumnetTab] = useState("Salary Details");
  const [docModal, setDocModal] = useState(false);
  const [docModalGosi, setDocModalGosi] = useState(false);
  const [docsTabs, setDocsTabs] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [religionOptions, setReligionOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [jobTitleOptions, setJobTitleOptions] = useState([]);
  const [jobGradeOptions, setJobGradeOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [reportingTo, setReportingTo] = useState([]);
  const [contractType, setContractType] = useState([]);
  const [probationPeriod, setProbationPeriod] = useState([]);
  const [bank, setBank] = useState([]);
  const [employmentType, setEmploymentType] = useState([]);
  const [visaType, setVisaType] = useState([]);
  const [depRelationOptions, setDepRelationOptions] = useState([]);
  const [dobHijriError, setDobHijriError] = useState("");
  const [dobGregorianError, setDobGregorianError] = useState("");
  const [employeeRegistrationData, setEmployeeRegistrationData] =
    useState(null);
  const [personalInfo, setPersonalInfo] = useState(null);
  const [employmentInfo, setEmploymentInfo] = useState(null);
  const [salaryDetails, setSalaryDetails] = useState(null);
  const [nationalDetails, setNationalDetails] = useState(null);
  const [iqamaDetails, setIqamaDetails] = useState(null);
  const [accountDetails, setAccountDetails] = useState(null);
  const [healthInsuranceDetails, setHealthInsuranceDetails] = useState(null);
  const [healthCardDetails, setHealthCardDetails] = useState(null);
  const [passportDetails, setPassportDetails] = useState(null);
  const [visaDetails, setVisaDetails] = useState(null);
  const [contractDetails, setContractDetails] = useState(null);
  const [drivingLicenseDetails, setDrivingLicenseDetails] = useState(null);
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [dependentsInfo, setDependentsInfo] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [isDraft, setIsDraft] = useState(false);
  const [draftedData, setDraftedData] = useState("");
  const [activeDocTab, setActiveDocTab] = useState("");
  const [draftLoading, setDraftLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [skippedSections, setSkippedSections] = useState(() =>
    currentEmployeeEditing
      ? [
          "employmentInfo",
          "Salary Details",
          "Iqama",
          "Account",
          "Health Insurance",
          "Health Card",
          "Visa",
          "Contract",
          "Subscription",
        ]
      : []
  );
  const [isDependentsInfo, setIsDependentsInfo] = useState(false);
  const [latestPublicId, setLatestPublicId] = useState("");
  const [latestConcurrencyStamp, setLatestConcurrencyStamp] = useState("");
  const [dataLoading, setDataLoading] = useState(false);
  const [isNewEmpEdded, setIsNewEmpAdded] = useState(false);
  const [profilePictureError, setProfilePictureError] = useState("");
  const [documentViewerState, setDocumentViewerState] = useState({
    isOpen: false,
    url: "",
    fileName: "",
  });

  const [formValues, setFormValues] = useState({
    firstName: "",
    firstNameArb: "",
    secondName: "",
    secondNameArb: "",
    thirdName: "",
    thirdNameArb: "",
    lastName: "",
    lastNameArb: "",
    phone: "",
    personalEmail: "",
    email: "",
    state: "",
    country: "",
    dobGregorian: "",
    dobHijri: "",
    religion: "",
    maritalStatus: "",
    gender: "",
    citizen: "",
    nationality: null,
    nationalId: "",
    profilePicture: { fileName: "", fileUrl: "" },
    userInvitation: "false",
    // Employment Info
    branch: "",
    role: "",
    jobTitle: "",
    designation: "",
    department: "",
    reportingTo: "",
    joiningDate: "",
    jobGrade: "",
    contractType: "",
    probationPeriod: "",
    employmentType: "",
    // Salary Info
    basicPay: "",
    housingAllows: "",
    transportAllows: "",
    foodAllows: "",
    otherAllows: "",
    totalSalary: "",
    gosiDeduction: "",
    // national id
    nationalId: "",
    nationalIdExpiry: "",
    placeOfBirth: "",
    nationalDocFront: "",
    nationalDocBack: "",
    // Iqama Info
    iqamaProfession: "",
    iqNationality: null,
    iqamaId: "",
    iqamaIdExpiry: null,
    workPermitNo: "",
    workPermitExpiry: null,
    iqamaNationalityId: "",
    iqamaNationalityIdExpiry: "",
    iqamaDocFront: "",
    iqamaDocBack: "",
    // Bank Info
    bank: "",
    accountHolderName: "",
    ibanNo: "",
    confirmIban: "",
    ifscCode: "",
    accountFront: "",
    accountBack: "",
    // Health Insurance Info
    insuranceClass: "",
    insuranceNo: "",
    insuranceExpiry: "",
    insuranceDocFront: "",
    insuranceDocBack: "",
    // health card
    healthCard: "",
    healthCardNo: "",
    healthCardExpiry: "",
    healthCardDocFront: "",
    healthCardDocBack: "",
    // Passport Info
    passportNo: "",
    passportExpiry: "",
    passportNationality: "",
    passportIssue: "",
    issuePlace: "",
    passportDocFront: "",
    passportDocBack: "",
    // Visa Info
    visaNo: "",
    visaExpiry: null,
    vNationality: null,
    visaIssue: null,
    visaIssuePlace: "",
    visaType: "",
    visaDocFront: "",
    visaDocBack: "",
    // Contract Info
    contractNo: "",
    contractEnd: "",
    contractDocFront: "",
    contractDocBack: "",
    // Driving License
    drivingLicenseNo: "",
    licenseValidity: "",
    drivingLicenseDocFront: "",
    drivingLicenseDocBack: "",
    // Subscription Info
    gosiRegNo: "",
    gosiReg: "",
    gosiDocFront: "",
    gosiDocBack: "",
    mudadRegNo: "",
    mudadReg: "",
    subscriptionDocFront: "",
    subscriptionDocBack: "",
    // Members
    isDependents: "false",
    members: [
      // {
      //   depFirstName: "",
      //   depSecondName: "",
      //   depThirdName: "",
      //   depFourthName: "",
      //   depIdNumber: "",
      //   idExpiry: "",
      //   depPassportNo: "",
      //   depPassportExpiry: "",
      //   depContactNo: "",
      //   depDob: "",
      //   depGender: "",
      //   depCitizen: "",
      //   depNationality: "",
      //   depSponsorName: "",
      //   depSponsorId: "",
      //   depReligion: "",
      //   depMaritalStatus: "",
      //   depRelation: "",
      // },
    ],
  });

  const [employeeDocNames, setEmployeeDocNames] = useState({
    nationalDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ], // Front and Back
    iqamaDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ],
    accountDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ], // Single file
    insuranceDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ],
    healthCardDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ],
    passportDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ],
    visaDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ],
    contractDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ],
    drivingLicenseDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ],
    gosiDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ],
    subscriptionDocNames: [
      { fileName: "", fileUrl: "" },
      { fileName: "", fileUrl: "" },
    ],
  });

  const docConfig = {
    nationalDoc: ["nationalDocFront", "nationalDocBack"],
    iqamaDoc: ["iqamaDocFront", "iqamaDocBack"],
    accountDoc: ["accountFront", "accountBack"],
    insuranceDoc: ["insuranceDocFront", "insuranceDocBack"],
    healthCardDoc: ["healthCardDocFront", "healthCardDocBack"],
    passportDoc: ["passportDocFront", "passportDocBack"],
    visaDoc: ["visaDocFront", "visaDocBack"],
    contractDoc: ["contractDocFront", "contractDocBack"],
    drivingLicenseDoc: ["drivingLicenseDocFront", "drivingLicenseDocBack"],
    gosiDoc: ["gosiDocFront", "gosiDocBack"],
    subscriptionDoc: ["subscriptionDocFront", "subscriptionDocBack"],
  };

  const docTypeToStateKey = {
    nationalDoc: "nationalDocNames",
    iqamaDoc: "iqamaDocNames",
    accountDoc: "accountDocNames",
    insuranceDoc: "insuranceDocNames",
    healthCardDoc: "healthCardDocNames",
    passportDoc: "passportDocNames",
    visaDoc: "visaDocNames",
    contractDoc: "contractDocNames",
    drivingLicenseDoc: "drivingLicenseDocNames",
    gosiDoc: "gosiDocNames",
    subscriptionDoc: "subscriptionDocNames",
  };

  // Prevent background scroll when modal is open
  useEffect(() => {
    // Store original overflow value
    const originalOverflow = document.body.style.overflow;

    // Disable background scroll
    document.body.style.overflow = "hidden";

    // Cleanup function to restore original overflow when modal unmounts
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  useEffect(() => {
    if (empPublicId) {
      getEmployeeRegistrationData();
    }
  }, [empPublicId]);

  useEffect(() => {
    if (employeeRegistrationData) {
      setFormValues({
        firstName: personalInfo?.firstName || "",
        firstNameArb: personalInfo?.firstNameArb || "",
        secondName: personalInfo?.secondName || "",
        secondNameArb: personalInfo?.secondNameArb || "",
        thirdName: personalInfo?.thirdName || "",
        thirdNameArb: personalInfo?.thirdNameArb || "",
        lastName: personalInfo?.lastName || "",
        lastNameArb: personalInfo?.lastNameArb || "",
        phone: personalInfo?.phone || "",
        personalEmail: personalInfo?.personalEmail || "",
        email: personalInfo?.email || "",
        state: personalInfo?.state || "",
        country: personalInfo?.country || "",
        // dobGregorian: personalInfo?.dobGregorian || "",
        dobGregorian: personalInfo?.dobGregorian || "",
        dobHijri: personalInfo?.dobHijri || "",
        religion: personalInfo?.religionInfo
          ? {
              label: personalInfo.religionInfo.name,
              value: personalInfo.religionInfo.publicId,
            }
          : "",
        maritalStatus: personalInfo?.maritalStatus || "",
        gender: personalInfo?.gender || "",
        citizen: personalInfo?.citizen || "",
        nationality: personalInfo?.nationalityInfo
          ? {
              label: personalInfo.nationalityInfo.name,
              value: personalInfo.nationalityInfo.publicId,
            }
          : personalInfo?.nationality || null,
        nationalId: personalInfo?.nationalId || "",
        profilePicture: personalInfo?.profilePicture
          ? {
              fileName: personalInfo?.profilePicture?.fileName || "",
              fileUrl: personalInfo?.profilePicture?.fileUrl || "",
            }
          : { fileName: "", fileUrl: "" },
        userInvitation: personalInfo?.userInvitation,
        // Employment Info
        branch: employmentInfo?.branchInfo
          ? {
              label: employmentInfo.branchInfo?.name,
              value: employmentInfo.branchInfo?.publicId,
            }
          : "",
        role: employmentInfo?.roleInfo
          ? {
              label: employmentInfo?.roleInfo?.role,
              value: employmentInfo?.roleInfo?.publicId,
            }
          : "",
        jobTitle: employmentInfo?.jobTitleInfo
          ? {
              label: employmentInfo?.jobTitleInfo?.name,
              value: employmentInfo?.jobTitleInfo?.publicId,
            }
          : "",
        designation: employmentInfo?.designationInfo
          ? {
              label: employmentInfo.designationInfo.name,
              value: employmentInfo.designationInfo.publicId,
            }
          : "",
        department: employmentInfo?.departmentInfo
          ? {
              label: employmentInfo.departmentInfo.name,
              value: employmentInfo.departmentInfo.publicId,
            }
          : "",
        reportingTo: employmentInfo?.reportingToInfo
          ? {
              label:
                `${employmentInfo.reportingToInfo.firstName || ""} ${
                  employmentInfo.reportingToInfo.lastName || ""
                }${
                  employmentInfo.reportingToInfo.email
                    ? ` (${employmentInfo.reportingToInfo.email})`
                    : ""
                }`.trim() ||
                employmentInfo.reportingToInfo.email ||
                "-",
              value: employmentInfo.reportingToInfo.publicId || "",
            }
          : "",

        joiningDate: employmentInfo?.joiningDate || "",
        jobGrade: employmentInfo?.jobGradeInfo
          ? {
              label: employmentInfo?.jobGradeInfo?.name,
              value: employmentInfo?.jobGradeInfo?.publicId,
            }
          : "",
        contractType: employmentInfo?.contractType
          ? {
              label: employmentInfo.contractType,
              value: employmentInfo.contractType,
            }
          : "",
        probationPeriod: employmentInfo?.probationPeriod || "",
        // probationPeriod: employmentInfo?.probationPeriodInfo
        //   ? {
        //       label: employmentInfo.probationPeriodInfo.name,
        //       value: employmentInfo.probationPeriodInfo.publicId,
        //     }
        //   : "",
        employmentType: employmentInfo?.employeeType
          ? {
              label: employmentInfo?.employeeType,
              value: employmentInfo?.employeeType,
            }
          : employmentInfo?.employeeType || "",
        // Salary Info
        basicPay: salaryDetails?.basicPay || "",
        housingAllows: salaryDetails?.housingAllows || "",
        transportAllows: salaryDetails?.transportAllows || "",
        foodAllows: salaryDetails?.foodAllows || "",
        otherAllows: salaryDetails?.otherAllows || "",
        totalSalary: salaryDetails?.totalSalary || "",
        gosiDeduction: salaryDetails?.gosiDeduction || "",
        deductionAmount: salaryDetails?.deductionAmount,
        // national id
        nationalId: personalInfo?.nationalId || "",
        nationalIdExpiry: nationalDetails?.nationalIdExpiry || "",
        placeOfBirth: nationalDetails?.placeOfBirth || "",
        nationalDocFront: nationalDetails?.nationalDocFront || "",
        nationalDocBack: nationalDetails?.nationalDocBack || "",

        // Iqama Info
        iqamaProfession: iqamaDetails?.iqamaProfession || "",
        iqNationality: iqamaDetails?.nationalityInfo
          ? {
              label: iqamaDetails.nationalityInfo.name,
              value: iqamaDetails.nationalityInfo.publicId,
            }
          : iqamaDetails?.nationality || null,
        iqamaId: iqamaDetails?.iqamaId || "",
        iqamaIdExpiry: iqamaDetails?.iqamaIdExpiry || null,
        workPermitNo: iqamaDetails?.workPermitNo || "",
        workPermitExpiry: iqamaDetails?.workPermitExpiry || null,
        iqamaNationalityId: iqamaDetails?.nationalityId || "",
        iqamaNationalityIdExpiry: iqamaDetails?.nationalityIdExpiry || "",
        iqamaDocFront: iqamaDetails?.frontDocument || "",
        iqamaDocBack: iqamaDetails?.backDocument || "",
        // Bank Info
        bank: accountDetails?.bankInfo
          ? {
              label: accountDetails.bankInfo.name,
              value: accountDetails.bankInfo.publicId,
            }
          : accountDetails?.bank || "",
        accountHolderName: accountDetails?.accountHolderName || "",
        ibanNo: accountDetails?.ibanNo || "",
        confirmIban: accountDetails?.ibanNo || "",
        ifscCode: accountDetails?.ifscCode || "",
        accountFront: accountDetails?.frontDocument || "",
        accountBack: accountDetails?.backDocument || "",
        // Health Insurance Info
        insuranceClass: healthInsuranceDetails?.insuranceClass || "",
        insuranceNo: healthInsuranceDetails?.insuranceNo || "",
        insuranceExpiry: healthInsuranceDetails?.insuranceExpiry || "",
        insuranceDocFront: healthInsuranceDetails?.frontDocument || "",
        insuranceDocBack: healthInsuranceDetails?.backDocument || "",
        // health card info
        healthCard: healthCardDetails?.healthCard || "",
        healthCardNo: healthCardDetails?.healthCardNo || "",
        healthCardExpiry: healthCardDetails?.healthCardExpiry || "",
        healthCardDocFront: healthCardDetails?.frontDocument || "",
        healthCardDocBack: healthCardDetails?.backDocument || "",
        // Passport Info
        passportNo: passportDetails?.passportNo || "",
        passportExpiry: passportDetails?.expiryDate || "",
        passportNationality: passportDetails?.nationalityInfo
          ? {
              label: passportDetails.nationalityInfo.name,
              value: passportDetails.nationalityInfo.publicId,
            }
          : passportDetails?.nationality || "",
        passportIssue: passportDetails?.issueDate || "",
        issuePlace: passportDetails?.placeOfIssue || "",
        passportDocFront: passportDetails?.frontDocument || "",
        passportDocBack: passportDetails?.backDocument || "",
        // Visa Info
        visaNo: visaDetails?.visaNo || "",
        visaExpiry: visaDetails?.expiryDate || null,
        vNationality: visaDetails?.nationalityInfo
          ? {
              label: visaDetails.nationalityInfo.name,
              value: visaDetails.nationalityInfo.publicId,
            }
          : visaDetails?.nationality || null,
        visaIssue: visaDetails?.issueDate || null,
        visaIssuePlace: visaDetails?.placeOfIssue || "",
        visaType: visaDetails?.type
          ? {
              label: visaDetails?.type,
              value: visaDetails?.type,
            }
          : "",
        visaDocFront: visaDetails?.frontDocument || "",
        visaDocBack: visaDetails?.backDocument || "",
        // Contract Info
        contractNo: contractDetails?.contractNo || "",
        contractEnd: contractDetails?.contractEnd || "",
        contractDocFront: contractDetails?.frontDocument || "",
        contractDocBack: contractDetails?.backDocument || "",
        // Driving License
        drivingLicenseNo: drivingLicenseDetails?.drivingLicenseNo || "",
        licenseValidity: drivingLicenseDetails?.drivingLicenseValidity || "",
        drivingLicenseDocFront: drivingLicenseDetails?.frontDocument || "",
        drivingLicenseDocBack: drivingLicenseDetails?.backDocument || "",
        // Subscription Info
        gosiRegNo: subscriptionDetails?.gosiRegNo || "",
        gosiReg: subscriptionDetails?.gosiReg || "",
        gosiDocFront: subscriptionDetails?.gosiFrontDocument || "",
        gosiDocBack: subscriptionDetails?.gosiBackDocument || "",
        mudadRegNo: subscriptionDetails?.mudadRegNo || "",
        mudadReg: subscriptionDetails?.mudadReg || "",
        subscriptionDocFront: subscriptionDetails?.frontDocument || "",
        subscriptionDocBack: subscriptionDetails?.backDocument || "",
        // Members
        isDependents: dependentsInfo?.length > 0 ? "true" : "false",
        members: dependentsInfo
          ? dependentsInfo?.map((dependent) => ({
              publicId: dependent.publicId || null,
              depFirstName: dependent.dependentFirstName || "",
              depSecondName: dependent.dependentSecondName || "",
              depThirdName: dependent.dependentThirdName || "",
              depFourthName: dependent.dependentFourthName || "",
              depIdNumber: dependent.iqamaNo || "",
              idExpiry: dependent.iqamaExpiryDate || null,
              depPassportNo: dependent.passportNo || "",
              depPassportExpiry: dependent.passportExpiryDate || null,
              depContactNo: dependent.contactNo || "",
              depDob: dependent.dateOfBirth || null,
              depGender: dependent.gender || "",
              depCitizen: dependent.citizen || "",
              depNationality: dependent?.nationalityInfo
                ? {
                    label: dependent.nationalityInfo.name,
                    value: dependent.nationalityInfo.publicId,
                  }
                : null,
              depSponsorName: dependent.sponsorName || "",
              depSponsorId: dependent.sponsorId || "",
              depReligion: dependent?.religionInfo
                ? {
                    label: dependent.religionInfo.name,
                    value: dependent.religionInfo.publicId,
                  }
                : null,
              depMaritalStatus: dependent.maritalStatus || "",
              depRelation: dependent?.relation
                ? {
                    label: dependent.relation,
                    value: dependent.relation,
                  }
                : null,
            }))
          : [],
      });
      setEmployeeDocNames({
        nationalDocNames: [
          {
            fileName:
              employeeRegistrationData?.nationalIdInfo
                ?.nationalDocFrontFileName || "",
            fileUrl:
              employeeRegistrationData?.nationalIdInfo?.nationalDocFront || "",
          },
          {
            fileName:
              employeeRegistrationData?.nationalIdInfo
                ?.nationalDocBackFileName || "",
            fileUrl:
              employeeRegistrationData?.nationalIdInfo?.nationalDocBack || "",
          },
        ],
        iqamaDocNames: [
          {
            fileName:
              employeeRegistrationData?.iqamaInfo?.frontDocumentFileName || "",
            fileUrl: employeeRegistrationData?.iqamaInfo?.frontDocument || "",
          },
          {
            fileName:
              employeeRegistrationData?.iqamaInfo?.backDocumentFileName || "",
            fileUrl: employeeRegistrationData?.iqamaInfo?.backDocument || "",
          },
        ],
        accountDocNames: [
          {
            fileName:
              employeeRegistrationData?.bankAccountInfo
                ?.frontDocumentFileName || "",
            fileUrl:
              employeeRegistrationData?.bankAccountInfo?.frontDocument || "",
          },
          {
            fileName:
              employeeRegistrationData?.bankAccountInfo?.backDocumentFileName ||
              "",
            fileUrl:
              employeeRegistrationData?.bankAccountInfo?.backDocument || "",
          },
        ],
        insuranceDocNames: [
          {
            fileName:
              employeeRegistrationData?.healthInfo?.frontDocumentFileName || "",
            fileUrl: employeeRegistrationData?.healthInfo?.frontDocument || "",
          },
          {
            fileName:
              employeeRegistrationData?.healthInfo?.backDocumentFileName || "",
            fileUrl: employeeRegistrationData?.healthInfo?.backDocument || "",
          },
        ],
        healthCardDocNames: [
          {
            fileName:
              employeeRegistrationData?.healthCardInfo?.frontDocumentFileName ||
              "",
            fileUrl:
              employeeRegistrationData?.healthCardInfo?.frontDocument || "",
          },
          {
            fileName:
              employeeRegistrationData?.healthCardInfo?.backDocumentFileName ||
              "",
            fileUrl:
              employeeRegistrationData?.healthCardInfo?.backDocument || "",
          },
        ],
        passportDocNames: [
          {
            fileName:
              employeeRegistrationData?.passportInfo?.frontDocumentFileName ||
              "",
            fileUrl:
              employeeRegistrationData?.passportInfo?.frontDocument || "",
          },
          {
            fileName:
              employeeRegistrationData?.passportInfo?.backDocumentFileName ||
              "",
            fileUrl: employeeRegistrationData?.passportInfo?.backDocument || "",
          },
        ],
        visaDocNames: [
          {
            fileName:
              employeeRegistrationData?.visaInfo?.frontDocumentFileName || "",
            fileUrl: employeeRegistrationData?.visaInfo?.frontDocument || "",
          },
          {
            fileName:
              employeeRegistrationData?.visaInfo?.backDocumentFileName || "",
            fileUrl: employeeRegistrationData?.visaInfo?.backDocument || "",
          },
        ],
        contractDocNames: [
          {
            fileName:
              employeeRegistrationData?.contractInfo?.frontDocumentFileName ||
              "",
            fileUrl:
              employeeRegistrationData?.contractInfo?.frontDocument || "",
          },
          {
            fileName:
              employeeRegistrationData?.contractInfo?.backDocumentFileName ||
              "",
            fileUrl: employeeRegistrationData?.contractInfo?.backDocument || "",
          },
        ],
        drivingLicenseDocNames: [
          {
            fileName:
              employeeRegistrationData?.drivingInfo?.frontDocumentFileName ||
              "",
            fileUrl: employeeRegistrationData?.drivingInfo?.frontDocument || "",
          },
          {
            fileName:
              employeeRegistrationData?.drivingInfo?.backDocumentFileName || "",
            fileUrl: employeeRegistrationData?.drivingInfo?.backDocument || "",
          },
        ],
        gosiDocNames: [
          {
            fileName:
              employeeRegistrationData?.subscriptionInfo
                ?.gosiFrontDocumentFileName || "",
            fileUrl:
              employeeRegistrationData?.subscriptionInfo?.gosiFrontDocument ||
              "",
          },
          {
            fileName:
              employeeRegistrationData?.subscriptionInfo
                ?.gosiBackDocumentFileName || "",
            fileUrl:
              employeeRegistrationData?.subscriptionInfo?.gosiBackDocument ||
              "",
          },
        ],
        subscriptionDocNames: [
          {
            fileName:
              employeeRegistrationData?.subscriptionInfo
                ?.frontDocumentFileName || "",
            fileUrl:
              employeeRegistrationData?.subscriptionInfo?.frontDocument || "",
          },
          {
            fileName:
              employeeRegistrationData?.subscriptionInfo
                ?.backDocumentFileName || "",
            fileUrl:
              employeeRegistrationData?.subscriptionInfo?.backDocument || "",
          },
        ],
      });
      setActiveMemberIndex(dependentsInfo?.length - 1);
    }
  }, [employeeRegistrationData]);

  console.log("formValues: ", formValues);

  useEffect(() => {
    setDocsTabs([
      "Salary Details",
      "Iqama",
      "National ID",
      "Account",
      "Health Insurance",
      "Health Card",
      "Passport",
      "Visa",
      "Contract",
      "Driving License",
      "Subscription",
    ]);
  }, []);

  useEffect(() => {
    setDetailsStep(1);
  }, [isOpen]);

  useEffect(() => {
    getReligionOptions();
    // getCountryOptions();
    // getStateOptions();
    getNationalityOptions();
    getRoleOptions();
    getJobTitleOptions();
    getDepartmentOptions();
    getDesignationOptions();
    // getEmployeesOptions();
    getJobGradeOptions();
    getContractTypeOptions();
    // getProbationPeriodOptions();
    getEmployementTypeOptions();
    getReportingToOptions();
    getVisaTypeOptions();
    getBranchOptions();
    // getIqamaProfessionOptions();
    getBankOptions();
    // getInsuranceClassOptions();
    // getRelationOptions();
    // getReligionOptions();
    getDepRelationOptions();
  }, []);

  const VALIDATION_STEPS = {
    STEP_1: "Step 1", // For phone, email, nationalId
    SALARY_DETAILS: "Salary Details",
    IQAMA: "Iqama",
    NATIONAL_ID: "National ID",
    ACCOUNT: "Account",
    HEALTH_INSURANCE: "Health Insurance",
    HEALTH_CARD: "Health Card",
    PASSPORT: "Passport",
    VISA: "Visa",
    CONTRACT: "Contract",
    DRIVING_LICENSE: "Driving License",
    SUBSCRIPTION: "Subscription",
  };

  const personalEmailSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeePersonalInfo, // or whatever your endpoint is
    columnName: "personalEmail",
    statusField: "status",
    checkUser: false,
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.STEP_1,
  });

  const emailSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeePersonalInfo, // or whatever your endpoint is
    columnName: "email",
    statusField: "status",
    checkUser: false,
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.STEP_1,
  });

  const nationalIdSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeePersonalInfo,
    columnName: "nationalId",
    statusField: "status",
    checkUser: false,
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.STEP_1,
  });

  const phoneSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeePersonalInfo,
    columnName: "phone",
    statusField: "status",
    checkUser: false,
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.STEP_1,
  });

  // Debounced search hooks for each field
  const iqamaIdSearch = useDebounceSearch({
    endpoint: apiServices.iqamaDocMaster,
    columnName: "iqamaId",
    statusField: "status",
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.IQAMA, // Iqama step
  });

  const ibanNoSearch = useDebounceSearch({
    endpoint: apiServices.bankInfo,
    columnName: "ibanNo",
    statusField: "status",
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.ACCOUNT, // Account step
  });

  const insuranceNoSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeeHealthInsuranceDetails,
    columnName: "insuranceNo",
    statusField: "status",
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.HEALTH_INSURANCE, // Health Insurance step
  });

  const healthCardNoSearch = useDebounceSearch({
    endpoint: apiServices.healthCardInfo,
    columnName: "healthCardNo",
    statusField: "status",
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.HEALTH_CARD, // Health Card step
  });

  const visaNoSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeeVisaDetails,
    columnName: "visaNo",
    statusField: "status",
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.VISA, // Visa step
  });

  const passportNoSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeePassportDetails,
    columnName: "passportNo",
    statusField: "status",
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.PASSPORT, // Passport step
  });

  const contractNoSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeeContractDetails,
    columnName: "contractNo",
    statusField: "status",
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.CONTRACT, // Contract step
  });

  const drivingLicenseNoSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeeDrivingLicenseDetails,
    columnName: "drivingLicenseNo",
    statusField: "status",
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.DRIVING_LICENSE, // Driving License step
  });

  const gosiRegNoSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeeSubscriptionDetails,
    columnName: "gosiRegNo",
    statusField: "status",
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.SUBSCRIPTION, // Subscription step
  });

  const mudadRegNoSearch = useDebounceSearch({
    endpoint: apiServices.getEmployeeSubscriptionDetails,
    columnName: "mudadRegNo",
    statusField: "status",
    userId: empPublicId,
    validationStep: VALIDATION_STEPS.SUBSCRIPTION, // Subscription step
  });

  const aggregatedValidation = useAggregatedValidation({
    validationStates: [
      personalEmailSearch,
      emailSearch,
      nationalIdSearch,
      phoneSearch,
      iqamaIdSearch,
      ibanNoSearch,
      insuranceNoSearch,
      healthCardNoSearch,
      visaNoSearch,
      passportNoSearch,
      contractNoSearch,
      drivingLicenseNoSearch,
      gosiRegNoSearch,
      mudadRegNoSearch,
    ],
  });

  const {
    checkCurrentStepValidation,
    getCurrentStepErrors,
    isCurrentStepSearching,
    checkMultipleStepsValidation,
    getValidationSummary,
  } = useMultiStepValidation(aggregatedValidation);

  // Enhanced validation checking
  const hasValidationErrorInCurrentStep = useMemo(() => {
    return (
      checkCurrentStepValidation(detailsStep) ||
      checkCurrentStepValidation(documentTab)
    );
  }, [detailsStep, documentTab, checkCurrentStepValidation]);

  if (aggregatedValidation.shouldDisableStep("Step 1")) {
  }

  // Email field handlers

  // Email change handler with debug logs
  const handlePersonalEmailChange = (e, setFieldValue) => {
    const value = e.target.value;

    setFieldValue("personalEmail", value);

    if (value.trim()) {
      personalEmailSearch.debouncedSearch(value);
    } else {
      personalEmailSearch.clearValidation();
    }
  };

  const handleEmailChange = (e, setFieldValue) => {
    const value = e.target.value;

    setFieldValue("email", value);

    if (value.trim()) {
      emailSearch.debouncedSearch(value);
    } else {
      emailSearch.clearValidation();
    }
  };

  // National ID field handlers
  const handleNationalIdChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("nationalId", value);

    if (value.trim()) {
      nationalIdSearch.debouncedSearch(value);
    } else {
      nationalIdSearch.clearValidation();
    }
  };

  // Phone field handlers
  const handlePhoneChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("phone", value);

    if (value.trim()) {
      phoneSearch.debouncedSearch(value);
    } else {
      phoneSearch.clearValidation();
    }
  };

  // Handler functions for each field
  const handleIqamaIdChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("iqamaId", value);

    if (value.trim()) {
      iqamaIdSearch.debouncedSearch(value);
    } else {
      iqamaIdSearch.clearValidation();
    }
  };

  const handleIbanNoChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("ibanNo", value);

    if (value.trim()) {
      ibanNoSearch.debouncedSearch(value);
    } else {
      ibanNoSearch.clearValidation();
    }
  };

  const handleInsuranceNoChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("insuranceNo", value);

    if (value.trim()) {
      insuranceNoSearch.debouncedSearch(value);
    } else {
      insuranceNoSearch.clearValidation();
    }
  };

  const handleHealthCardNoChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("healthCardNo", value);

    if (value.trim()) {
      healthCardNoSearch.debouncedSearch(value);
    } else {
      healthCardNoSearch.clearValidation();
    }
  };

  const handleVisaNoChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("visaNo", value);

    if (value.trim()) {
      visaNoSearch.debouncedSearch(value);
    } else {
      visaNoSearch.clearValidation();
    }
  };

  const handlePassportNoChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("passportNo", value);

    if (value.trim()) {
      passportNoSearch.debouncedSearch(value);
    } else {
      passportNoSearch.clearValidation();
    }
  };

  const handleContractNoChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("contractNo", value);

    if (value.trim()) {
      contractNoSearch.debouncedSearch(value);
    } else {
      contractNoSearch.clearValidation();
    }
  };

  const handleDrivingLicenseNoChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("drivingLicenseNo", value);

    if (value.trim()) {
      drivingLicenseNoSearch.debouncedSearch(value);
    } else {
      drivingLicenseNoSearch.clearValidation();
    }
  };

  const handleGosiRegNoChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("gosiRegNo", value);

    if (value.trim()) {
      gosiRegNoSearch.debouncedSearch(value);
    } else {
      gosiRegNoSearch.clearValidation();
    }
  };

  const handleMudadRegNoChange = (e, setFieldValue) => {
    const value = e.target.value;
    setFieldValue("mudadRegNo", value);

    if (value.trim()) {
      mudadRegNoSearch.debouncedSearch(value);
    } else {
      mudadRegNoSearch.clearValidation();
    }
  };

  const shouldHideButtons = useMemo(() => {
    const restrictedTabs = [
      "Salary Details",
      "Iqama",
      "Account",
      "Health Insurance",
      "Health Card",
      "Visa",
      "Contract",
      "Subscription",
    ];
    return (
      (detailsStep === 2 && currentEmployeeEditing) ||
      (detailsStep === 3 &&
        restrictedTabs.includes(documentTab) &&
        currentEmployeeEditing)
    );
  }, [detailsStep, currentEmployeeEditing, documentTab]);

  const handleSetTotalSalary = (totalSalary) => {
    setTotalSalary(totalSalary);
  };

  const getEmployeeRegistrationData = async (latestPublicId) => {
    let publicId;
    setDataLoading(true);
    if (latestPublicId) {
      publicId = latestPublicId;
    } else if (empPublicId) {
      publicId = empPublicId;
    }
    try {
      const response = await fetchEmployeeRegistrationDataById(publicId);
      if (response?.data) {
        const completeData = response?.data?.data;
        setLatestPublicId(completeData?.personalInfo?.publicId);
        setLatestConcurrencyStamp(completeData?.personalInfo?.concurrencyStamp);
        setEmployeeRegistrationData(completeData);
        setPersonalInfo(completeData?.personalInfo);
        setDraftedData(completeData?.personalInfo);
        setEmploymentInfo(completeData?.employementInfo);
        setNationalDetails(completeData?.nationalIdInfo);
        setSalaryDetails(completeData?.salaryInfo);
        setIqamaDetails(completeData?.iqamaInfo);
        setAccountDetails(completeData?.bankAccountInfo);
        setHealthInsuranceDetails(completeData?.healthInfo);
        setHealthCardDetails(completeData?.healthCardInfo);
        setPassportDetails(completeData?.passportInfo);
        setVisaDetails(completeData?.visaInfo);
        setContractDetails(completeData?.contractInfo);
        setDrivingLicenseDetails(completeData?.drivingInfo);
        setSubscriptionDetails(completeData?.subscriptionInfo);
        setDependentsInfo(completeData?.dependentInfo || []);
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    } finally {
      setDataLoading(false);
    }
  };

  const getReligionOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      pageSize: "20",
      filters: mergedFilters,
    };

    try {
      const response = await getReligionMaster(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = response?.data?.data?.doc?.map((religion) => ({
          label: religion.name,
          value: religion.publicId,
        }));

        !search && setReligionOptions(options);
        return options;
      } else {
        setReligionOptions([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchReligionDebounce = (inputValue, callback) => {
    deBounce(() => onSearchdReligion(inputValue, callback), 1000);
  };

  const onSearchdReligion = async (inputValue, callback) => {
    if (!inputValue) {
      callback(religionOptions);
      return;
    }

    let filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    let options = await getReligionOptions(filter, true);
    callback(options);
  };

  const getCountryOptions = async () => {
    try {
      const response = await getCountryMaster({});
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    }
  };

  const getStateOptions = async () => {
    try {
      const response = await getStateMaster({});
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    }
  };

  const getNationalityOptions = async () => {
    try {
      const response = await getCountryMaster({});
      if (response?.data && response.data?.data?.doc?.length >= 0) {
        setCountryOptions(
          response.data?.data?.doc?.map((country) => ({
            label: country.name,
            value: country.publicId,
          }))
        );
      } else {
        setCountryOptions([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    }
  };

  const onSearchDepartmentDebounce = (inputValue, callback) => {
    deBounce(() => onSearchDepartment(inputValue, callback), 1000);
  };

  const onSearchDepartment = async (inputValue, callback) => {
    if (!inputValue) {
      callback(departmentOptions);
      return;
    }

    let filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    let options = await getDepartmentOptions(filter, true);
    callback(options);
  };

  const getDepartmentOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      pageSize: "20",
      filters: mergedFilters,
    };

    try {
      const response = await getDepartmentMaster(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = response?.data?.data?.doc?.map((department) => ({
          label: department.name,
          value: department.publicId,
        }));
        !search && setDepartmentOptions(options);
        return options;
      } else {
        setDepartmentOptions([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const getRoleOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      pageSize: "20",
      filters: mergedFilters,
    };
    try {
      const response = await getRolesMaster(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = response?.data?.data?.doc?.map((role) => ({
          label: role?.role,
          value: role?.publicId,
        }));
        !search && setRoleOptions(options);
        return options;
      } else {
        setRoleOptions([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchRoleDebounce = (inputValue, callback) => {
    deBounce(() => onSearchRole(inputValue, callback), 1000);
  };

  const onSearchRole = async (inputValue, callback) => {
    if (!inputValue) {
      callback(roleOptions);
      return;
    }

    let filter = [
      {
        key: "role",
        iLike: inputValue,
      },
    ];
    let options = await getRoleOptions(filter, true);
    callback(options);
  };

  const getJobTitleOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      pageSize: "20",
      filters: mergedFilters,
    };

    try {
      const response = await getJobTitleData(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = response?.data?.data?.doc?.map((jobTitle) => ({
          label: jobTitle.name,
          value: jobTitle.publicId,
        }));
        !search && setJobTitleOptions(options);
        return options;
      } else {
        setJobTitleOptions([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchJobTitleDebounce = (inputValue, callback) => {
    deBounce(() => onSearchJobTitle(inputValue, callback), 1000);
  };

  const onSearchJobTitle = async (inputValue, callback) => {
    if (!inputValue) {
      callback(jobTitleOptions);
      return;
    }

    let filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    let options = await getJobTitleOptions(filter, true);
    callback(options);
  };

  const load = (inputValue, callback) => {
    if (!inputValue) {
      callback(designationOptions);
    } else {
      const filteredOptions = branchOptions.filter((option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    }
  };

  const getBranchOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      pageSize: "20",
      filters: mergedFilters,
    };

    try {
      const response = await getBranchMaster(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = response?.data?.data?.doc?.map((branch) => ({
          label: branch.name,
          value: branch.publicId,
        }));
        !search && setBranchOptions(options);
        return options;
      } else {
        setBranchOptions([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchBranchDebounce = (inputValue, callback) => {
    deBounce(() => onSearchdBranch(inputValue, callback), 1000);
  };

  const onSearchdBranch = async (inputValue, callback) => {
    if (!inputValue) {
      callback(branchOptions);
      return;
    }

    let filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    let options = await getBranchOptions(filter, true);
    callback(options);
  };

  const onSearchDesignationDebounce = (inputValue, callback) => {
    deBounce(() => onSearchdDesignation(inputValue, callback), 1000);
  };

  const onSearchdDesignation = async (inputValue, callback) => {
    if (!inputValue) {
      callback(designationOptions);
      return;
    }

    let filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    let options = await getDesignationOptions(filter, true);
    callback(options);
  };

  const getDesignationOptions = async (filters, search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      pageSize: "20",
      filters: mergedFilters,
    };

    try {
      const response = await getDesignationMaster(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options =
          response?.data?.data?.doc?.map((designation) => ({
            label: designation.name,
            value: designation.publicId,
          })) || [];
        !search && setDesignationOptions(options);
        return options;
      } else {
        setDesignationOptions([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchReportingToDebounce = (inputValue, callback) => {
    deBounce(() => onSearchReportingTo(inputValue, callback), 1000);
  };

  const onSearchReportingTo = async (inputValue, callback) => {
    if (!inputValue) {
      callback(reportingTo);
      return;
    }

    let filter = [
      {
        key: "username",
        iLike: inputValue,
      },
    ];
    let options = await getReportingToOptions(filter, true);
    callback(options);
  };

  // Fetching reportingTo options from API
  const getReportingToOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      { key: "type", in: ["user", "master", "admin"] },
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      pageSize: "20",
      filters: mergedFilters,
    };

    try {
      const response = await getEmployeesMasterData(details); // Replace with actual API function
      if (response?.data?.data?.doc?.length >= 0) {
        const options = response?.data?.data?.doc?.length
          ? response.data.data.doc.map((manager) => ({
              label:
                `${manager?.firstName || ""} ${manager?.lastName || ""}${
                  manager?.email ? ` (${manager.email})` : ""
                }`.trim() ||
                manager?.email ||
                "-",
              value: manager?.publicId || "",
            }))
          : [];

        !search && setReportingTo(options);
        return options;
      } else {
        setReportingTo([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };
  const getJobGradeOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      pageSize: "20",
      filters: mergedFilters,
    };
    try {
      const response = await getJobGradeData(details);
      if (response?.data?.data?.doc?.length >= 0) {
        const options = response?.data?.data?.doc?.map((jobGrade) => ({
          label: jobGrade.name,
          value: jobGrade.publicId,
        }));
        !search && setJobGradeOptions(options);
        return options;
      } else {
        setJobGradeOptions([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const onSearchJobGradeDebounce = (inputValue, callback) => {
    deBounce(() => onSearchJobGrade(inputValue, callback), 1000);
  };

  const onSearchJobGrade = async (inputValue, callback) => {
    if (!inputValue) {
      callback(jobGradeOptions);
      return;
    }

    let filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    let options = await getJobGradeOptions(filter, true);
    callback(options);
  };

  const loadContractTypeOptions = (inputValue, callback) => {
    const filteredOptions = contractType.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    callback(inputValue ? filteredOptions : contractType);
  };

  const getContractTypeOptions = async () => {
    const dummyContractTypes = [
      { label: "Limited", value: "Limited" },
      { label: "Unlimited", value: "Unlimited" },
    ];
    setContractType(dummyContractTypes);
    // try {
    //   const response = await getContractTypeMaster();
    //   console.log("Contract Type options: ", response);
    //   if (response?.data?.data?.doc?.length >= 0) {
    //     setContractType(
    //       response?.data?.data?.doc?.map((type) => ({
    //         label: type.name,
    //         value: type.publicId,
    //       }))
    //     );
    //   } else {
    //     setContractType([{ label: "Data not loaded", value: "" }]);
    //   }
    // } catch (error) {
    //   console.error(error);
    //   setContractType([{ label: "Data not loaded", value: "" }]);
    // }
  };

  const loadProbationPeriodOptions = (inputValue, callback) => {
    const filteredOptions = probationPeriod.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    callback(inputValue ? filteredOptions : probationPeriod);
  };

  const getProbationPeriodOptions = async () => {
    try {
      const response = await getProbationPeriodMaster();
      if (response?.data?.data?.doc?.length >= 0) {
        setProbationPeriod(
          response?.data?.data?.doc?.map((period) => ({
            label: period.name,
            value: period.publicId,
          }))
        );
      } else {
        setProbationPeriod([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    }
  };

  const loadEmploymentTypeOptions = (inputValue, callback) => {
    const filteredOptions = employmentType.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    callback(inputValue ? filteredOptions : employmentType);
  };

  const getEmployementTypeOptions = async () => {
    const dummyEmploymentTypes = [
      { label: "Full Time", value: "Full Time" },
      { label: "Part Time", value: "Part Time" },
      { label: "Distance", value: "Distance" },
    ];
    setEmploymentType(dummyEmploymentTypes);

    // try {
    //   const response = await getEmployementTypeMaster();
    //   console.log("Employment Type options: ", response);
    //   if (response?.data?.data?.doc?.length >= 0) {
    //     setEmploymentType(
    //       response?.data?.data?.doc?.map((type) => ({
    //         label: type.name,
    //         value: type.publicId,
    //       }))
    //     );
    //   } else {
    //     setEmploymentType([{ label: "Data not loaded", value: "" }]);
    //   }
    // } catch (error) {
    //   console.error(error);
    //   setEmploymentType([{ label: "Data not loaded", value: "" }]);
    // }
  };

  const getIqamaProfessionOptions = async () => {
    try {
      const response = await getIqamaProfessionMaster({});
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    }
  };

  const onSearchBankDebounce = (inputValue, callback) => {
    deBounce(() => onSearchBank(inputValue, callback), 1000);
  };

  const onSearchBank = async (inputValue, callback) => {
    if (!inputValue) {
      callback(bank);
      return;
    }

    let filter = [
      {
        key: "name",
        iLike: inputValue,
      },
    ];
    let options = await getBankOptions(filter, true);
    callback(options);
  };

  const getBankOptions = async (filters = [], search) => {
    const mergedFilters = [
      activeFilter,
      ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
    ];

    const details = {
      pageSize: "20",
      filters: mergedFilters,
    };

    try {
      const response = await getBankMaster(details);

      if (response?.data?.data?.doc?.length >= 0) {
        const options = response?.data?.data?.doc?.map((bank) => ({
          label: bank.name,
          value: bank.publicId,
        }));
        !search && setBank(options);
        return options;
      } else {
        setBank([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const loadVisaTypeOptions = (inputValue, callback) => {
    const filteredOptions = visaType.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    callback(inputValue ? filteredOptions : visaType);
  };

  // Fetching visaType options
  const getVisaTypeOptions = async () => {
    setVisaType([
      { value: "business", label: "Business Visa" },
      { value: "iqama visa", label: "Iqama Visa" },
      { value: "student", label: "Student Visa" },
      { value: "work", label: "Work Visa" },
      { value: "transit", label: "Transit Visa" },
      { value: "diplomatic", label: "Diplomatic Visa" },
      { value: "medical", label: "Medical Visa" },
    ]);
    try {
      const response = await getVisaTypeMaster(); // Replace with actual API function

      if (response?.data?.data?.doc?.length >= 0) {
        // setVisaType(
        //   response?.data?.data?.doc?.map((type) => ({
        //     label: type.name,
        //     value: type.publicId,
        //   }))
        // );
        setVisaType([
          { value: "business", label: "Business Visa" },
          { value: "iqama visa", label: "Iqama Visa" },
          { value: "student", label: "Student Visa" },
          { value: "work", label: "Work Visa" },
          { value: "transit", label: "Transit Visa" },
          { value: "diplomatic", label: "Diplomatic Visa" },
          { value: "medical", label: "Medical Visa" },
        ]);
      } else {
        setVisaType([{ label: "Data not loaded", value: "" }]);
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    }
  };

  const getInsuranceClassOptions = async () => {
    try {
      const response = await getInsuranceClassMaster({});
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    }
  };

  const loadDepRelationOptions = (inputValue, callback) => {
    const filteredOptions = depRelationOptions.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    callback(inputValue ? filteredOptions : depRelationOptions);
  };

  const getDepRelationOptions = async () => {
    const dummyRelations = [
      { label: "Father", value: "Father" },
      { label: "Mother", value: "Mother" },
      { label: "Brother", value: "Brother" },
      { label: "Sister", value: "Sister" },
      { label: "Son", value: "Son" },
      { label: "Daughter", value: "Daughter" },
      { label: "Husband", value: "Husband" },
      { label: "Wife", value: "Wife" },
      { label: "Uncle", value: "Uncle" },
      { label: "Aunt", value: "Aunt" },
      { label: "Nephew", value: "Nephew" },
      { label: "Niece", value: "Niece" },
      { label: "Cousin", value: "Cousin" },
      { label: "Grandfather", value: "Grandfather" },
      { label: "Grandmother", value: "Grandmother" },
      { label: "Grandson", value: "Grandson" },
      { label: "Granddaughter", value: "Granddaughter" },
    ];

    setDepRelationOptions(dummyRelations);

    // try {
    //   const response = await getRelationMaster(); // Replace with actual API function
    //   console.log("Dependent Relation options: ", response);
    //   if (response?.data?.data?.doc?.length >= 0) {
    //     setDepRelationOptions(
    //       response?.data?.data?.doc?.map((relation) => ({
    //         label: relation.name,
    //         value: relation.publicId,
    //       }))
    //     );
    //   } else {
    //     setDepRelationOptions([{ label: "Data not loaded", value: "" }]);
    //   }
    // } catch (error) {
    //   console.error(error);
    //   setDepRelationOptions([{ label: "Data not loaded", value: "" }]);
    // }
  };

  function handleOpenFileInput() {
    fileInputRef1?.current?.click();
  }

  function handleOpenFileInputGosi() {
    fileInputRef1Gosi?.current?.click();
  }

  function handleOpenFileInput2() {
    fileInputRef2?.current?.click();
  }

  function handleOpenFileInput2Gosi() {
    fileInputRef2Gosi?.current?.click();
  }

  function handleClickAddMember() {
    addMemberRef?.current?.click();
  }

  function onDocModal() {
    setDocModal(true);
  }

  function onDocModalGosi() {
    setDocModalGosi(true);
  }

  function closeDocModal(setFieldValue) {
    setDocModal(false);
    // setFieldValue("iqamaDocFront", ""); // Clear specific field
    // setFieldValue("iqamaDocBack", ""); // Clear specific field
  }

  function closeDocModalAccount(setFieldValue) {
    setDocModal(false);
    // setFieldValue("accountFront", ""); // Clear specific field
    // setFieldValue("accountBack", ""); // Clear specific field
  }

  function closeDocModalInsurance(setFieldValue) {
    setDocModal(false);
    // setFieldValue("insuranceDocFront", ""); // Clear specific field
    // setFieldValue("insuranceDocBack", ""); // Clear specific field
  }

  function closeDocModalHealthCard(setFieldValue) {
    setDocModal(false);
    // setFieldValue("insuranceDocFront", ""); // Clear specific field
    // setFieldValue("insuranceDocBack", ""); // Clear specific field
  }

  function closeDocModalPassport(setFieldValue) {
    setDocModal(false);
    // setFieldValue("passportDocFront", ""); // Clear specific field
    // setFieldValue("passportDocBack", ""); // Clear specific field
  }

  function closeDocModalVisa(setFieldValue) {
    setDocModal(false);
    // setFieldValue("visaDocFront", ""); // Clear specific field
    // setFieldValue("visaDocBack", ""); // Clear specific field
  }

  function closeDocModalContract(setFieldValue) {
    setDocModal(false);
    // setFieldValue("contractDocFront", ""); // Clear specific field
    // setFieldValue("contractDocBack", ""); // Clear specific field
  }

  function closeDocModalLicense(setFieldValue) {
    setDocModal(false);
    // setFieldValue("drivingLicenseDocFront", ""); // Clear specific field
    // setFieldValue("drivingLicenseDocBack", ""); // Clear specific field
  }

  function closeDocModalSubscription(setFieldValue) {
    setDocModal(false);
    // setFieldValue("subscriptionDocFront", ""); // Clear specific field
    // setFieldValue("subscriptionDocBack", ""); // Clear specific field
  }

  function closeDocModalGosi(setFieldValue) {
    setDocModalGosi(false);
    // setFieldValue("subscriptionDocFront", ""); // Clear specific field
    // setFieldValue("subscriptionDocBack", ""); // Clear specific field
  }

  const handleRemoveDocument = (fieldName, docPosition, setFieldValue) => {
    try {
      // Update the form field (e.g., set nationalDocBack to null)
      setFieldValue(fieldName, null);

      // Update the employeeDocNames state
      setEmployeeDocNames((prev) => {
        const updatedDocNames = { ...prev };

        // Find the document type and state key based on the fieldName
        const docTypeKey = Object.keys(docConfig).find((key) =>
          docConfig[key].includes(fieldName)
        );

        if (!docTypeKey) {
          throw new Error(`Document type not found for field "${fieldName}".`);
        }

        // Get the state key for the document type from the mapping
        const stateKey = docTypeToStateKey[docTypeKey];
        if (!stateKey) {
          throw new Error(
            `State key not found for document type "${docTypeKey}".`
          );
        }

        // Determine the index to update based on the docPosition (front or back)
        const docIndex = docPosition === "front" ? 0 : 1;

        // Set the corresponding file metadata to empty
        updatedDocNames[stateKey][docIndex] = { fileName: "", fileUrl: "" };

        return updatedDocNames;
      });

      toast.success("Document Removed Successfully", {
        position: "top-left",
        style: { zIndex: 10001 },
      });
    } catch (error) {
      notifyWarn(error?.message || "An unexpected error occurred");
      console.error("Error", error);
    }
  };

  const handleSubmitDocument = async (values, docType, gosiDoc = false) => {
    setDocUploadLoading(true);
    try {
      // Get the file fields for the document type from the configuration
      const fileFields = docConfig[docType];
      if (!fileFields) {
        throw new Error(`Document type "${docType}" is not configured.`);
      }

      // Filter out files that are instances of File
      const filesToUpload = fileFields
        .map((field) => values[field])
        .filter((file) => file instanceof File);

      // Check if there are any files to upload
      if (filesToUpload.length === 0) {
        throw new Error("No new files to upload");
      }

      // Upload the files
      const response = await fileUpload(filesToUpload);

      if (response?.data) {
        // Extract file metadata (fileName and fileUrl) from the response
        const fileMetadata = response.data?.data?.map((fileData) => ({
          fileName: fileData.fileName,
          fileUrl: fileData.fileUrl,
        }));

        // Update the state with the file metadata
        setEmployeeDocNames((prev) => {
          const updatedDocNames = { ...prev };

          // Get the state key for the document type from the mapping
          const stateKey = docTypeToStateKey[docType];
          if (!stateKey) {
            throw new Error(
              `State key not found for document type "${docType}".`
            );
          }

          // Ensure the state key exists in the updatedDocNames object
          if (!updatedDocNames[stateKey]) {
            updatedDocNames[stateKey] = [];
          }

          // Track the index of the fileMetadata array
          let fileMetadataIndex = 0;

          // Update the file metadata for the document type
          fileFields.forEach((field, index) => {
            if (values[field] instanceof File) {
              // Assign the file metadata to the correct index
              updatedDocNames[stateKey][index] = fileMetadata[
                fileMetadataIndex
              ] || { fileName: "", fileUrl: "" };
              fileMetadataIndex++; // Move to the next file metadata
            }
          });

          return updatedDocNames;
        });

        toast.success(t("Documents Submitted Successfully"), {
          position: "top-left",
          style: { zIndex: 10001 },
        });

        if (gosiDoc) {
          setDocModalGosi(false);
        } else {
          setDocModal(false);
        }
      } else {
        throw new Error("Failed to submit documents");
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    } finally {
      setDocUploadLoading(false);
    }
  };

  const isAtLeast18 = (gregorianDateStr) => {
    const birthDate = moment(gregorianDateStr, "YYYY-MM-DD");
    const age = moment().diff(birthDate, "years");
    return age >= 18;
  };

  const today = new Date();

  const nameRegexRequired = /^[A-Za-z\s'.-]+$/; // required fields
  const nameRegexOptional = /^[A-Za-z\s'.-]*$/; // optional fields

  const getValidationSchema = (step) => {
    switch (step) {
      case 1:
        return Yup.object({
          firstName: Yup.string()
            .required("First name is required")
            .matches(
              nameRegexRequired,
              "Only English letters, spaces, apostrophes (’), dashes (-), and periods (.) are allowed."
            )
            .max(30, "First name must not exceed 30 characters"),

          firstNameArb: Yup.string()
            .required("First name is required")
            .matches(
              /^[\u0600-\u06FF\s]*$/,
              "First name in Arabic must contain only Arabic letters and no numbers or special characters"
            )
            .max(30, "First name in Arabic must not exceed 30 characters"),

          secondName: Yup.string()
            .matches(
              nameRegexOptional,
              "Only English letters, spaces, apostrophes (’), dashes (-), and periods (.) are allowed."
            )
            .max(30, "Second name must not exceed 30 characters"),

          secondNameArb: Yup.string()
            .matches(
              /^[\u0600-\u06FF\s]*$/,
              "Second name in Arabic must contain only Arabic letters and no numbers or special characters"
            )
            .max(30, "Second name in Arabic must not exceed 30 characters"),

          thirdName: Yup.string()
            .matches(
              nameRegexOptional,
              "Only English letters, spaces, apostrophes (’), dashes (-), and periods (.) are allowed."
            )
            .max(30, "Third name must not exceed 30 characters"),

          thirdNameArb: Yup.string()
            .matches(
              /^[\u0600-\u06FF\s]*$/,
              "Third name in Arabic must contain only Arabic letters and no numbers or special characters"
            )
            .max(30, "Third name in Arabic must not exceed 30 characters"),

          lastName: Yup.string()
            .required("Last name is required")
            .matches(
              nameRegexOptional,
              "Only English letters, spaces, apostrophes (’), dashes (-), and periods (.) are allowed."
            )
            .max(30, "Last name must not exceed 30 characters"),

          lastNameArb: Yup.string()
            .required("Last name is required")
            .matches(
              /^[\u0600-\u06FF\s]*$/,
              "Last name in Arabic must contain only Arabic letters and no numbers or special characters"
            )
            .max(30, "Last name in Arabic must not exceed 30 characters"),

          phone: Yup.string()
            .required("Phone number is required")
            .transform((value) => {
              // Convert Arabic numerals to Western numerals
              if (value) {
                return value.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
              }
              return value;
            })
            .matches(
              /^(00966|966|\+966|0)?5\d{8}$/,
              "Enter a valid Saudi mobile number"
            ),
          personalEmail: Yup.string()
            .email("Invalid email address")
            .required("Personal Email is required"),
          email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),

          dobHijri: Yup.string()
            .required("Date of birth is required")
            .test(
              "is-18-hijri",
              "User must be at least 18 years old",
              function (value) {
                if (!value) return false;

                let hijriDate;

                // Handle ISO-like format from backend: "1420-09-24T00:00:00.000Z"
                if (value.includes("T")) {
                  const datePart = value.split("T")[0]; // "1420-09-24"
                  const [y, m, d] = datePart.split("-").map(Number);
                  hijriDate = { day: d, month: m, year: y };
                } else {
                  // Handle "24-09-1420" (DD-MM-YYYY)
                  const [d, m, y] = value.split("-").map(Number);
                  hijriDate = { day: d, month: m, year: y };
                }

                if (
                  !hijriDate.day ||
                  !hijriDate.month ||
                  !hijriDate.year ||
                  hijriDate.month > 12 ||
                  hijriDate.day > 30
                ) {
                  return false;
                }

                const gregorian = toGregorian(
                  hijriDate.year,
                  hijriDate.month,
                  hijriDate.day
                );
                const gregorianDateStr = `${gregorian.gy}-${String(
                  gregorian.gm
                ).padStart(2, "0")}-${String(gregorian.gd).padStart(2, "0")}`;

                return isAtLeast18(gregorianDateStr);
              }
            ),

          dobGregorian: Yup.string()
            .required("Date of birth is required")
            .test(
              "is-18-gregorian",
              "User must be at least 18 years old",
              function (value) {
                if (!value) return false;

                let formattedValue = value;

                // Handle ISO-like string from backend
                if (value.includes("T")) {
                  formattedValue = value.split("T")[0]; // Get "YYYY-MM-DD"
                }

                return isAtLeast18(formattedValue);
              }
            ),

          religion: Yup.object().required("Religion is required"),
          maritalStatus: Yup.string().required("Marital status is required"),
          gender: Yup.string().required("Gender is required"),
          citizen: Yup.string().required("Citizen status is required"),
          nationality: Yup.object().when("citizen", {
            is: (value) => value === "false", // Ensure this matches your form data type
            then: (schema) => schema.required("Nationality is required"),
            otherwise: (schema) => schema.notRequired(),
          }),
          nationalId: Yup.string().when("citizen", {
            is: "true",
            then: (schema) =>
              schema
                .required("National ID is required")
                .trim()
                .matches(
                  /^[0-9]{10}$/,
                  "National ID must be exactly 10 digits"
                ),
            otherwise: (schema) => schema.notRequired(),
          }),
          profilePicture: Yup.object()
            .shape({
              fileName: Yup.string(),
              fileUrl: Yup.string(),
            })
            .notRequired(),
        });
      case 2:
        return Yup.object({
          branch: Yup.object().required("Branch is required"),
          role: Yup.object().required("Role is required"),
          jobTitle: Yup.object().required("Job Title is required"),
          designation: Yup.object().required("Designation is required"),
          department: Yup.object().required("Department is required"),
          reportingTo: Yup.object().required("Reporting To is required"),
          joiningDate: Yup.date()
            .required("Joining Date is required")
            .typeError("Invalid date format"),
          jobGrade: Yup.object().required("Job Grade is required"),
          contractType: Yup.object().required("Contract Type is required"),
          probationPeriod: Yup.string().required(
            "Probation Period is required"
          ),
          employmentType: Yup.object().required("Employment Type is required"),
        });
      case 3:
        const schemas = {
          "Salary Details": Yup.object({
            basicPay: Yup.number()
              .typeError("Basic Pay must be a valid number")
              .required("Basic Pay is required")
              .min(0, "Basic Pay cannot be negative") // Allow 0 and positive numbers
              .max(9999999999, "Basic Pay is too large"),

            housingAllows: Yup.number()
              .typeError("Housing Allowance must be a valid number")
              .required("Housing Allowance is required")
              .min(0, "Housing Allowance cannot be negative") // Allow 0 and positive numbers
              .max(9999999999, "Housing Allowance is too large"),

            transportAllows: Yup.number()
              .typeError("Transport Allowance must be a valid number")
              .required("Transport Allowance is required")
              .min(0, "Transport Allowance cannot be negative") // Allow 0 and positive numbers
              .max(9999999999, "Transport Allowance is too large"),

            foodAllows: Yup.number()
              .typeError("Food Allowance must be a valid number")
              .required("Food Allowance is required")
              .min(0, "Food Allowance cannot be negative") // Allow 0 and positive numbers
              .max(9999999999, "Food Allowance is too large"),

            otherAllows: Yup.number()
              .typeError("Other Allowance must be a valid number")
              .required("Other Allowances are required")
              .min(0, "Other Allowance cannot be negative") // Allow 0 and positive numbers
              .max(9999999999, "Other Allowance is too large"),

            // gosiDeduction: Yup.number().when("citizen", {
            //   is: (value) => value === "true", // or value === true if it's a boolean
            //   then: (schema) => schema.required("GOSI Deduction is required"),
            //   otherwise: (schema) => schema.notRequired(),
            // }),

            gosiDeduction: Yup.number()
              .typeError("GOSI Deduction must be a valid number")
              .transform((value, originalValue) =>
                originalValue === "" ? undefined : value
              )
              .when("citizen", {
                is: (value) => value === "true",
                then: (schema) =>
                  schema
                    .required("GOSI Deduction is required")
                    .min(0, "GOSI Deduction cannot be negative")
                    .max(9999999999, "GOSI Deduction is too large"),
                otherwise: (schema) => schema.notRequired(),
              }),

            // gosiDeduction: Yup.mixed().when("citizen", {
            //   is: (value) => value === "true",
            //   then: Yup.number()
            //     .typeError("GOSI Deduction must be a valid number")
            //     .min(0, "GOSI Deduction cannot be negative")
            //     .max(9999999999, "GOSI Deduction is too large")
            //     .required("GOSI Deduction is required"),
            //   otherwise: Yup.number().nullable().notRequired(),
            // }),
          }),

          "National ID": Yup.object({
            nationalId: Yup.string().when("citizen", {
              is: "true",
              then: (schema) =>
                schema
                  .required("National ID is required")
                  .trim()
                  .matches(
                    /^[0-9]{10}$/,
                    "National ID must be exactly 10 digits"
                  ),
              otherwise: (schema) => schema.notRequired(),
            }),
            nationalIdExpiry: Yup.date().when("citizen", {
              is: "true",
              then: (schema) =>
                schema
                  .required("National ID Expiry is required")
                  .typeError("Invalid date format"),
              otherwise: (schema) => schema.notRequired(),
            }),
            // nationalIdDob: Yup.date().when("citizen", {
            //   is: "true",
            //   then: (schema) =>
            //     schema
            //       .required("Date of Birth is required")
            //       .typeError("Invalid date format"),
            //   otherwise: (schema) => schema.notRequired(),
            // }),
            // placeOfBirth: Yup.string().when("citizen", {
            //   is: "true",
            //   then: (schema) =>
            //     schema.required("Place of Birth is required").trim(),
            //   otherwise: (schema) => schema.notRequired(),
            // }),

            nationalDocFront: documentValidation(),
            nationalDocBack: documentValidation(),
          }),

          Iqama: Yup.object({
            iqamaProfession: Yup.string().when("citizen", {
              is: "false",
              then: (schema) =>
                schema.required("Iqama Profession is required").trim(),
              otherwise: (schema) => schema.notRequired(),
            }),
            iqamaId: Yup.string().when("citizen", {
              is: "false",
              then: (schema) =>
                schema
                  .required("Iqama ID is required")
                  .matches(
                    /^[\u0660-\u06690-9]{10}$/,
                    "Iqama ID must be a 10-digit number"
                  ),
              otherwise: (schema) => schema.notRequired(),
            }),
            iqamaIdExpiry: Yup.date().when("citizen", {
              is: "false",
              then: (schema) =>
                schema
                  .required("Iqama ID Expiry is required")
                  .typeError("Invalid date format"),
              otherwise: (schema) => schema.notRequired(),
            }),
            workPermitNo: Yup.string().when("citizen", {
              is: "false",
              then: (schema) =>
                schema
                  .required("Work Permit Number is required")
                  .matches(
                    /^[\u0660-\u0669\u06F0-\u06F90-9]{5,64}$/,
                    "Work Permit Number must contain only digits (min 5, max 64)"
                  )
                  .trim(),
              otherwise: (schema) => schema.notRequired(),
            }),
            workPermitExpiry: Yup.date().when("citizen", {
              is: "false",
              then: (schema) =>
                schema
                  .required("Work Permit Expiry is required")
                  .typeError("Invalid date format"),
              otherwise: (schema) => schema.notRequired(),
            }),
            iqamaDocFront: documentValidation(),
            iqamaDocBack: documentValidation(),
          }),

          Account: Yup.object({
            bank: Yup.object().required("Bank name is required"),
            accountHolderName: Yup.string()
              .matches(
                /^[\u0600-\u06FFA-Za-z\s]+$/,
                "Only alphabets and spaces are allowed"
              )
              .max(50, "Account Holder Name cannot exceed 50 characters")
              .required("Account Holder Name is required"),

            ibanNo: Yup.string()
              .matches(
                /^[\u0600-\u06FFa-zA-Z0-9\u0660-\u0669]+$/,
                "Invalid IBAN format"
              )
              .required("IBAN is required")
              .min(15, "IBAN must be at least 15 characters")
              .max(34, "IBAN must not exceed 34 characters")
              .test(
                "not-only-letters",
                "Cannot contain only letters",
                (value) => {
                  if (!value) return true;
                  return !/^[\u0600-\u06FFa-zA-Z]+$/.test(value);
                }
              ),
            confirmIban: Yup.string()
              .oneOf([Yup.ref("ibanNo")], "IBANs must match")
              .required("Confirm IBAN is required"),
            ifscCode: Yup.string()
              .nullable()
              .notRequired()
              .test("valid-ifsc", "Invalid IFSC Code format", (value) => {
                if (!value) return true; // Allow empty values
                const regex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
                return regex.test(value);
              }),
            accountFront: documentValidation(),
            accountBack: documentValidation(),
          }),

          "Health Insurance": Yup.object({
            insuranceClass: Yup.string()
              .required("Insurance Class is required")
              .min(2, "Insurance Class must be at least 2 characters")
              .max(30, "Insurance Class must not exceed 10 characters"),
            insuranceNo: Yup.string()
              .required("Insurance Number is required")
              .matches(
                /^[\u0600-\u06FFA-Za-z0-9]+$/,
                "Only letters and numbers are allowed"
              )
              .matches(
                /[0-9]/,
                "Insurance Number must include at least one digit (e.g., INS123456 or 987XYZ or 448890)"
              )

              .min(5, "Insurance Number must be at least 5 characters")
              .max(20, "Insurance Number must not exceed 20 characters")
              .trim(),
            insuranceExpiry: Yup.date()
              .required("Insurance Expiry is required")
              .typeError("Invalid date format"),
            // healthCardNo: Yup.string()
            //   .required("Health Card Number is required")
            //   .matches(
            //     /^\d{8,15}$/,
            //     "Health Card Number must be between 8 and 15 digits"
            //   ),
            // healthCardExpiry: Yup.date()
            //   .required("Health Card Expiry is required")
            //   .typeError("Invalid date format"),
            insuranceDocFront: documentValidation(),
            insuranceDocBack: documentValidation(),
          }),

          "Health Card": Yup.object({
            healthCard: Yup.string().required("Health Card is required"),
            healthCardNo: Yup.string().when("healthCard", {
              is: "true",
              then: (schema) =>
                schema
                  .required("Health Card Number is required")
                  .matches(
                    /^[\u0600-\u06FFA-Za-z0-9]+$/,
                    "Only Arabic letters, English letters, and numbers are allowed"
                  )
                  .matches(
                    /\d/,
                    "Health Card Number must include at least one number"
                  )
                  .min(5, "Health Card Number must be at least 5 characters")
                  .max(20, "Health Card Number must not exceed 20 characters")
                  .trim(),
              otherwise: (schema) =>
                schema.test(
                  "empty-when-false",
                  "Health Card Number should be empty when Health Card is No",
                  function (value) {
                    const { healthCard } = this.parent;
                    if (healthCard === "false" && value?.trim()) {
                      return false;
                    }
                    return true;
                  }
                ),
            }),

            healthCardExpiry: Yup.string().when("healthCard", {
              is: "true",
              then: (schema) =>
                schema.required("Health Card Expiry is required").trim(),
              otherwise: (schema) =>
                schema.test(
                  "empty-when-false",
                  "Health Card Expiry should be empty when Health Card is No",
                  function (value) {
                    const { healthCard } = this.parent;
                    if (
                      healthCard === "false" &&
                      value &&
                      value.trim() !== ""
                    ) {
                      return false;
                    }
                    return true;
                  }
                ),
            }),
            healthCardDocFront: documentValidation(),
            healthCardDocBack: documentValidation(),
          }),

          Passport: Yup.object({
            passportNo: Yup.string()
              .required("Passport Number is required")
              .trim()
              .test(
                "not-only-letters",
                "Cannot contain only letters",
                (value) => {
                  if (!value) return true;
                  return !/^[a-zA-Z\s]+$/.test(value);
                }
              ),

            passportExpiry: Yup.date()
              .required("Passport Expiry is required")
              .typeError("Invalid date format"),
            passportIssue: Yup.date()
              .required("Passport Issue Date is required")
              .typeError("Invalid date format")
              .max(today, "Passport Issue Date cannot be in the future"),
            issuePlace: Yup.string()
              .required("Issue Place is required")
              .matches(/^(?!\d+$).+$/, "Issue Place cannot be only numbers")
              .trim(),

            passportDocFront: documentValidation(),
            passportDocBack: documentValidation(),

            // passportDocFront: Yup.mixed().required(
            //   "Passport Front Document is required"
            // ),
          }),

          Visa: Yup.object({
            visaNo: Yup.string().when("citizen", {
              is: "false",
              then: (schema) =>
                schema
                  .required("Visa Number is required")
                  .matches(
                    /^(?![A-Za-z]+$).+$/,
                    "Visa Number must include numbers"
                  ),
              otherwise: (schema) => schema.notRequired(),
            }),

            visaExpiry: Yup.date().when("citizen", {
              is: "false",
              then: (schema) =>
                schema
                  .required("Visa Expiry is required")
                  .typeError("Invalid date format"),
              otherwise: (schema) => schema.notRequired(),
            }),
            visaIssue: Yup.date().when("citizen", {
              is: "false",
              then: (schema) =>
                schema
                  .required("Visa Issue Date is required")
                  .typeError("Invalid date format"),
              otherwise: (schema) => schema.notRequired(),
            }),
            visaIssuePlace: Yup.string().when("citizen", {
              is: "false",
              then: (schema) =>
                schema
                  .required("Visa Issue Place is required")
                  .matches(
                    /^(?!\d+$).+$/,
                    "Visa Issue Place cannot be only numbers"
                  ),
              otherwise: (schema) => schema.notRequired(),
            }),
            visaType: Yup.object().when("citizen", {
              is: "false",
              then: (schema) => schema.required("Visa Type is required"),
              otherwise: (schema) => schema.notRequired(),
            }),
            visaDocFront: documentValidation(),
            visaDocBack: documentValidation(),
          }),

          Contract: Yup.object({
            contractNo: Yup.string()
              .required("Contract Number is required")
              .test(
                "not-only-letters",
                "Cannot contain only letters",
                (value) => {
                  if (!value) return true;
                  return !/^[a-zA-Z\s]+$/.test(value);
                }
              ),
            contractEnd: Yup.date()
              .required("Contract End Date is required")
              .typeError("Invalid date format"),
            contractDocFront: documentValidation(),
            contractDocBack: documentValidation(),
          }),

          "Driving License": Yup.object({
            drivingLicenseNo: Yup.string()
              .required("Driving License Number is required")
              .matches(
                /^(?=.*[0-9])[A-Za-z0-9-]+$/, // Must contain at least 1 number
                "Must include at least 1 number (e.g., ABC123 or DL-4567)"
              )
              .min(4, "Must be at least 4 characters long")
              .max(25, "Cannot exceed 25 characters")
              .test(
                "no-consecutive-hyphens",
                "Hyphens cannot be consecutive (e.g., '--')",
                (value) => !value?.includes("--")
              )
              .test(
                "no-standalone-hyphens",
                "Hyphen cannot be at start or end (e.g., '-ABC123' or 'ABC123-')",
                (value) => !value?.startsWith("-") && !value?.endsWith("-")
              ),

            licenseValidity: Yup.date()
              .required("License Validity is required")
              .typeError("Invalid date format"),
            drivingLicenseDocFront: documentValidation(),
            drivingLicenseDocBack: documentValidation(),
          }),

          Subscription: Yup.object({
            gosiReg: Yup.string().required("GOSI Registration is required"),
            gosiRegNo: Yup.string().when("gosiReg", {
              is: "true", // Only validate if `gosiReg` is "true"
              then: (schema) =>
                schema
                  .required("GOSI Number is required")
                  .matches(
                    /^[0-9]+$/, // Only digits allowed
                    "GOSI Number must contain only numbers (0-9)"
                  )
                  .min(4, "GOSI Number must be at least 4 digits")
                  .max(20, "GOSI Number cannot exceed 20 digits"),
              otherwise: (schema) =>
                schema
                  .notRequired()
                  .test(
                    "empty-when-false",
                    "GOSI Number should be empty when GOSI Registration is No",
                    function (value) {
                      const { gosiReg } = this.parent;
                      if (gosiReg === "false" && value && value.trim() !== "") {
                        return false;
                      }
                      return true;
                    }
                  ),
            }),
            mudadReg: Yup.string().required("Mudad Registration is required"),
            mudadRegNo: Yup.string().when("mudadReg", {
              is: "true", // Only validate if mudadReg is "true"
              then: (schema) =>
                schema
                  .required("Mudad Number is required")
                  .matches(
                    /^[0-9]+$/, // Only digits allowed
                    "Mudad Number must contain only numbers (0-9)"
                  )
                  .min(4, "Mudad Number must be at least 4 digits")
                  .max(20, "Mudad Number cannot exceed 20 digits"),
              otherwise: (schema) =>
                schema
                  .notRequired()
                  .test(
                    "empty-when-false",
                    "Mudad Number should be empty when Mudad Registration is No",
                    function (value) {
                      const { mudadReg } = this.parent;
                      if (
                        mudadReg === "false" &&
                        value &&
                        value.trim() !== ""
                      ) {
                        return false;
                      }
                      return true;
                    }
                  ),
            }),

            gosiDocFront: documentValidation(),
            gosiDocBack: documentValidation(),

            subscriptionDocFront: documentValidation(),
            subscriptionDocBack: documentValidation(),

            // gosiDocFront: Yup.string().when("gosiReg", {
            //   is: "true",
            //   then: (schema) => schema.required("Subscription Front Document is required"),
            //   otherwise: (schema) => schema.notRequired(),
            // }),
            // gosiDocBack: Yup.mixed().required(
            //   "Subscription Front Document is required"
            // ),

            // subscriptionDocFront: Yup.string().when("gosiReg", {
            //   is: "true",
            //   then: (schema) => schema.required("Subscription Front Document is required"),
            //   otherwise: (schema) => schema.notRequired(),
            // }),
            // subscriptionDocFront: Yup.mixed().required(
            //   "Subscription Front Document is required"
            // ),
          }),
        };

        return schemas[documentTab] || Yup.object({});

      case 4:
        return Yup.object({
          members: Yup.array()
            .of(
              Yup.object().shape({
                depFirstName: Yup.string()
                  .trim()
                  .required("First Name is required")
                  .matches(
                    /^[\u0600-\u06FFA-Za-z\s]*$/,
                    "First name must not contain special characters or numbers"
                  )
                  .max(30, "First name must not exceed 30 characters"),
                depSecondName: Yup.string()
                  .trim()
                  .matches(
                    /^[\u0600-\u06FFA-Za-z\s]*$/,
                    "Second name must not contain special characters or numbers"
                  )
                  .max(30),

                depThirdName: Yup.string()
                  .trim()
                  .matches(
                    /^[\u0600-\u06FFA-Za-z\s]*$/,
                    "Third name must not contain special characters or numbers"
                  )
                  .max(30),

                depFourthName: Yup.string()
                  .trim()
                  .required("Last Name is required")
                  .matches(
                    /^[\u0600-\u06FFA-Za-z\s]*$/,
                    "Fourth name must not contain special characters or numbers"
                  )
                  .max(30),

                depIdNumber: Yup.string()
                  .trim()
                  .matches(
                    /^[\u0660-\u06690-9]*$/,
                    "ID Number must contain only numbers"
                  )
                  .max(15),

                idExpiry: Yup.date()
                  .nullable()
                  .transform((v) => (v === "" ? null : v))
                  .typeError("Invalid date format")
                  .min(new Date(), "ID Expiry must be in the future"),

                depPassportNo: Yup.string()
                  .trim()
                  .test(
                    "not-only-letters",
                    "Passport Number cannot contain only letters",
                    (value) => !value || !/^[a-zA-Z\s]+$/.test(value)
                  )
                  .max(20),

                depPassportExpiry: Yup.date()
                  .nullable()
                  .transform((v) => (v === "" ? null : v))
                  .typeError("Invalid date format")
                  .min(new Date(), "Passport Expiry must be in the future"),

                depContactNo: Yup.string()
                  .trim()
                  .transform((value) =>
                    value
                      ? value.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
                      : value
                  )
                  .matches(
                    /^(00966|966|\+966|0)?5\d{8}$|^$/,
                    "Enter a valid Saudi mobile number or leave empty"
                  ),

                depDob: Yup.date()
                  .nullable()
                  .transform((v) => (v === "" ? null : v))
                  .typeError("Invalid date format")
                  .max(new Date(), "Date of birth cannot be in the future")
                  .test(
                    "realistic-age",
                    "Please enter a realistic date of birth.",
                    (value) => {
                      if (!value) return true;
                      const age =
                        new Date().getFullYear() -
                        new Date(value).getFullYear();
                      return age <= 120;
                    }
                  ),

                depGender: Yup.string().oneOf(
                  ["Male", "Female", ""],
                  "Invalid gender"
                ),

                depCitizen: Yup.string().oneOf(
                  ["true", "false", ""],
                  "Invalid citizen value"
                ),

                depNationality: Yup.mixed().nullable(),

                depSponsorName: Yup.string()
                  .trim()
                  .matches(
                    /^[\u0600-\u06FFA-Za-z\s]*$/,
                    "Sponsor name must not contain special characters or numbers"
                  )
                  .max(50),

                depSponsorId: Yup.string()
                  .nullable()
                  .notRequired()
                  .trim()
                  .max(30, "Sponsor ID must not exceed 30 characters")
                  .test(
                    "is-valid-sponsor-id",
                    "Sponsor ID must be alphanumeric and cannot contain only letters",
                    (value) => {
                      if (!value) return true; // allow null, undefined, or empty string
                      return /^(?=.*\d)[A-Za-z0-9-]+$/.test(value);
                    }
                  ),

                depReligion: Yup.mixed().nullable(),

                depMaritalStatus: Yup.string().oneOf(
                  ["Married", "Single", "Divorced", "Widowed", ""],
                  "Invalid marital status"
                ),

                depRelation: Yup.mixed().nullable(),
              })
            )
            // Simplified test - only check if array exists and has valid structure
            .min(0, "Invalid members array"),
        });

      default:
        return Yup.object();
    }
  };

  const getEmployeeById = async (publicId) => {
    try {
      const response = await getPersonalInfoById(publicId); // Replace with actual API function

      setDraftedData(response?.data?.data);
      setPersonalInfo(response?.data?.data);
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    }
  };

  // Function to handle step progression
  const handleNextStep = async (values, actions) => {
    const filteredTabs =
      values?.citizen === "true"
        ? docsTabs.filter((tab) => tab !== "Iqama" && tab !== "Visa")
        : docsTabs.filter((tab) => tab !== "National ID");

    const currentIndex = filteredTabs.indexOf(documentTab);
    const isLastTab = currentIndex === filteredTabs.length - 1;

    const currentValidationSchema = getValidationSchema(detailsStep);
    currentValidationSchema
      .validate(values, { abortEarly: false })
      .then(() => {
        if (detailsStep == 2) {
          // Remove "employmentInfo" from skippedSections
          setSkippedSections((prev) =>
            prev.filter((section) => section !== "employmentInfo")
          );
        } else if (detailsStep == 3) {
          // Remove the current documentTab from skippedSections
          setSkippedSections((prev) =>
            prev.filter((section) => section !== documentTab)
          );
        }

        if (isDraft && detailsStep < 5) {
          handleDraftData(values, detailsStep);
        } else if (detailsStep < 4) {
          if (detailsStep == 3) {
            if (isLastTab) {
              setDetailsStep((prev) => prev + 1);
            } else {
              setDocumnetTab(filteredTabs[currentIndex + 1]);
            }
          } else {
            setDetailsStep((prev) => prev + 1);
          }
        } else {
          // onClose();
          let documents = {};

          const employeeInfo = {
            ...(values?.branch?.value && { branch: values.branch.value }),
            ...(values?.role?.value && { roleId: values.role.value }),
            ...(values?.jobTitle?.value && {
              jobTitle: values.jobTitle?.value,
            }),
            ...(values?.designation?.value && {
              designation: values.designation.value,
            }),
            ...(values?.department?.value && {
              department: values.department.value,
            }),
            ...(values?.reportingTo?.value && {
              reportingTo: values.reportingTo.value,
            }),
            ...(values?.joiningDate && { joiningDate: values.joiningDate }),
            ...(values?.jobGrade?.value && {
              jobGrade: values.jobGrade?.value,
            }),
            ...(values?.contractType?.value && {
              contractType: values.contractType.value,
            }),
            ...(values?.probationPeriod && {
              probationPeriod: values.probationPeriod,
            }),
            ...(values?.employmentType?.value && {
              employeeType: values.employmentType.value,
            }),
          };

          const allEmployeeInfoFieldsPresent =
            areAllFieldsPresent(employeeInfo);

          const sections = {
            ...(!skippedSections.includes("Salary Details") && {
              salaryInfo: {
                ...(values?.basicPay && { basicPay: values.basicPay }),
                ...(values?.housingAllows && {
                  housingAllows: values.housingAllows,
                }),
                ...(values?.transportAllows && {
                  transportAllows: values.transportAllows,
                }),
                ...(values?.foodAllows && { foodAllows: values.foodAllows }),
                ...(values?.otherAllows && { otherAllows: values.otherAllows }),
                ...(totalSalary &&
                  totalSalary !== "0.00" && { totalSalary: totalSalary }),
                ...(values?.citizen === "true" &&
                  values?.gosiDeduction && {
                    gosiDeduction: values.gosiDeduction,
                  }),
                ...(values?.citizen === "true" &&
                  values?.deductionAmount && {
                    deductionAmount: values.deductionAmount,
                  }),
              },
            }),

            ...(!skippedSections.includes("National ID") &&
              values?.citizen === "true" && {
                nationalIdInfo: {
                  ...(values?.nationalId && { nationalId: values.nationalId }),
                  ...(values?.nationalIdExpiry && {
                    nationalIdExpiry: values.nationalIdExpiry,
                  }),
                  ...(values?.dobGregorian && {
                    nationalIdDob: values.dobGregorian,
                  }),
                  ...(values?.placeOfBirth && {
                    placeOfBirth: values.placeOfBirth,
                  }),
                  nationalDocFront:
                    employeeDocNames?.nationalDocNames[0]?.fileUrl,
                  nationalDocBack:
                    employeeDocNames?.nationalDocNames[1]?.fileUrl,
                  // ...(employeeDocNames?.nationalDocNames?.[1] && {
                  //   nationalDocBack: employeeDocNames.nationalDocNames[1],
                  // }),
                },
              }),
            // Include iqamaInfo only if it's not in skippedSections and citizen is "false"
            ...(!skippedSections.includes("Iqama") &&
              values?.citizen === "false" && {
                iqamaInfo: {
                  ...(values?.iqamaProfession && {
                    iqamaProfession: values.iqamaProfession,
                  }),
                  ...(values?.iqamaId && { iqamaId: values.iqamaId }),
                  ...(values?.iqamaIdExpiry && {
                    iqamaIdExpiry: values.iqamaIdExpiry,
                  }),
                  ...(values?.workPermitNo && {
                    workPermitNo: values.workPermitNo,
                  }),
                  ...(values?.workPermitExpiry && {
                    workPermitExpiry: values.workPermitExpiry,
                  }),
                  frontDocument: employeeDocNames?.iqamaDocNames[0]?.fileUrl,
                  backDocument: employeeDocNames?.iqamaDocNames[1]?.fileUrl,
                },
              }),

            // Include bankInfo only if it's not in skippedSections
            ...(!skippedSections.includes("Account") && {
              bankInfo: {
                ...(values?.bank?.value && { bank: values.bank.value }),
                ...(values?.accountHolderName && {
                  accountHolderName: values.accountHolderName,
                }),
                ...(values?.ibanNo && { ibanNo: values.ibanNo }),
                ...(values?.ifscCode && { ifscCode: values.ifscCode }),
                frontDocument: employeeDocNames?.accountDocNames[0]?.fileUrl,
                backDocument: employeeDocNames?.accountDocNames[1]?.fileUrl,
              },
            }),
            ...(!skippedSections.includes("Health Insurance") && {
              healthInsuranceInfo: {
                ...(values?.insuranceClass && {
                  insuranceClass: values.insuranceClass,
                }),
                ...(values?.insuranceNo && { insuranceNo: values.insuranceNo }),
                ...(values?.insuranceExpiry && {
                  insuranceExpiry: values.insuranceExpiry,
                }),
                frontDocument: employeeDocNames?.insuranceDocNames[0]?.fileUrl,
                backDocument: employeeDocNames?.insuranceDocNames[1]?.fileUrl,
              },
            }),
            ...(!skippedSections.includes("Health Card") && {
              healthCardInfo: {
                ...(values?.healthCard && {
                  healthCard: values.healthCard,
                }),
                ...{
                  healthCardNo: values.healthCardNo,
                },
                ...{
                  healthCardExpiry: values.healthCardExpiry,
                },
                frontDocument: employeeDocNames?.healthCardDocNames[0]?.fileUrl,
                backDocument: employeeDocNames?.healthCardDocNames[1]?.fileUrl,
              },
            }),
            // Include passportInfo only if it's not in skippedSections
            ...(!skippedSections.includes("Passport") && {
              passportInfo: {
                ...(values?.passportNo && { passportNo: values.passportNo }),
                ...(values?.passportExpiry && {
                  expiryDate: values.passportExpiry,
                }),
                ...(values?.passportIssue && {
                  issueDate: values.passportIssue,
                }),
                ...(values?.issuePlace && { placeOfIssue: values.issuePlace }),
                frontDocument: employeeDocNames?.passportDocNames[0]?.fileUrl,
                backDocument: employeeDocNames?.passportDocNames[1]?.fileUrl,
              },
            }), // Include visaInfo only if it's not in skippedSections and citizen is "false"
            ...(!skippedSections.includes("Visa") &&
              values?.citizen === "false" && {
                visaInfo: {
                  ...(values?.visaNo && { visaNo: values.visaNo }),
                  ...(values?.visaExpiry && { expiryDate: values.visaExpiry }),
                  ...(values?.visaIssue && { issueDate: values.visaIssue }),
                  ...(values?.visaIssuePlace && {
                    placeOfIssue: values.visaIssuePlace,
                  }),
                  ...(values?.visaType?.value && {
                    type: values.visaType.value,
                  }),
                  frontDocument: employeeDocNames?.visaDocNames[0]?.fileUrl,
                  backDocument: employeeDocNames?.visaDocNames[1]?.fileUrl,
                },
              }),
            // Include contractInfo only if it's not in skippedSections
            ...(!skippedSections.includes("Contract") && {
              contractInfo: {
                ...(values?.contractNo && { contractNo: values.contractNo }),
                ...(values?.contractEnd && { contractEnd: values.contractEnd }),
                frontDocument: employeeDocNames?.contractDocNames[0]?.fileUrl,
                backDocument: employeeDocNames?.contractDocNames[1]?.fileUrl,
              },
            }),
            ...(!skippedSections.includes("Driving License") && {
              drivingLicenseInfo: {
                ...(values?.drivingLicenseNo && {
                  drivingLicenseNo: values.drivingLicenseNo,
                }),
                ...(values?.licenseValidity && {
                  drivingLicenseValidity: values.licenseValidity,
                }),
                frontDocument:
                  employeeDocNames?.drivingLicenseDocNames[0]?.fileUrl,
                backDocument:
                  employeeDocNames?.drivingLicenseDocNames[1]?.fileUrl,
              },
            }),
            ...(!skippedSections.includes("Subscription") && {
              subscriptionInfo: {
                ...(values?.gosiReg && { gosiReg: values.gosiReg }),
                ...{ gosiRegNo: values.gosiRegNo },
                gosiFrontDocument: employeeDocNames?.gosiDocNames[0]?.fileUrl,
                gosiBackDocument: employeeDocNames?.gosiDocNames[1]?.fileUrl,
                ...(values?.mudadReg && { mudadReg: values.mudadReg }),
                ...{ mudadRegNo: values.mudadRegNo },
                frontDocument:
                  employeeDocNames?.subscriptionDocNames[0]?.fileUrl,
                backDocument:
                  employeeDocNames?.subscriptionDocNames[1]?.fileUrl,
              },
            }),
          };

          // **Updating `documents` only with non-empty sections**
          for (const key in sections) {
            if (sections[key] && Object.keys(sections[key]).length > 0) {
              documents[key] = sections[key];
            }
          }

          const submitValue2 = {
            status: "active",
            ...(values?.firstName && { firstName: values.firstName }),
            ...{ firstNameArb: values.firstNameArb },
            ...{ secondName: values.secondName },
            ...{ secondNameArb: values.secondNameArb },
            ...{ thirdName: values.thirdName },
            ...{ thirdNameArb: values.thirdNameArb },
            ...(values?.lastName && { lastName: values.lastName }),
            ...{ lastNameArb: values.lastNameArb },
            ...(values?.phone && { phone: values.phone }),
            ...(values?.personalEmail && {
              personalEmail: values.personalEmail,
            }),
            ...(values?.email && { email: values.email }),
            ...(values?.dobHijri && {
              dobHijri: convertDateForPayload(values.dobHijri),
            }),
            ...(values?.dobGregorian && { dobGregorian: values.dobGregorian }),
            ...(values?.religion?.value && { religion: values.religion.value }),
            ...(values?.maritalStatus && {
              maritalStatus: values.maritalStatus,
            }),
            ...(values?.gender && { gender: values.gender }),
            ...(values?.citizen && { citizen: values.citizen }),

            ...(values?.citizen === "false" &&
              values?.nationality?.value && {
                nationality: values.nationality.value,
              }),
            ...(values?.citizen === "true" &&
              values?.nationalId && {
                nationalId: values.nationalId,
              }),

            profilePicture: values.profilePicture,
            userInvitation: values?.userInvitation,

            ...(!skippedSections.includes("employmentInfo") &&
              allEmployeeInfoFieldsPresent && { employeeInfo }),

            ...(documents && { documents: documents }),

            ...(values?.isDependents === "true" &&
              values?.members?.length > 0 && {
                dependentsInfo:
                  values?.members?.map((member) => ({
                    ...(member?.publicId && { publicId: member.publicId }),
                    ...{
                      dependentFirstName: member.depFirstName,
                    },
                    ...{
                      dependentSecondName: member.depSecondName,
                    },
                    ...{
                      dependentThirdName: member.depThirdName,
                    },
                    ...{
                      dependentFourthName: member.depFourthName,
                    },
                    ...{ iqamaNo: member.depIdNumber },
                    ...{
                      iqamaExpiryDate: member.idExpiry || "",
                    },
                    ...{
                      passportNo: member.depPassportNo,
                    },
                    ...{
                      passportExpiryDate: member.depPassportExpiry || "",
                    },
                    ...{
                      contactNo: member.depContactNo,
                    },
                    ...{ dateOfBirth: member.depDob || "" },
                    ...{
                      relation: member.depRelation?.value || "",
                    },
                    ...{
                      religion: member.depReligion?.value || "",
                    },
                    ...{
                      nationality: member.depNationality?.value || "",
                    },
                    ...{
                      sponsorName: member.depSponsorName,
                    },
                    ...{
                      sponsorId: member.depSponsorId,
                    },
                    ...(member.depCitizen && { citizen: member.depCitizen }),
                    ...(member.depMaritalStatus && {
                      maritalStatus: member.depMaritalStatus,
                    }),
                    ...(member?.depGender && { gender: member.depGender }),
                  })) || [],
              }),
          };

          if (latestPublicId) {
            handleUpdateEmployee(submitValue2);
          } else {
            handleSubmitValues(submitValue2);
          }
        }
      })
      .catch((validationErrors) => {
        console.error("Validation failed:", validationErrors);
        setIsDraft(false);
        // const errors = {};
        // validationErrors.inner.forEach((error) => {
        //   errors[error.path] = error.message;
        // });
        // actions.setErrors(errors);
      });
  };

  const areAllFieldsPresent = (obj) => {
    return Object.values(obj).every(
      (field) => field !== undefined && field !== null && field !== ""
    );
  };

  const handleDraftData = async (values, detailsStep) => {
    let draftData;
    let firstData;
    let secondData;
    let thirdData;
    let dependentsInfo;
    try {
      firstData = {
        ...(draftAndExit
          ? { status: "draft" }
          : saveAndExit && { status: "active" }),
        ...(values?.firstName && { firstName: values.firstName }),
        ...{ firstNameArb: values.firstNameArb },
        ...{ secondName: values.secondName },
        ...{ secondNameArb: values.secondNameArb },
        ...{ thirdName: values.thirdName },
        ...{ thirdNameArb: values.thirdNameArb },
        ...(values?.lastName && { lastName: values.lastName }),
        ...{ lastNameArb: values.lastNameArb },
        ...(values?.phone && { phone: values.phone }),
        ...(values?.personalEmail && { personalEmail: values.personalEmail }),
        ...(values?.email && { email: values.email }),
        ...(values?.dobHijri && {
          dobHijri: convertDateForPayload(values.dobHijri),
        }),
        ...(values?.dobGregorian && { dobGregorian: values.dobGregorian }),
        ...(values?.religion?.value && { religion: values.religion.value }),
        ...(values?.maritalStatus && { maritalStatus: values.maritalStatus }),
        ...(values?.gender && { gender: values.gender }),
        ...(values?.citizen && { citizen: values.citizen }),

        ...(values?.citizen === "false" &&
          values?.nationality?.value && {
            nationality: values.nationality.value,
          }),
        ...(values?.citizen === "true" &&
          values?.nationalId && {
            nationalId: values.nationalId,
          }),

        profilePicture: values.profilePicture,

        userInvitation: values?.userInvitation,
      };

      let employeeInfo = {
        ...(values?.branch?.value && { branch: values.branch.value }),
        ...(values?.role?.value && { roleId: values.role.value }),
        ...(values?.jobTitle?.value && { jobTitle: values.jobTitle?.value }),
        ...(values?.designation?.value && {
          designation: values.designation.value,
        }),
        ...(values?.department?.value && {
          department: values.department.value,
        }),
        ...(values?.reportingTo?.value && {
          reportingTo: values.reportingTo.value,
        }),
        ...(values?.joiningDate && { joiningDate: values.joiningDate }),
        ...(values?.jobGrade?.value && {
          jobGrade: values.jobGrade?.value,
        }),
        ...(values?.contractType?.value && {
          contractType: values.contractType.value,
        }),
        ...(values?.probationPeriod && {
          probationPeriod: values.probationPeriod,
        }),
        ...(values?.employmentType?.value && {
          employeeType: values.employmentType.value,
        }),
      };
      let documents = {};

      if (
        (!skippedSections.includes("Salary Details") ||
          documentTab === "Salary Details") &&
        [
          "Salary Details",
          "National ID",
          "Iqama",
          "Account",
          "Health Insurance",
          "Health Card",
          "Passport",
          "Visa",
          "Contract",
          "Driving License",
          "Subscription",
        ].includes(documentTab)
      ) {
        const salaryInfo = {
          ...(values?.basicPay && { basicPay: values.basicPay }),
          ...(values?.housingAllows && { housingAllows: values.housingAllows }),
          ...(values?.transportAllows && {
            transportAllows: values.transportAllows,
          }),
          ...(values?.foodAllows && { foodAllows: values.foodAllows }),
          ...(values?.otherAllows && { otherAllows: values.otherAllows }),
          ...(totalSalary &&
            totalSalary !== "0.00" && { totalSalary: totalSalary }),
          ...(values?.citizen === "true" &&
            values?.gosiDeduction && { gosiDeduction: values.gosiDeduction }),
          ...(values?.citizen === "true" &&
            values?.deductionAmount && {
              deductionAmount: values.deductionAmount,
            }),
        };

        documents = {
          ...(Object.keys(salaryInfo).length > 0 && { salaryInfo }),
        };
      }

      if (
        (!skippedSections.includes("National ID") ||
          documentTab === "National ID") &&
        [
          "National ID",
          "Iqama",
          "Account",
          "Health Insurance",
          "Health Card",
          "Passport",
          "Visa",
          "Contract",
          "Driving License",
          "Subscription",
        ].includes(documentTab)
      ) {
        const nationalIdInfo =
          values?.citizen === "true"
            ? {
                ...(values?.nationalId && {
                  nationalId: values.nationalId,
                }),
                ...(values?.nationalIdExpiry && {
                  nationalIdExpiry: values.nationalIdExpiry,
                }),
                ...(values?.dobGregorian && {
                  nationalIdDob: values.dobGregorian,
                }),
                ...(values?.placeOfBirth && {
                  placeOfBirth: values.placeOfBirth,
                }),
                nationalDocFront:
                  employeeDocNames?.nationalDocNames[0]?.fileUrl,
                nationalDocBack: employeeDocNames?.nationalDocNames[1]?.fileUrl,
                // ...(employeeDocNames?.nationalDocNames?.[0] && {
                //   nationalDocFront: employeeDocNames.nationalDocNames[0],
                // }),
                // ...(employeeDocNames?.nationalDocNames?.[1] && {
                //   nationalDocBack: employeeDocNames.nationalDocNames[1],
                // }),
              }
            : null;

        documents = {
          ...documents,
          ...(nationalIdInfo &&
            Object.keys(nationalIdInfo).length > 0 && { nationalIdInfo }),
        };
      }

      if (
        (!skippedSections.includes("Iqama") || documentTab === "Iqama") &&
        [
          "Iqama",
          "Account",
          "Health Insurance",
          "Health Card",
          "Passport",
          "Visa",
          "Contract",
          "Driving License",
          "Subscription",
        ].includes(documentTab)
      ) {
        const iqamaInfo =
          values?.citizen === "false"
            ? {
                ...(values?.iqamaProfession && {
                  iqamaProfession: values.iqamaProfession,
                }),
                ...(values?.iqamaId && { iqamaId: values.iqamaId }),
                ...(values?.iqamaIdExpiry && {
                  iqamaIdExpiry: values.iqamaIdExpiry,
                }),
                ...(values?.workPermitNo && {
                  workPermitNo: values.workPermitNo,
                }),
                ...(values?.workPermitExpiry && {
                  workPermitExpiry: values.workPermitExpiry,
                }),
                frontDocument: employeeDocNames?.iqamaDocNames[0]?.fileUrl,
                backDocument: employeeDocNames?.iqamaDocNames[1]?.fileUrl,
              }
            : null;

        documents = {
          ...documents,
          ...(iqamaInfo && Object.keys(iqamaInfo).length > 0 && { iqamaInfo }),
        };
      }

      if (
        (!skippedSections.includes("Account") || documentTab === "Account") &&
        [
          "Account",
          "Health Insurance",
          "Health Card",
          "Passport",
          "Visa",
          "Contract",
          "Driving License",
          "Subscription",
        ].includes(documentTab)
      ) {
        const bankInfo = {
          ...(values?.bank?.value && { bank: values.bank.value }),
          ...(values?.accountHolderName && {
            accountHolderName: values.accountHolderName,
          }),
          ...(values?.ibanNo && { ibanNo: values.ibanNo }),
          ...(values?.ifscCode && { ifscCode: values.ifscCode }),
          frontDocument: employeeDocNames?.accountDocNames[0]?.fileUrl,
          backDocument: employeeDocNames?.accountDocNames[1]?.fileUrl,
        };

        documents = {
          ...documents,
          ...(Object.keys(bankInfo).length > 0 && { bankInfo }),
        };
      }

      if (
        (!skippedSections.includes("Health Insurance") ||
          documentTab === "Health Insurance") &&
        [
          "Health Insurance",
          "Health Card",
          "Passport",
          "Visa",
          "Contract",
          "Driving License",
          "Subscription",
        ].includes(documentTab)
      ) {
        const healthInsuranceInfo = {
          ...(values?.insuranceClass && {
            insuranceClass: values.insuranceClass,
          }),
          ...(values?.insuranceNo && { insuranceNo: values.insuranceNo }),
          ...(values?.insuranceExpiry && {
            insuranceExpiry: values.insuranceExpiry,
          }),
          frontDocument: employeeDocNames?.insuranceDocNames[0]?.fileUrl,
          backDocument: employeeDocNames?.insuranceDocNames[1]?.fileUrl,
        };

        documents = {
          ...documents,
          ...(Object.keys(healthInsuranceInfo).length > 0 && {
            healthInsuranceInfo,
          }),
        };
      }

      if (
        (!skippedSections.includes("Health Card") ||
          documentTab === "Health Card") &&
        [
          "Health Card",
          "Passport",
          "Visa",
          "Contract",
          "Driving License",
          "Subscription",
        ].includes(documentTab)
      ) {
        const healthCardInfo = {
          ...(values?.healthCard && { healthCard: values.healthCard }),
          ...{ healthCardNo: values.healthCardNo },
          ...{
            healthCardExpiry: values.healthCardExpiry,
          },
          frontDocument: employeeDocNames?.healthCardDocNames[0]?.fileUrl,
          backDocument: employeeDocNames?.healthCardDocNames[1]?.fileUrl,
        };

        documents = {
          ...documents,
          ...(Object.keys(healthCardInfo).length > 0 && {
            healthCardInfo,
          }),
        };
      }

      if (
        (!skippedSections.includes("Passport") || documentTab === "Passport") &&
        [
          "Passport",
          "Visa",
          "Contract",
          "Driving License",
          "Subscription",
        ].includes(documentTab)
      ) {
        const passportInfo = {
          ...(values?.passportNo && { passportNo: values.passportNo }),
          ...(values?.passportExpiry && { expiryDate: values.passportExpiry }),
          ...(values?.passportIssue && { issueDate: values.passportIssue }),
          ...(values?.issuePlace && { placeOfIssue: values.issuePlace }),
          frontDocument: employeeDocNames?.passportDocNames[0]?.fileUrl,
          backDocument: employeeDocNames?.passportDocNames[1]?.fileUrl,
        };

        documents = {
          ...documents,
          ...(Object.keys(passportInfo).length > 0 && { passportInfo }),
        };
      }

      if (
        (!skippedSections.includes("Visa") || documentTab === "Visa") &&
        ["Visa", "Contract", "Driving License", "Subscription"].includes(
          documentTab
        )
      ) {
        const visaInfo =
          values?.citizen === "false"
            ? {
                ...(values?.visaNo && { visaNo: values.visaNo }),
                ...(values?.visaExpiry && { expiryDate: values.visaExpiry }),
                ...(values?.visaIssue && { issueDate: values.visaIssue }),
                ...(values?.visaIssuePlace && {
                  placeOfIssue: values.visaIssuePlace,
                }),
                ...(values?.visaType?.value && { type: values.visaType.value }),
                frontDocument: employeeDocNames?.visaDocNames[0]?.fileUrl,
                backDocument: employeeDocNames?.visaDocNames[1]?.fileUrl,
              }
            : null;

        documents = {
          ...documents,
          ...(visaInfo && Object.keys(visaInfo).length > 0 && { visaInfo }),
        };
      }

      if (
        (!skippedSections.includes("Contract") || documentTab === "Contract") &&
        ["Contract", "Driving License", "Subscription"].includes(documentTab)
      ) {
        const contractInfo = {
          ...(values?.contractNo && { contractNo: values.contractNo }),
          ...(values?.contractEnd && { contractEnd: values.contractEnd }),
          frontDocument: employeeDocNames?.contractDocNames[0]?.fileUrl,
          backDocument: employeeDocNames?.contractDocNames[1]?.fileUrl,
        };

        documents = {
          ...documents,
          ...(Object.keys(contractInfo).length > 0 && { contractInfo }),
        };
      }

      if (
        (!skippedSections.includes("Driving License") ||
          documentTab === "Driving License") &&
        ["Driving License", "Subscription"].includes(documentTab)
      ) {
        const drivingLicenseInfo = {
          ...(values?.drivingLicenseNo && {
            drivingLicenseNo: values.drivingLicenseNo,
          }),
          ...(values?.licenseValidity && {
            drivingLicenseValidity: values.licenseValidity,
          }),
          frontDocument: employeeDocNames?.drivingLicenseDocNames[0]?.fileUrl,
          backDocument: employeeDocNames?.drivingLicenseDocNames[1]?.fileUrl,
        };

        documents = {
          ...documents,
          ...(Object.keys(drivingLicenseInfo).length > 0 && {
            drivingLicenseInfo,
          }),
        };
      }

      if (
        !skippedSections.includes("Subscription") &&
        documentTab === "Subscription"
      ) {
        const subscriptionInfo = {
          ...(values?.gosiReg && { gosiReg: values.gosiReg }),
          ...{ gosiRegNo: values.gosiRegNo },
          gosiFrontDocument: employeeDocNames?.gosiDocNames[0]?.fileUrl,
          gosiBackDocument: employeeDocNames?.gosiDocNames[1]?.fileUrl,
          ...(values?.mudadReg && { mudadReg: values.mudadReg }),
          ...{ mudadRegNo: values.mudadRegNo },
          frontDocument: employeeDocNames?.subscriptionDocNames[0]?.fileUrl,
          backDocument: employeeDocNames?.subscriptionDocNames[1]?.fileUrl,
        };

        documents = {
          ...documents,
          ...(Object.keys(subscriptionInfo).length > 0 && { subscriptionInfo }),
        };
      }

      if (detailsStep == 4) {
      }

      const filteredTabs =
        values?.citizen === "true"
          ? docsTabs.filter((tab) => tab !== "Iqama" && tab !== "Visa")
          : docsTabs.filter((tab) => tab !== "National ID");

      const currentIndex = filteredTabs.indexOf(documentTab);
      const isLastTab = currentIndex === filteredTabs.length - 1;

      const allEmployeeInfoFieldsPresent = areAllFieldsPresent(employeeInfo);
      if (detailsStep == 1) {
        draftData = firstData;
      } else if (detailsStep == 2) {
        draftData = {
          ...firstData,
          ...(allEmployeeInfoFieldsPresent && { employeeInfo }),
        };
      } else if (detailsStep == 3) {
        draftData = {
          ...firstData,
          ...(!skippedSections.includes("employmentInfo") &&
            allEmployeeInfoFieldsPresent && { employeeInfo }),
          ...(documents && { documents: documents }),
        };
      } else if (detailsStep == 4) {
        const dependentsInfo =
          values?.isDependents === "true" && values?.members?.length > 0
            ? values.members.map((member) => ({
                ...(member?.publicId && { publicId: member.publicId }),
                ...{
                  dependentFirstName: member.depFirstName,
                },
                ...{
                  dependentSecondName: member.depSecondName,
                },
                ...{
                  dependentThirdName: member.depThirdName,
                },
                ...{
                  dependentFourthName: member.depFourthName,
                },
                ...{ iqamaNo: member.depIdNumber },
                ...{ iqamaExpiryDate: member.idExpiry || "" },
                ...{
                  passportNo: member.depPassportNo,
                },
                ...{
                  passportExpiryDate: member.depPassportExpiry || "",
                },
                ...{ contactNo: member.depContactNo },
                ...{ dateOfBirth: member.depDob || "" },
                ...{
                  relation: member.depRelation?.value || "",
                },
                ...{
                  religion: member.depReligion?.value || "",
                },
                ...{
                  nationality: member.depNationality?.value || "",
                },
                ...{
                  sponsorName: member.depSponsorName,
                },
                ...{ sponsorId: member.depSponsorId },
                ...(member?.depCitizen && { citizen: member.depCitizen }),
                ...(member?.depMaritalStatus && {
                  maritalStatus: member.depMaritalStatus,
                }),
                ...(member?.depGender && { gender: member.depGender }),
              }))
            : null;

        draftData = {
          ...firstData,
          ...(!skippedSections.includes("employmentInfo") &&
            allEmployeeInfoFieldsPresent && { employeeInfo }),
          ...(documents && { documents: documents }),
          ...(dependentsInfo && { dependentsInfo }), // Only include if dependentsInfo is not null
        };
      }

      let publicId;
      let concurrencyStamp;
      if (latestPublicId && latestConcurrencyStamp) {
        publicId = latestPublicId;
        concurrencyStamp = latestConcurrencyStamp;
      }
      if (detailsStep < 5 && !latestPublicId) {
        setDraftLoading(true);
        const res = await addEmployeeMaster(draftData);
        if (res?.data) {
          const data = res?.data?.data;
          getEmployeeRegistrationData(data?.public_id);
          setIsNewEmpAdded(true);
          setDraftLoading(false);
          setDraftedData(data);
          setIsDraft(false);
          getEmployeeStats();
          getAdditionalStats();
          onClose();
          handleDraftSubmit();
          // if (detailsStep == 4) {
          //   onClose();
          //   handleDraftSubmit();
          // } else {
          //   notifySuccess("Employee Details Drafted Successfully");
          // }
          // setDetailsStep((prev) => prev + 1);
          handleGetTableData();
        }
      } else {
        setDraftLoading(true);
        const res = await updateEmployeeRegistrationMaster(
          draftData,
          publicId,
          concurrencyStamp
        );
        if (res?.data) {
          const data = res?.data?.data;
          setDraftLoading(false);
          setIsDraft(false);
          handleGetTableData();
          getEmployeeRegistrationData(latestPublicId);
          getEmployeeStats();
          getAdditionalStats();

          if (draftAndExit) {
            onClose();
            handleDraftSubmit();
          } else if (saveAndExit) {
            onClose();
            if (empPublicId) {
              handleSaveAndSubmitWhenUpdate();
            } else {
              handleSaveSubmit();
            }
          }

          // if (detailsStep == 4) {
          //   onClose();
          //   handleDraftSubmit();
          // } else if (detailsStep == 3) {
          //   notifySuccess("Employee Details Updated Successfully");
          //   if (isLastTab) {
          //     setDetailsStep((prev) => prev + 1);
          //   } else {
          //     setDocumnetTab(filteredTabs[currentIndex + 1]);
          //   }
          // } else {
          //   notifySuccess("Employee Details Updated Successfully");
          //   setDetailsStep((prev) => prev + 1);
          // }
        }
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    } finally {
      setIsDraft(false);
      setDraftLoading(false);
    }
  };

  const handleSubmitValues = async (submitValue) => {
    try {
      setSubmitLoading(true);
      const res = await addEmployeeMaster(submitValue);

      if (res?.data) {
        onClose();
        if (
          personalInfo?.userInvitation !== "true" &&
          submitValue?.userInvitation === "true"
        ) {
          handleOnSubmitInvited();
        } else {
          handleOnSubmit();
        }
        handleGetTableData();
        setSubmitLoading(false);
        // handleOnSumbit();
      } else {
        notifyWarn(res?.message || "Failed to add Employee");
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleUpdateEmployee = async (submitValue) => {
    let publicId = latestPublicId;
    let concurrencyStamp = latestConcurrencyStamp;
    try {
      setSubmitLoading(true);
      const res = await updateEmployeeRegistrationMaster(
        submitValue,
        publicId,
        concurrencyStamp
      );

      if (res?.data) {
        if (
          personalInfo?.userInvitation !== "true" &&
          submitValue?.userInvitation === "true"
        ) {
          handleOnUpdateInvited();
        } else {
          handleOnSubmit();
        }
        handleGetTableData();
        setSubmitLoading(false);
      } else {
        setSubmitLoading(false);
        notifyWarn(res?.message || "Failed to update Employee");
      }
    } catch (error) {
      notifyWarn(
        error?.response?.data?.message || "An unexpected error occurred"
      );
      console.error("Error", error);
    } finally {
      setSubmitLoading(false);
    }
  };

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback(countryOptions);
    } else {
      const filteredOptions = countryOptions.filter((option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      );
      callback(filteredOptions);
    }
  };

  const calculateTotalSalary = (values, setFieldValue) => {
    const totalSalary =
      (Number(values?.basicPay) || 0) +
      (Number(values?.housingAllows) || 0) +
      (Number(values?.transportAllows) || 0) +
      (Number(values?.foodAllows) || 0) +
      (Number(values?.otherAllows) || 0);

    let gosiDeductionAmount = 0;

    if (values?.gosiDeduction) {
      gosiDeductionAmount =
        ((Number(values?.basicPay) || 0) +
          (Number(values?.housingAllows) || 0)) *
        (Number(values?.gosiDeduction) / 100);

      // Update the deductionAmount field dynamically
      setFieldValue("deductionAmount", gosiDeductionAmount.toFixed(2));
    }

    const totalAfterGosi = totalSalary - gosiDeductionAmount;
    const totalSalaryString = totalAfterGosi.toString();

    setTotalSalary(totalSalaryString);
    return totalSalaryString;
  };

  const formatDateToYYYYMMDD = (date) => {
    if (!date) return "";

    const isISODate = /^\d{4}-\d{2}-\d{2}T/.test(date);
    const isDDMMYYYY = /^\d{2}\/\d{2}\/\d{4}$/.test(date);
    const isYYYYMMDD = /^\d{4}-\d{2}-\d{2}$/.test(date);

    let formattedDate = "";

    if (isISODate) {
      formattedDate = new Date(date).toISOString().split("T")[0];
    } else if (isDDMMYYYY) {
      const [day, month, year] = date.split("/");
      formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
        2,
        "0"
      )}`;
    } else if (isYYYYMMDD) {
      formattedDate = date;
    }

    return formattedDate;
  };

  const convertDateForPayload = (dateString) => {
    if (!dateString || typeof dateString !== "string") {
      return ""; // Return empty string for invalid input
    }

    // Check if the input is in ISO format (e.g., "2000-01-01T00:00:00.000Z")
    if (dateString.includes("T")) {
      return dateString; // Return as is for ISO format
    }

    // Otherwise, assume the input is in "DD-MM-YYYY" format
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
  };

  const isAtLeast18YearsOld = (dateString, isHijri = false) => {
    if (!dateString) return false;

    let date;

    if (isHijri) {
      // For Hijri dates, convert to Gregorian first
      const [day, month, year] = dateString.split("-").map(Number);
      const gregorianDate = toGregorian(year, month, day);
      date = new Date(gregorianDate.gy, gregorianDate.gm - 1, gregorianDate.gd);
    } else {
      // For Gregorian dates
      date = new Date(dateString);
    }

    if (isNaN(date.getTime())) return false;

    const today = new Date();
    const eighteenYearsAgo = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate()
    );

    return date <= eighteenYearsAgo;
  };

  const convertAndFormatHijriDate = (dateString) => {
    // If the input is empty or invalid, return an empty string or a default value
    if (!dateString || typeof dateString !== "string") {
      return ""; // or return a default value like "DD-MM-YYYY"
    }

    // Check if the input is in ISO format (e.g., "1446-09-15T00:00:00.000Z")
    if (dateString.includes("T")) {
      // Extract the date part (YYYY-MM-DD) from the ISO string
      const datePart = dateString.split("T")[0];
      const [year, month, day] = datePart.split("-");

      // Validate year, month, and day
      if (!year || !month || !day) {
        return ""; // or return a default value like "DD-MM-YYYY"
      }

      // Format as "DD-MM-YYYY"
      return `${day}-${month}-${year}`;
    } else {
      // Check if the input is already in "DD-MM-YYYY" format
      const dateParts = dateString.split("-");
      if (
        dateParts.length === 3 &&
        dateParts[0].length === 2 &&
        dateParts[1].length === 2 &&
        dateParts[2].length === 4
      ) {
        return dateString; // Return as is if already in "DD-MM-YYYY" format
      } else {
        return ""; // or return a default value like "DD-MM-YYYY"
      }
    }
  };

  const convertHijriToGregorian = (
    hijriDate,
    setFieldValue,
    setDobHijriError
  ) => {
    // Split the input Hijri date into day, month, and year
    const [day, month, year] = hijriDate.split("-").map(Number);

    // Validate the Hijri date inputs
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      console.error(
        "Invalid Hijri date format. Please provide a valid date in the format DD-MM-YYYY."
      );
      return null;
    }

    // Validate the Hijri year, month, and day
    if (year < 1 || month < 1 || month > 12 || day < 1 || day > 30) {
      console.error(
        "Invalid Hijri date. Please provide a valid date within the correct range."
      );
      return null; // Do not set the value if the date is invalid
    }

    // Convert Hijri to Gregorian
    const gregorianDate = toGregorian(year, month, day);

    // Check if the conversion was successful and the Gregorian date is valid
    if (
      !gregorianDate ||
      isNaN(gregorianDate.gy) ||
      isNaN(gregorianDate.gm) ||
      isNaN(gregorianDate.gd) ||
      gregorianDate.gy < 1 || // Year must be positive
      gregorianDate.gm < 1 ||
      gregorianDate.gm > 12 || // Month must be between 1 and 12
      gregorianDate.gd < 1 ||
      gregorianDate.gd > 31 // Day must be between 1 and 31
    ) {
      console.error("Conversion failed. Invalid Gregorian date object.");
      setFieldValue("dobGregorian", "");
      return null; // Do not set the value if conversion fails
    }

    // Format the Gregorian date as YYYY-MM-DD

    const formattedGregorianDate = `${gregorianDate.gy}-${String(
      gregorianDate.gm
    ).padStart(2, "0")}-${String(gregorianDate.gd).padStart(2, "0")}`;

    // Optionally, update a field dynamically (if needed)
    if (setFieldValue) {
      setFieldValue("dobGregorian", formattedGregorianDate);
    }

    return formattedGregorianDate;
  };

  const convertGregorianToHijri = (
    gregorianDate,
    setFieldValue,
    setDobGregorianError
  ) => {
    // Split the input Gregorian date into year, month, and day
    const [year, month, day] = gregorianDate.split("-").map(Number);

    // Validate the Gregorian date inputs
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      console.error(
        "Invalid Gregorian date format. Please provide a valid date in the format YYYY-MM-DD."
      );
      return null;
    }

    // Convert Gregorian to Hijri
    const hijriDate = toHijri(year, month, day);

    // Check if any part of the Hijri date is NaN
    if (isNaN(hijriDate.hy) || isNaN(hijriDate.hm) || isNaN(hijriDate.hd)) {
      console.error("Invalid Hijri date conversion. Skipping value update.");
      setFieldValue("dobHijri", "");
      return null; // Do not set the value if conversion fails
    }

    // Format the Hijri date as DD-MM-YYYY
    const formattedHijriDate = `${String(hijriDate.hd).padStart(
      2,
      "0"
    )}-${String(hijriDate.hm).padStart(2, "0")}-${hijriDate.hy}`;

    // Optionally, update a field dynamically (if needed)
    if (setFieldValue) {
      setFieldValue("dobHijri", formattedHijriDate);
    }

    return formattedHijriDate;
  };

  const asyncSelectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "56px",
      paddingInline: "6px", // logical replacement for padding-left/right
      borderRadius: "8px",
      display: "flex",
      justifyContent: "space-between",
      background: "#f9fafb",
      border: "1px solid #eaecf0",
      fontFamily: "Poppins, sans-serif",
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "18px",
      textAlign: "start", // logical replacement for text-align: left
      color: "#111827",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#A0A0A0",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#04080b",
      marginInlineStart: "0", // logical replacement for margin-left
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      zIndex: 3,
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? "#f3f4f6" : "#fff",
      color: "#04080b",
      paddingBlock: "10px", // logical replacement for padding-top/bottom
      paddingInline: "16px", // logical replacement for padding-left/right
      cursor: "pointer",
      fontSize: "12px",
      lineHeight: "18px",
      textAlign: "start", // logical replacement for text-align: left
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
    }),
  };

  const asyncSelectStylesPortal = getAsyncSelectStylesForm({
    usePortal: true, // Enable portal rendering
  });

  const portalProps = getAsyncSelectPortalProps(true);

  if (!isOpen) return null;

  return (
    <div className="add-modal-overlay">
      <Formik
        initialValues={formValues}
        enableReinitialize
        validateOnChange={true}
        validationSchema={getValidationSchema(detailsStep)}
        onSubmit={(values, actions) => handleNextStep(values, actions)}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form
            onClick={(e) => e.stopPropagation()}
            className="add-modal-content"
            style={
              detailsStep === 4 && values?.isDependents == "true"
                ? { maxWidth: "1370px" }
                : undefined
            }
          >
            <div className="add-modal-header">
              <span className="add-modal-title">
                {empPublicId ? t("Edit Employee") : t("Add New Employee")}
              </span>
              <div
                className="add-modal-icon-container"
                onClick={onCloseWarning}
              >
                <img src={cancelIcon} alt="cancel icon" />
              </div>
            </div>
            <div className="add-subheader">
              <div className="add-steps-container">
                <div
                  className={`add-step-content ${
                    detailsStep === 1 ? "active" : ""
                  }`}
                >
                  <div className={`add-step-no`}>1</div>
                  <span className="add-step-heading">{t("Personal Info")}</span>
                </div>
                <div
                  className={`add-step-content ${
                    detailsStep === 2 ? "active" : ""
                  }`}
                >
                  <div className="add-step-no">2</div>
                  <span className="add-step-heading">
                    {t("Employment Info")}
                  </span>
                </div>
                <div
                  className={`add-step-content ${
                    detailsStep === 3 ? "active" : ""
                  }`}
                >
                  <div className="add-step-no">3</div>
                  <span className="add-step-heading">{t("Documents")}</span>
                </div>
                <div
                  className={`add-step-content ${
                    detailsStep === 4 ? "active" : ""
                  }`}
                >
                  <div className="add-step-no">4</div>
                  <span className="add-step-heading">
                    {t("Dependents Info")}
                  </span>
                </div>
              </div>
              {detailsStep !== 3 && !empPublicId && (
                <p
                  style={detailsStep === 4 ? { maxWidth: "752px" } : undefined}
                  className="add-desc"
                >
                  {t(
                    "Fill in the details below to add a new employee to your team. Once added, you can manage their profile, roles, and permissions seamlessly."
                  )}
                </p>
              )}
            </div>
            {dataLoading ? (
              <div className="">
                <PageLoader />
              </div>
            ) : (
              <>
                <div className="add-body">
                  {detailsStep === 1 ? (
                    <div className="add-body-content-container margin-rm">
                      <div className="add-body-content-header">
                        <h3 className="add-body-content-heading">
                          {t("Personal Info")}
                        </h3>
                        {/* <div className="relative">
                          <select
                            value={values.lang}
                            onChange={(e) =>
                              setFieldValue("lang", e.target.value)
                            }
                            className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                          >
                            <option value="en">English</option>
                            <option value="ar">Arabic</option>
                          </select>
                          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                            <DropDownIcon />
                          </span>
                        </div> */}
                      </div>
                      <div className="add-body-content-grid">
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="firstName">
                                {t("Employee First Name (EN)")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            <input
                              id="firstName"
                              name="firstName"
                              className="add-input"
                              placeholder={t("First Name (EN)")}
                              value={values?.firstName}
                              onChange={(e) => {
                                setFieldValue("firstName", e.target.value);
                                // setFieldTouched("firstName", true);
                              }}
                              onBlur={handleBlur}
                            />
                          </div>
                          <CustomErrorMessage
                            name="firstName"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="firstNameArb"
                              >
                                {t("Employee First Name (AR)")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            <input
                              id="firstNameArb"
                              name="firstNameArb"
                              className="add-input"
                              placeholder={t("First Name (AR)")}
                              value={values?.firstNameArb}
                              onChange={(e) => {
                                setFieldValue("firstNameArb", e.target.value);
                                // setFieldTouched("firstNameArb", true);
                              }}
                              onBlur={handleBlur}
                            />
                          </div>
                          <CustomErrorMessage
                            name="firstNameArb"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="secondName">
                                {t("Employee Second Name (EN)")}
                              </label>
                            </div>
                            <input
                              id="secondName"
                              name="secondName"
                              className="add-input"
                              placeholder={t("Second Name (EN)")}
                              value={values?.secondName}
                              onChange={(e) =>
                                setFieldValue("secondName", e.target.value)
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                          <CustomErrorMessage
                            name="secondName"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="secondName">
                                {t("Employee Second Name (AR)")}
                              </label>
                            </div>
                            <input
                              id="secondNameArb"
                              name="secondNameArb"
                              className="add-input"
                              placeholder={t("Second Name (AR)")}
                              value={values?.secondNameArb}
                              onChange={(e) =>
                                setFieldValue("secondNameArb", e.target.value)
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                          <CustomErrorMessage
                            name="secondNameArb"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="thirdName">
                                {t("Employee Third Name (EN)")}
                              </label>
                            </div>
                            <input
                              id="thirdName"
                              name="thirdName"
                              className="add-input"
                              placeholder={t("Third Name (EN)")}
                              value={values?.thirdName}
                              onChange={(e) =>
                                setFieldValue("thirdName", e.target.value)
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                          <CustomErrorMessage
                            name="thirdName"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="thirdNameArb"
                              >
                                {t("Employee Third Name (AR)")}
                              </label>
                            </div>
                            <input
                              id="thirdNameArb"
                              name="thirdNameArb"
                              className="add-input"
                              placeholder={t("Third Name (AR)")}
                              value={values?.thirdNameArb}
                              onChange={(e) =>
                                setFieldValue("thirdNameArb", e.target.value)
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                          <CustomErrorMessage
                            name="thirdNameArb"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="lastName">
                                {t("Employee Last Name (EN)")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            <input
                              id="lastName"
                              name="lastName"
                              className="add-input"
                              placeholder={t("Last Name (EN)")}
                              value={values?.lastName}
                              onChange={(e) =>
                                setFieldValue("lastName", e.target.value)
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                          <CustomErrorMessage
                            name="lastName"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="lastNameArb"
                              >
                                {t("Employee Last Name (AR)")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            <input
                              id="lastNameArb"
                              name="lastNameArb"
                              className="add-input"
                              placeholder={t("Last Name (EN)")}
                              value={values?.lastNameArb}
                              onChange={(e) =>
                                setFieldValue("lastNameArb", e.target.value)
                              }
                              onBlur={handleBlur}
                            />
                          </div>
                          <CustomErrorMessage
                            name="lastNameArb"
                            errors={errors}
                            touched={touched}
                          />
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="personalEmail"
                              >
                                {t("Personal Email")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>{values?.personalEmail || "-"}</span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <input
                                id="personalEmail"
                                name="personalEmail"
                                className="add-input"
                                placeholder={t("Enter Personal Email")}
                                value={values?.personalEmail}
                                onChange={(e) =>
                                  handlePersonalEmailChange(e, setFieldValue)
                                }
                                onBlur={handleBlur}
                              />
                            )}
                          </div>

                          <ValidateIndicators
                            isSearching={personalEmailSearch.isSearching}
                            validationResult={
                              personalEmailSearch.validationResult
                            }
                            error={personalEmailSearch.error}
                          />
                          <CustomErrorMessage
                            name="personalEmail"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="email">
                                {t("Email")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>{values?.email || "-"}</span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <input
                                id="email"
                                name="email"
                                className="add-input"
                                placeholder={t("Enter Email")}
                                value={values?.email}
                                onChange={(e) =>
                                  handleEmailChange(e, setFieldValue)
                                }
                                onBlur={handleBlur}
                              />
                            )}
                          </div>

                          <ValidateIndicators
                            isSearching={emailSearch.isSearching}
                            validationResult={emailSearch.validationResult}
                            error={emailSearch.error}
                          />
                          <CustomErrorMessage
                            name="email"
                            errors={errors}
                            touched={touched}
                          />
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="phone">
                                {t("Contact Number")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>{" "}
                            <div
                              className="phone-input-container"
                              style={{ display: "flex" }}
                            >
                              <input
                                id="phone"
                                name="phone"
                                className="add-input"
                                placeholder={t("Enter Saudi Mobile Number")}
                                value={values?.phone}
                                onChange={(e) =>
                                  handlePhoneChange(e, setFieldValue)
                                }
                                onBlur={handleBlur}
                              />
                            </div>
                          </div>
                          <ValidateIndicators
                            isSearching={phoneSearch.isSearching}
                            validationResult={phoneSearch.validationResult}
                            error={phoneSearch.error}
                          />
                          <CustomErrorMessage
                            name="phone"
                            errors={errors}
                            touched={touched}
                          />
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="dobGregorian"
                              >
                                {t("Date Of Birth (Gregorian)")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            <div className="add-input-wrapper">
                              <input
                                type="date"
                                id="dobGregorian"
                                name="dobGregorian"
                                className={`add-wrap-input ${
                                  !values?.dobGregorian ||
                                  values.dobGregorian === "DD-MM-YYYY"
                                    ? "empty"
                                    : ""
                                }`}
                                placeholder="DD/MM/YYYY"
                                value={
                                  values?.dobGregorian
                                    ? formatDateToYYYYMMDD(values.dobGregorian)
                                    : ""
                                }
                                onChange={(e) => {
                                  convertGregorianToHijri(
                                    e.target.value,
                                    setFieldValue,
                                    setDobGregorianError
                                  );
                                  setFieldValue("dobGregorian", e.target.value);
                                }}
                                onBlur={handleBlur}
                              />
                              <img
                                src={dateIcon}
                                alt="date icon"
                                className="add-date-input-in"
                              />
                            </div>
                          </div>
                          <CustomErrorMessage
                            name="dobGregorian"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="dobHijri">
                                {t("Date Of Birth (Hijri)")}
                              </label>
                            </div>
                            <div className="add-input-wrapper">
                              <HijriDatePicker
                                value={
                                  values.dobHijri
                                    ? convertAndFormatHijriDate(values.dobHijri)
                                    : ""
                                } // Pass the Formik value
                                onChange={(date) => {
                                  convertHijriToGregorian(
                                    date,
                                    setFieldValue,
                                    setDobHijriError
                                  );
                                  setFieldValue("dobHijri", date); // Update Formik value
                                }}
                                onBlur={handleBlur}
                              />
                              {/* <img
                            src={dateIcon}
                            alt="date icon"
                            className="add-input-in"
                          /> */}
                            </div>
                          </div>
                          <CustomErrorMessage
                            name="dobHijri"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="religion">
                                {t("Religion")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            <AsyncSelect
                              id="religion"
                              name="religion"
                              value={values.religion}
                              onChange={(selectedOption) =>
                                setFieldValue("religion", selectedOption)
                              }
                              loadOptions={onSearchReligionDebounce}
                              defaultOptions={religionOptions}
                              styles={asyncSelectStyles}
                              cacheOptions
                              placeholder={t("Select religion")}
                            />
                          </div>
                          <CustomErrorMessage
                            name="religion"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label">
                                {t("Marital Status")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            <div className="add-radio-input-container">
                              <div className="add-radio-container">
                                <input
                                  id="married"
                                  type="radio"
                                  name="maritalStatus"
                                  className="add-radio-input"
                                  value="Married" // Set the value directly
                                  onChange={(e) =>
                                    setFieldValue(
                                      "maritalStatus",
                                      e.target.value
                                    )
                                  }
                                  checked={values?.maritalStatus === "Married"} // Bind checked state
                                />
                                <label htmlFor="married" className="add-label">
                                  {t("Married")}
                                </label>
                              </div>
                              <div className="add-radio-container">
                                <input
                                  id="single"
                                  type="radio"
                                  name="maritalStatus"
                                  className="add-radio-input"
                                  value="Single"
                                  onChange={(e) =>
                                    setFieldValue(
                                      "maritalStatus",
                                      e.target.value
                                    )
                                  }
                                  checked={values?.maritalStatus === "Single"} // Bind checked state
                                />
                                <label htmlFor="single" className="add-label">
                                  {t("Single")}
                                </label>
                              </div>
                            </div>
                          </div>
                          <CustomErrorMessage
                            name="maritalStatus"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label">{t("Gender")}</label>
                              <span className="add-req-mark">*</span>
                            </div>
                            <div className="add-radio-input-container">
                              <div className="add-radio-container">
                                <input
                                  id="Male"
                                  type="radio"
                                  name="gender"
                                  className="add-radio-input"
                                  value="Male"
                                  onChange={(e) =>
                                    setFieldValue("gender", e.target.value)
                                  }
                                  checked={values?.gender === "Male"}
                                />
                                <label htmlFor="Male" className="add-label">
                                  {t("Male")}
                                </label>
                              </div>
                              <div className="add-radio-container">
                                <input
                                  id="Female"
                                  type="radio"
                                  name="gender"
                                  className="add-radio-input"
                                  value="Female"
                                  onChange={(e) =>
                                    setFieldValue("gender", e.target.value)
                                  }
                                  checked={values?.gender === "Female"}
                                />
                                <label htmlFor="Female" className="add-label">
                                  {t("Female")}
                                </label>
                              </div>
                            </div>
                          </div>
                          <CustomErrorMessage
                            name="gender"
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label">
                                {t("Citizen")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            <div className="add-radio-input-container">
                              <div className="add-radio-container">
                                <input
                                  id="yes"
                                  type="radio"
                                  name="citizen"
                                  className="add-radio-input"
                                  value="true"
                                  onChange={(e) =>
                                    setFieldValue("citizen", e.target.value)
                                  }
                                  checked={values?.citizen === "true"}
                                />
                                <label htmlFor="yes" className="add-label">
                                  {t("Yes")}
                                </label>
                              </div>
                              <div className="add-radio-container">
                                <input
                                  id="no"
                                  type="radio"
                                  name="citizen"
                                  className="add-radio-input"
                                  value="false"
                                  onChange={(e) =>
                                    setFieldValue("citizen", e.target.value)
                                  }
                                  checked={values?.citizen === "false"}
                                />
                                <label htmlFor="false" className="add-label">
                                  {t("No")}
                                </label>
                              </div>
                            </div>
                          </div>
                          <CustomErrorMessage
                            name="citizen"
                            errors={errors}
                            touched={touched}
                          />
                        </div>

                        {values?.citizen === "true" ? (
                          <>
                            <div className="form-group">
                              <div className="add-body-input-section">
                                <div className="add-label-container">
                                  <label
                                    className="add-label"
                                    htmlFor="nationalId"
                                  >
                                    {t("National ID")}
                                  </label>
                                  <span className="add-req-mark">*</span>
                                </div>
                                <input
                                  id="nationalId"
                                  name="nationalId"
                                  className="add-input"
                                  placeholder={t("Enter National ID")}
                                  value={values?.nationalId}
                                  onChange={(e) =>
                                    handleNationalIdChange(e, setFieldValue)
                                  }
                                  onBlur={handleBlur}
                                />
                              </div>
                              <ValidateIndicators
                                isSearching={nationalIdSearch.isSearching}
                                validationResult={
                                  nationalIdSearch.validationResult
                                }
                                error={nationalIdSearch.error}
                              />
                              <CustomErrorMessage
                                name="nationalId"
                                errors={errors}
                                touched={touched}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="form-group">
                              <div className="add-body-input-section">
                                <div className="add-label-container">
                                  <label
                                    className="add-label"
                                    htmlFor="nationality"
                                  >
                                    {t("Nationality")}
                                  </label>
                                  <span className="add-req-mark">*</span>
                                </div>
                                <AsyncSelect
                                  id="nationality"
                                  name="nationality"
                                  value={values.nationality}
                                  onChange={(selectedOption) =>
                                    setFieldValue("nationality", selectedOption)
                                  }
                                  loadOptions={loadOptions}
                                  defaultOptions={countryOptions}
                                  styles={asyncSelectStylesPortal}
                                  {...portalProps}
                                  cacheOptions
                                  placeholder={t("Select nationality")}
                                />
                              </div>
                              <CustomErrorMessage
                                name="nationality"
                                errors={errors}
                                touched={touched}
                              />
                            </div>
                          </>
                        )}
                      </div>
                      <div className="form-group">
                        <div className="add-body-input-section">
                          <div className="add-label-container">
                            <label
                              className="add-label"
                              htmlFor="profilePicture"
                            >
                              {t("Profile Picture")}
                            </label>
                          </div>
                          <div className="space-y-2">
                            {values?.profilePicture?.fileUrl ? (
                              <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                                <img
                                  src={values.profilePicture.fileUrl}
                                  alt="Profile"
                                  className="w-16 h-16 rounded-full object-cover border-2 border-gray-300"
                                />
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm text-gray-700 truncate">
                                    {values.profilePicture.fileName ||
                                      "Profile picture uploaded"}
                                  </p>
                                </div>
                                <div className="flex gap-2">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setDocumentViewerState({
                                        isOpen: true,
                                        url: values.profilePicture.fileUrl,
                                        fileName:
                                          values.profilePicture.fileName ||
                                          "Profile Picture",
                                      });
                                    }}
                                    className="px-3 py-1.5 text-xs font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-md transition-colors"
                                  >
                                    {t("View")}
                                  </button>
                                  <label
                                    htmlFor="profilePictureReplace"
                                    className="px-3 py-1.5 text-xs font-medium text-[#B99A51] hover:text-[#156268] hover:bg-yellow-50 rounded-md transition-colors cursor-pointer"
                                  >
                                    {t("Replace")}
                                  </label>
                                  <input
                                    type="file"
                                    id="profilePictureReplace"
                                    accept="image/jpeg,image/jpg,image/png"
                                    className="hidden"
                                    onChange={async (e) => {
                                      const file = e.target.files?.[0];
                                      setProfilePictureError("");

                                      if (file) {
                                        const validTypes = [
                                          "image/jpeg",
                                          "image/jpg",
                                          "image/png",
                                        ];
                                        if (!validTypes.includes(file.type)) {
                                          setProfilePictureError(
                                            t(
                                              "Please upload only JPG, JPEG or PNG images"
                                            )
                                          );
                                          e.target.value = "";
                                          return;
                                        }

                                        const maxSize = 5 * 1024 * 1024;
                                        if (file.size > maxSize) {
                                          setProfilePictureError(
                                            t("File size must be less than 5MB")
                                          );
                                          e.target.value = "";
                                          return;
                                        }

                                        try {
                                          const response = await fileUpload(
                                            file
                                          );

                                          if (response?.data?.data?.[0]) {
                                            const { fileName, fileUrl } =
                                              response.data.data[0];
                                            setFieldValue("profilePicture", {
                                              fileName,
                                              fileUrl,
                                            });
                                            setProfilePictureError("");
                                          }
                                        } catch (error) {
                                          console.error(
                                            "Profile picture upload failed:",
                                            error
                                          );
                                          setProfilePictureError(
                                            t(
                                              "Failed to upload profile picture. Please try again."
                                            )
                                          );
                                        }
                                      }
                                      e.target.value = ""; // Reset input
                                    }}
                                  />
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setFieldValue("profilePicture", {
                                        fileName: "",
                                        fileUrl: "",
                                      });
                                      setProfilePictureError("");
                                    }}
                                    className="px-3 py-1.5 text-xs font-medium text-red-600 hover:text-red-700 hover:bg-red-50 rounded-md transition-colors"
                                  >
                                    {t("Delete")}
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div
                                className={`relative border-2 border-dashed rounded-lg p-8 text-center transition-colors ${
                                  profilePictureError
                                    ? "border-red-300 bg-red-50"
                                    : "border-gray-300 hover:border-gray-400"
                                }`}
                              >
                                <input
                                  type="file"
                                  id="profilePicture"
                                  name="profilePicture"
                                  accept="image/jpeg,image/jpg,image/png"
                                  className="hidden"
                                  onChange={async (e) => {
                                    const file = e.target.files?.[0];
                                    setProfilePictureError(""); // Clear previous errors

                                    if (file) {
                                      // Validate file type
                                      const validTypes = [
                                        "image/jpeg",
                                        "image/jpg",
                                        "image/png",
                                      ];
                                      if (!validTypes.includes(file.type)) {
                                        setProfilePictureError(
                                          t(
                                            "Please upload only JPG, JPEG or PNG images"
                                          )
                                        );
                                        e.target.value = "";
                                        return;
                                      }

                                      // Validate file size (5MB max)
                                      const maxSize = 5 * 1024 * 1024;
                                      if (file.size > maxSize) {
                                        setProfilePictureError(
                                          t("File size must be less than 5MB")
                                        );
                                        e.target.value = "";
                                        return;
                                      }

                                      try {
                                        const response = await fileUpload(file);

                                        if (response?.data?.data?.[0]) {
                                          const { fileName, fileUrl } =
                                            response.data.data[0];
                                          setFieldValue("profilePicture", {
                                            fileName,
                                            fileUrl,
                                          });
                                          setProfilePictureError("");
                                        }
                                      } catch (error) {
                                        console.error(
                                          "Profile picture upload failed:",
                                          error
                                        );
                                        setProfilePictureError(
                                          t(
                                            "Failed to upload profile picture. Please try again."
                                          )
                                        );
                                      }
                                    }
                                  }}
                                />
                                <label
                                  htmlFor="profilePicture"
                                  className="cursor-pointer"
                                >
                                  <div className="flex flex-col items-center gap-2">
                                    <svg
                                      className="w-10 h-10 text-gray-400"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                      />
                                    </svg>
                                    <div>
                                      <span className="text-blue-600 font-medium hover:underline">
                                        {t("Click to upload")}
                                      </span>
                                      <span className="text-gray-600">
                                        {" "}
                                        {t("or drag and drop")}
                                      </span>
                                    </div>
                                    <p className="text-xs text-gray-500">
                                      {t("JPG, JPEG, PNG up to 5MB")}
                                    </p>
                                  </div>
                                </label>
                              </div>
                            )}
                          </div>
                        </div>
                        {profilePictureError && (
                          <p className="text-red-500 text-sm mt-1">
                            {profilePictureError}
                          </p>
                        )}
                        <CustomErrorMessage
                          name="profilePicture"
                          errors={errors}
                          touched={touched}
                        />
                      </div>
                    </div>
                  ) : detailsStep === 2 ? (
                    <div className="add-body-content-container margin-rm">
                      <div className="add-body-content-header">
                        <h3 className="add-body-content-heading">
                          {t("Employment Information")}
                        </h3>
                        <div className="relative">
                          {/* <select
                            value={values.lang}
                            onChange={(e) =>
                              setFieldValue("lang", e.target.value)
                            }
                            className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                          >
                            <option value="en">English</option>
                            <option value="ar">Arabic</option>
                          </select> */}
                          {/* <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                            <DropDownIcon />
                          </span> */}
                        </div>
                      </div>
                      <div className="add-body-content-grid">
                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="branch">
                                {t("Branch / Location")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>{values?.branch?.label || "-"}</span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <AsyncSelect
                                id="branch"
                                name="branch"
                                value={values.branch}
                                onChange={(selectedOption) =>
                                  setFieldValue("branch", selectedOption)
                                }
                                loadOptions={onSearchBranchDebounce}
                                defaultOptions={branchOptions}
                                styles={asyncSelectStyles}
                                cacheOptions
                                placeholder={t("Select Branch")}
                              />
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="branch"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="role">
                                {t("Role")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>{values?.role?.label || "-"}</span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <AsyncSelect
                                id="role"
                                name="role"
                                value={values.role}
                                onChange={(selectedOption) =>
                                  setFieldValue("role", selectedOption)
                                }
                                loadOptions={onSearchRoleDebounce}
                                defaultOptions={roleOptions}
                                styles={asyncSelectStyles}
                                cacheOptions
                                placeholder={t("Select Role")}
                              />
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="role"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="jobTitle">
                                {t("Job Title")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>{values?.jobTitle?.label || "-"}</span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <AsyncSelect
                                id="jobTitle"
                                name="jobTitle"
                                value={values.jobTitle}
                                onChange={(selectedOption) =>
                                  setFieldValue("jobTitle", selectedOption)
                                }
                                loadOptions={onSearchJobTitleDebounce}
                                defaultOptions={jobTitleOptions}
                                styles={asyncSelectStyles}
                                cacheOptions
                                placeholder={t("Select Job Title")}
                              />
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="jobTitle"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="designation"
                              >
                                {t("Designation")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>{values?.designation?.label || "-"}</span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <AsyncSelect
                                id="designation"
                                name="designation"
                                value={values.designation}
                                onChange={(selectedOption) =>
                                  setFieldValue("designation", selectedOption)
                                }
                                loadOptions={onSearchDesignationDebounce}
                                defaultOptions={designationOptions}
                                styles={asyncSelectStyles}
                                cacheOptions
                                placeholder={t("Select Designation")}
                              />
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="designation"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="department">
                                {t("Department")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>{values?.department?.label || "-"}</span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <AsyncSelect
                                id="department"
                                name="department"
                                value={values.department}
                                onChange={(selectedOption) =>
                                  setFieldValue("department", selectedOption)
                                }
                                loadOptions={onSearchDepartmentDebounce}
                                defaultOptions={departmentOptions}
                                styles={asyncSelectStyles}
                                cacheOptions
                                placeholder={t("Select Department")}
                              />
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="department"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="reportingTo"
                              >
                                {t("Reporting To")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>{values?.reportingTo?.label || "-"}</span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <AsyncSelect
                                id="reportingTo"
                                name="reportingTo"
                                value={values.reportingTo}
                                onChange={(selectedOption) =>
                                  setFieldValue("reportingTo", selectedOption)
                                }
                                loadOptions={onSearchReportingToDebounce}
                                defaultOptions={reportingTo}
                                styles={asyncSelectStyles}
                                cacheOptions
                                placeholder={t("Select Manager")}
                              />
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="reportingTo"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="joiningDate"
                              >
                                {t("Joining Date")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>{values?.joiningDate || "-"}</span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <div className="add-input-wrapper">
                                <input
                                  type="date"
                                  id="joiningDate"
                                  name="joiningDate"
                                  className={`add-wrap-input ${
                                    !values?.joiningDate ||
                                    values.joiningDate === "DD-MM-YYYY"
                                      ? "empty"
                                      : ""
                                  }`}
                                  placeholder="DD/MM/YYYY"
                                  value={
                                    values?.joiningDate
                                      ? formatDateToYYYYMMDD(values.joiningDate)
                                      : ""
                                  }
                                  onChange={(e) =>
                                    setFieldValue("joiningDate", e.target.value)
                                  }
                                  onBlur={handleBlur}
                                />
                                <img
                                  src={dateIcon}
                                  alt="date icon"
                                  className="add-date-input-in"
                                />
                              </div>
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="joiningDate"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label className="add-label" htmlFor="jobGrade">
                                {t("Job Grade")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>{values?.jobGrade?.label || "-"}</span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <AsyncSelect
                                id="jobGrade"
                                name="jobGrade"
                                value={values.jobGrade}
                                onChange={(selectedOption) =>
                                  setFieldValue("jobGrade", selectedOption)
                                }
                                loadOptions={onSearchJobGradeDebounce}
                                defaultOptions={jobGradeOptions}
                                styles={asyncSelectStyles}
                                cacheOptions
                                placeholder={t("Select Job Grade")}
                              />
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="jobGrade"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="contractType"
                              >
                                {t("Contract Type")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>
                                  {values?.contractType?.label || "-"}
                                </span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <AsyncSelect
                                id="contractType"
                                name="contractType"
                                value={values.contractType}
                                onChange={(selectedOption) =>
                                  setFieldValue("contractType", selectedOption)
                                }
                                loadOptions={loadContractTypeOptions}
                                defaultOptions={contractType}
                                styles={asyncSelectStyles}
                                cacheOptions
                                placeholder={t("Select Contract Type")}
                              />
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="contractType"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="probationPeriod"
                              >
                                {t("Probation Period")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>
                                  {values?.probationPeriod
                                    ? `${values.probationPeriod} days`
                                    : "-"}
                                </span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <input
                                id="probationPeriod"
                                name="probationPeriod"
                                className="add-input"
                                placeholder={t(
                                  "Enter Probation Period in Days"
                                )}
                                type="number"
                                min="1"
                                max="180"
                                value={values?.probationPeriod}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (
                                    /^\d*$/.test(value) &&
                                    Number(value) <= 180
                                  ) {
                                    setFieldValue("probationPeriod", value);
                                  }
                                }}
                                onBlur={handleBlur}
                              />
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="probationPeriod"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>

                        <div className="form-group">
                          <div className="add-body-input-section">
                            <div className="add-label-container">
                              <label
                                className="add-label"
                                htmlFor="employementType"
                              >
                                {t("Employment Type")}
                              </label>
                              <span className="add-req-mark">*</span>
                            </div>
                            {currentEmployeeEditing ? (
                              <div className="add-input-value">
                                <span>
                                  {values?.employmentType?.label || "-"}
                                </span>
                                <span className="add-input-badge">
                                  {noEditingMsg}
                                </span>
                              </div>
                            ) : (
                              <AsyncSelect
                                id="employmentType"
                                name="employmentType"
                                value={values.employmentType}
                                onChange={(selectedOption) =>
                                  setFieldValue(
                                    "employmentType",
                                    selectedOption
                                  )
                                }
                                loadOptions={loadEmploymentTypeOptions}
                                defaultOptions={employmentType}
                                styles={asyncSelectStyles}
                                cacheOptions
                                placeholder={t("Select Employment Type")}
                              />
                            )}
                          </div>
                          {!currentEmployeeEditing && (
                            <CustomErrorMessage
                              name="employmentType"
                              errors={errors}
                              touched={touched}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  ) : detailsStep === 3 ? (
                    <>
                      <div className="add-tabs-container">
                        {docsTabs
                          ?.filter((tab) => {
                            if (values?.citizen === "true") {
                              return tab !== "Iqama" && tab !== "Visa"; // Hide 'iqama' and 'visa' if citizen is true
                            } else {
                              return tab !== "National ID"; // hide national id for non-citizen
                            }
                          })
                          .map((tab, index) => (
                            <div
                              key={tab}
                              className={`add-tab ${
                                documentTab === tab ? "active" : ""
                              }`}
                              // onClick={() => setDocumnetTab(tab)}
                            >
                              {t(tab)}
                            </div>
                          ))}
                      </div>
                      {documentTab === "Salary Details" ? (
                        <>
                          <div className="add-details-type-container"></div>
                          <div className="add-body-content-container">
                            <div className="add-body-content-header">
                              <h3 className="add-body-content-heading">
                                {t("Salary Details")}
                              </h3>
                              <div className="relative">
                                {/* <select
                                  value={values.lang}
                                  onChange={(e) =>
                                    setFieldValue("lang", e.target.value)
                                  }
                                  className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                >
                                  <option value="en">English</option>
                                  <option value="ar">Arabic</option>
                                </select> */}
                                {/* <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                  <DropDownIcon />
                                </span> */}
                              </div>
                            </div>
                            <div className="add-body-content-grid">
                              <div className="form-group">
                                <div className="add-body-input-section">
                                  <div className="add-label-container">
                                    <label
                                      className="add-label"
                                      htmlFor="basicPay"
                                    >
                                      {t("Basic Pay")}
                                    </label>
                                    <span className="add-req-mark">*</span>
                                  </div>
                                  {currentEmployeeEditing ? (
                                    <div className="add-input-value">
                                      <span>
                                        {values?.basicPay
                                          ? `${values.basicPay} SAR`
                                          : "-"}
                                      </span>
                                      <span className="add-input-badge">
                                        {noEditingMsg}
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="add-input-wrapper">
                                      <input
                                        id="basicPay"
                                        name="basicPay"
                                        className="add-wrap-input"
                                        placeholder="0"
                                        maxLength={10}
                                        value={values?.basicPay}
                                        onChange={(e) =>
                                          setFieldValue(
                                            "basicPay",
                                            e.target.value
                                          )
                                        }
                                        onBlur={handleBlur}
                                      />
                                      <span className="add-input-in">
                                        {t("SAR")}
                                      </span>
                                    </div>
                                  )}
                                </div>
                                {!currentEmployeeEditing && (
                                  <CustomErrorMessage
                                    name="basicPay"
                                    errors={errors}
                                    touched={touched}
                                  />
                                )}
                              </div>

                              <div className="form-group">
                                <div className="add-body-input-section">
                                  <div className="add-label-container">
                                    <label
                                      className="add-label"
                                      htmlFor="housingAllows"
                                    >
                                      {t("Housing Allows")}
                                    </label>
                                    <span className="add-req-mark">*</span>
                                  </div>
                                  {currentEmployeeEditing ? (
                                    <div className="add-input-value">
                                      <span>
                                        {values?.housingAllows
                                          ? `${values.housingAllows} SAR`
                                          : "-"}
                                      </span>
                                      <span className="add-input-badge">
                                        {noEditingMsg}
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="add-input-wrapper">
                                      <input
                                        id="housingAllows"
                                        name="housingAllows"
                                        className="add-wrap-input"
                                        placeholder="0"
                                        maxLength={10}
                                        value={values?.housingAllows}
                                        onChange={(e) =>
                                          setFieldValue(
                                            "housingAllows",
                                            e.target.value
                                          )
                                        }
                                        onBlur={handleBlur}
                                      />
                                      <span className="add-input-in">
                                        {t("SAR")}
                                      </span>
                                    </div>
                                  )}
                                </div>
                                {!currentEmployeeEditing && (
                                  <CustomErrorMessage
                                    name="housingAllows"
                                    errors={errors}
                                    touched={touched}
                                  />
                                )}
                              </div>

                              <div className="form-group">
                                <div className="add-body-input-section">
                                  <div className="add-label-container">
                                    <label
                                      className="add-label"
                                      htmlFor="transportAllows"
                                    >
                                      {t("Transport Allows")}
                                    </label>
                                    <span className="add-req-mark">*</span>
                                  </div>
                                  {currentEmployeeEditing ? (
                                    <div className="add-input-value">
                                      <span>
                                        {values?.transportAllows
                                          ? `${values.transportAllows} SAR`
                                          : "-"}
                                      </span>
                                      <span className="add-input-badge">
                                        {noEditingMsg}
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="add-input-wrapper">
                                      <input
                                        id="transportAllows"
                                        name="transportAllows"
                                        className="add-wrap-input"
                                        placeholder="0"
                                        maxLength={10}
                                        value={values?.transportAllows}
                                        onChange={(e) =>
                                          setFieldValue(
                                            "transportAllows",
                                            e.target.value
                                          )
                                        }
                                        onBlur={handleBlur}
                                      />
                                      <span className="add-input-in">
                                        {t("SAR")}
                                      </span>
                                    </div>
                                  )}
                                </div>
                                {!currentEmployeeEditing && (
                                  <CustomErrorMessage
                                    name="transportAllows"
                                    errors={errors}
                                    touched={touched}
                                  />
                                )}
                              </div>

                              <div className="form-group">
                                <div className="add-body-input-section">
                                  <div className="add-label-container">
                                    <label
                                      className="add-label"
                                      htmlFor="foodAllows"
                                    >
                                      {t("Food Allows")}
                                    </label>
                                    <span className="add-req-mark">*</span>
                                  </div>
                                  {currentEmployeeEditing ? (
                                    <div className="add-input-value">
                                      <span>
                                        {values?.foodAllows
                                          ? `${values.foodAllows} SAR`
                                          : "-"}
                                      </span>
                                      <span className="add-input-badge">
                                        {noEditingMsg}
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="add-input-wrapper">
                                      <input
                                        id="foodAllows"
                                        name="foodAllows"
                                        className="add-wrap-input"
                                        placeholder="0"
                                        maxLength={10}
                                        value={values?.foodAllows}
                                        onChange={(e) =>
                                          setFieldValue(
                                            "foodAllows",
                                            e.target.value
                                          )
                                        }
                                        onBlur={handleBlur}
                                      />
                                      <span className="add-input-in">
                                        {t("SAR")}
                                      </span>
                                    </div>
                                  )}
                                </div>
                                {!currentEmployeeEditing && (
                                  <CustomErrorMessage
                                    name="foodAllows"
                                    errors={errors}
                                    touched={touched}
                                  />
                                )}
                              </div>

                              <div className="form-group">
                                <div className="add-body-input-section">
                                  <div className="add-label-container">
                                    <label
                                      className="add-label"
                                      htmlFor="otherAllows"
                                    >
                                      {t("Other Allows")}
                                    </label>
                                    <span className="add-req-mark">*</span>
                                  </div>
                                  {currentEmployeeEditing ? (
                                    <div className="add-input-value">
                                      <span>
                                        {values?.otherAllows
                                          ? `${values.otherAllows} SAR`
                                          : "-"}
                                      </span>
                                      <span className="add-input-badge">
                                        {noEditingMsg}
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="add-input-wrapper">
                                      <input
                                        id="otherAllows"
                                        name="otherAllows"
                                        className="add-wrap-input"
                                        placeholder="0"
                                        maxLength={10}
                                        value={values?.otherAllows}
                                        onChange={(e) =>
                                          setFieldValue(
                                            "otherAllows",
                                            e.target.value
                                          )
                                        }
                                        onBlur={handleBlur}
                                      />
                                      <span className="add-input-in">
                                        {t("SAR")}
                                      </span>
                                    </div>
                                  )}
                                </div>
                                {!currentEmployeeEditing && (
                                  <CustomErrorMessage
                                    name="otherAllows"
                                    errors={errors}
                                    touched={touched}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                          {values.citizen === "true" && (
                            <div className="add-body-content-container">
                              <div className="add-body-content-header">
                                <h3 className="add-body-content-heading">
                                  {t("Gosi Deduction")}
                                </h3>
                              </div>
                              <div className="add-body-content-grid">
                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="basicPay"
                                      >
                                        {t("Basic Pay")}
                                      </label>
                                      <span className="add-req-mark">*</span>
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.basicPay
                                            ? `${values.basicPay} SAR`
                                            : "-"}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          id="basicPay"
                                          name="basicPay"
                                          className="add-wrap-input"
                                          placeholder="0"
                                          maxLength={10}
                                          value={values?.basicPay}
                                          onChange={(e) =>
                                            setFieldValue(
                                              "basicPay",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                        <span className="add-input-in">
                                          {t("SAR")}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  {values.citizen === "true" &&
                                    !currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="basicPay"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                </div>

                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="housingAllows"
                                      >
                                        {t("Housing Allows")}
                                      </label>
                                      <span className="add-req-mark">*</span>
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.housingAllows
                                            ? `${values.housingAllows} SAR`
                                            : "-"}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          id="housingAllows"
                                          name="housingAllows"
                                          className="add-wrap-input"
                                          placeholder="0"
                                          maxLength={10}
                                          value={values?.housingAllows}
                                          onChange={(e) =>
                                            setFieldValue(
                                              "housingAllows",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                        <span className="add-input-in">
                                          {t("SAR")}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  {values.citizen === "true" &&
                                    !currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="housingAllows"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                </div>

                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="gosiDeduction"
                                      >
                                        {t("Gosi Deduction")}
                                      </label>
                                      <span className="add-req-mark">*</span>
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.gosiDeduction
                                            ? `${values.gosiDeduction}%`
                                            : "-"}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          id="gosiDeduction"
                                          name="gosiDeduction"
                                          className="add-wrap-input"
                                          placeholder="0"
                                          maxLength={10}
                                          value={values?.gosiDeduction}
                                          onChange={(e) =>
                                            setFieldValue(
                                              "gosiDeduction",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                        <span className="add-input-in">%</span>
                                      </div>
                                    )}
                                  </div>
                                  {values.citizen === "true" &&
                                    !currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="gosiDeduction"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                </div>

                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="deductionAmount"
                                      >
                                        {t("Deduction Amount")}
                                      </label>
                                      <span className="add-req-mark">*</span>
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.deductionAmount
                                            ? `${values.deductionAmount} SAR`
                                            : "-"}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          disabled={true}
                                          id="deductionAmount"
                                          name="deductionAmount"
                                          className="add-wrap-input"
                                          placeholder="0"
                                          maxLength={10}
                                          value={values?.deductionAmount}
                                          onChange={(e) =>
                                            setFieldValue(
                                              "deductionAmount",
                                              e.target.value
                                            )
                                          }
                                        />
                                        <span className="add-input-in">
                                          {t("SAR")}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  {values.citizen === "true" &&
                                    !currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="deductionAmount"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                </div>
                              </div>
                            </div>
                          )}
                          <SalaryComponent
                            totalSalary={totalSalary}
                            handleSetTotalSalary={handleSetTotalSalary}
                            values={values}
                            setFieldValue={setFieldValue}
                          />
                        </>
                      ) : (
                        <>
                          {documentTab === "Iqama" ? (
                            <div className="add-body-content-container">
                              <div className="add-body-content-header">
                                <h3 className="add-body-content-heading">
                                  {t("Iqama")}
                                </h3>
                                <div className="relative">
                                  {/* <select
                                    value={values.lang}
                                    onChange={(e) =>
                                      setFieldValue("lang", e.target.value)
                                    }
                                    className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                  >
                                    <option value="en">English</option>
                                    <option value="ar">Arabic</option>
                                  </select> */}
                                  {/* <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                    <DropDownIcon />
                                  </span> */}
                                </div>
                              </div>
                              <div className="add-body-content-grid">
                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="iqamaProfession"
                                      >
                                        {t("Iqama Profession")}
                                      </label>
                                      {values.citizen === "false" && (
                                        <span className="add-req-mark">*</span>
                                      )}
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.iqamaProfession || "-"}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          id="iqamaProfession"
                                          name="iqamaProfession"
                                          className="add-input"
                                          placeholder={t(
                                            "Enter Iqama Profession"
                                          )}
                                          value={values?.iqamaProfession}
                                          onChange={(e) =>
                                            setFieldValue(
                                              "iqamaProfession",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {values.citizen === "false" &&
                                    !currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="iqamaProfession"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                </div>

                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="iqamaId"
                                      >
                                        {t("Iqama ID")}
                                      </label>
                                      {values.citizen === "false" && (
                                        <span className="add-req-mark">*</span>
                                      )}
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>{values?.iqamaId || "-"}</span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          id="iqamaId"
                                          name="iqamaId"
                                          className="add-wrap-input"
                                          placeholder={t("Enter Iqama ID")}
                                          value={values?.iqamaId}
                                          onChange={(e) =>
                                            handleIqamaIdChange(
                                              e,
                                              setFieldValue
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {values.citizen === "false" &&
                                    !currentEmployeeEditing && (
                                      <>
                                        <ValidateIndicators
                                          isSearching={
                                            iqamaIdSearch.isSearching
                                          }
                                          validationResult={
                                            iqamaIdSearch.validationResult
                                          }
                                          error={iqamaIdSearch.error}
                                        />

                                        <CustomErrorMessage
                                          name="iqamaId"
                                          errors={errors}
                                          touched={touched}
                                        />
                                      </>
                                    )}
                                </div>

                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="iqamaIdExpiry"
                                      >
                                        {t("Iqama ID Expiry")}
                                      </label>
                                      {values.citizen === "false" && (
                                        <span className="add-req-mark">*</span>
                                      )}
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.iqamaIdExpiry || "-"}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          type="date"
                                          id="iqamaIdExpiry"
                                          name="iqamaIdExpiry"
                                          className={`add-wrap-input ${
                                            !values?.iqamaIdExpiry ||
                                            values.iqamaIdExpiry ===
                                              "DD-MM-YYYY"
                                              ? "empty"
                                              : ""
                                          }`}
                                          placeholder="DD/MM/YYYY"
                                          value={
                                            values?.iqamaIdExpiry
                                              ? formatDateToYYYYMMDD(
                                                  values.iqamaIdExpiry
                                                )
                                              : ""
                                          }
                                          onChange={(e) =>
                                            setFieldValue(
                                              "iqamaIdExpiry",
                                              e.target.value
                                            )
                                          }
                                          min={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                          onBlur={handleBlur}
                                        />
                                        <img
                                          src={dateIcon}
                                          alt="date icon"
                                          className="add-date-input-in"
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {values.citizen === "false" &&
                                    !currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="iqamaIdExpiry"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                </div>

                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="workPermitNo"
                                      >
                                        {t("Work Permit No")}
                                      </label>
                                      {values.citizen === "false" && (
                                        <span className="add-req-mark">*</span>
                                      )}
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.workPermitNo || "-"}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          id="workPermitNo"
                                          name="workPermitNo"
                                          className="add-wrap-input"
                                          placeholder={t(
                                            "Enter Work Permit No"
                                          )}
                                          value={values?.workPermitNo}
                                          onChange={(e) =>
                                            setFieldValue(
                                              "workPermitNo",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {!currentEmployeeEditing && (
                                    <CustomErrorMessage
                                      name="workPermitNo"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  )}
                                </div>

                                {/* Work Permit Expiry */}
                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="workPermitExpiry"
                                      >
                                        {t("Work Permit Expiry")}
                                      </label>
                                      {values.citizen === "false" && (
                                        <span className="add-req-mark">*</span>
                                      )}
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.workPermitExpiry || "-"}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          type="date"
                                          id="workPermitExpiry"
                                          name="workPermitExpiry"
                                          className={`add-wrap-input ${
                                            !values?.workPermitExpiry ||
                                            values.workPermitExpiry ===
                                              "DD-MM-YYYY"
                                              ? "empty"
                                              : ""
                                          }`}
                                          placeholder="DD/MM/YYYY"
                                          value={
                                            values?.workPermitExpiry
                                              ? formatDateToYYYYMMDD(
                                                  values.workPermitExpiry
                                                )
                                              : ""
                                          }
                                          onChange={(e) =>
                                            setFieldValue(
                                              "workPermitExpiry",
                                              e.target.value
                                            )
                                          }
                                          min={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                          onBlur={handleBlur}
                                        />
                                        <img
                                          src={dateIcon}
                                          alt="date icon"
                                          className="add-date-input-in"
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {!currentEmployeeEditing && (
                                    <CustomErrorMessage
                                      name="workPermitExpiry"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  )}
                                </div>
                              </div>

                              {values.citizen === "true" && (
                                <div className="add-body-content-container">
                                  <div className="add-body-content-header">
                                    <h3 className="add-body-content-heading">
                                      {t("Nationality")}
                                    </h3>
                                  </div>
                                  <div className="add-body-content-grid"></div>
                                </div>
                              )}

                              <DocumentUploadDisplay
                                values={values}
                                frontDocKey="iqamaDocFront"
                                backDocKey="iqamaDocBack"
                                handleRemoveDocument={handleRemoveDocument}
                                setFieldValue={setFieldValue}
                                currentEmployeeEditing={currentEmployeeEditing}
                                onDocModal={onDocModal}
                                errors={errors}
                                touched={touched}
                              />

                              {docModal && (
                                <>
                                  <div className="upload-modal-overlay">
                                    <div className="upload-modal-content">
                                      <div className="upload-modal-header">
                                        <span className="upload-modal-title">
                                          {t("Upload Documents")}
                                        </span>
                                        <div
                                          className="upload-modal-icon-container"
                                          onClick={() =>
                                            closeDocModal(setFieldValue)
                                          }
                                        >
                                          <img
                                            src={arrowIcon}
                                            alt="arrow icon"
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-body">
                                        <p className="upload-desc">
                                          {t(
                                            "Please select the import file from your device"
                                          )}
                                        </p>
                                        <div className="upload-file-input-container">
                                          <div className="upload-file-input-container2">
                                            <div className="upload-label-container">
                                              <label
                                                htmlFor="iqamaDocFront"
                                                className="upload-label"
                                              >
                                                {t("Front Document")}
                                              </label>
                                              {/* <span className="upload-req-mark">
                                            *
                                          </span> */}
                                            </div>
                                            <div
                                              className="upload-file-input-wrapper"
                                              onClick={handleOpenFileInput}
                                            >
                                              <span className="upload-file-input-replacer">
                                                {values?.iqamaDocFront
                                                  ? values?.iqamaDocFront?.name
                                                  : t("Upload Document")}
                                              </span>
                                              <input
                                                name="iqamaDocFront"
                                                // value={values.iqamaDocFront}
                                                ref={fileInputRef1}
                                                id="iqamaDocFront"
                                                type="file"
                                                className="upload-file-hidden-input"
                                                onChange={(e) => {
                                                  setFieldValue(
                                                    "iqamaDocFront",
                                                    e.target.files[0]
                                                  );
                                                }}
                                              />
                                              <button
                                                type="button"
                                                className="upload-btn"
                                              >
                                                {t("Upload File")}
                                              </button>
                                            </div>
                                            <CustomErrorMessage
                                              name="iqamaDocFront"
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>
                                        </div>
                                        <div className="upload-file-input-container">
                                          <div className="upload-file-input-container2">
                                            <div className="upload-label-container">
                                              <label
                                                htmlFor="iqamaDocBack"
                                                className="upload-label"
                                              >
                                                {t("Back Document")}
                                              </label>
                                              {/* <span className="upload-req-mark">
                                            *
                                          </span> */}
                                            </div>
                                            <div
                                              className="upload-file-input-wrapper"
                                              onClick={handleOpenFileInput2}
                                            >
                                              <span className="upload-file-input-replacer">
                                                {values?.iqamaDocBack
                                                  ? values?.iqamaDocBack?.name
                                                  : t("Upload Document")}
                                              </span>
                                              <input
                                                name="iqamaDocBack"
                                                // value={values.iqamaDocBack}
                                                ref={fileInputRef2}
                                                id="iqamaDocBack"
                                                type="file"
                                                className="upload-file-hidden-input"
                                                onChange={(e) => {
                                                  setFieldValue(
                                                    "iqamaDocBack",
                                                    e.target.files[0]
                                                  );
                                                }}
                                              />
                                              <button
                                                type="button"
                                                className="upload-btn"
                                              >
                                                {t("Upload File")}
                                              </button>
                                            </div>
                                            <CustomErrorMessage
                                              name="iqamaDocBack"
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="upload-footer">
                                        <button
                                          type="button"
                                          className="upload-footer-btn"
                                          disabled={docUploadLoading}
                                          onClick={() =>
                                            handleSubmitDocument(
                                              values,
                                              "iqamaDoc"
                                            )
                                          }
                                        >
                                          {!docUploadLoading ? (
                                            t("Submit")
                                          ) : (
                                            <ButtonLoading />
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          ) : documentTab === "National ID" ? (
                            <div className="add-body-content-container">
                              <div className="add-body-content-header">
                                <h3 className="add-body-content-heading">
                                  {t("National ID")}
                                </h3>
                                <div className="relative">
                                  {/* <select
                                    value={values.lang}
                                    onChange={(e) =>
                                      setFieldValue("lang", e.target.value)
                                    }
                                    className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                  >
                                    <option value="en">English</option>
                                    <option value="ar">Arabic</option>
                                  </select> */}
                                  {/* <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                    <DropDownIcon />
                                  </span> */}
                                </div>
                              </div>
                              <div className="add-body-content-grid">
                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="nationalId"
                                      >
                                        {t("National ID")}
                                      </label>
                                      <span className="add-req-mark">*</span>
                                    </div>
                                    <input
                                      disabled
                                      id="nationalId"
                                      name="nationalId"
                                      className="add-input  bg-gray-100 border border-gray-300 cursor-not-allowed"
                                      placeholder={t("Enter National ID")}
                                      value={values?.nationalId}
                                      onChange={(e) =>
                                        handleNationalIdChange(e, setFieldValue)
                                      }
                                      onBlur={handleBlur}
                                    />
                                  </div>
                                  <ValidateIndicators
                                    isSearching={nationalIdSearch.isSearching}
                                    validationResult={
                                      nationalIdSearch.validationResult
                                    }
                                    error={nationalIdSearch.error}
                                  />
                                  <CustomErrorMessage
                                    name="nationalId"
                                    errors={errors}
                                    touched={touched}
                                  />
                                </div>
                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="nationalIdExpiry"
                                      >
                                        {t("National ID Expiry")}
                                      </label>
                                      <span className="add-req-mark">*</span>
                                    </div>
                                    <div className="add-input-wrapper">
                                      <input
                                        type="date"
                                        id="nationalIdExpiry"
                                        name="nationalIdExpiry"
                                        className={`add-wrap-input ${
                                          !values?.nationalIdExpiry ||
                                          values.nationalIdExpiry ===
                                            "DD-MM-YYYY"
                                            ? "empty"
                                            : ""
                                        }`}
                                        placeholder="DD/MM/YYYY"
                                        min={
                                          new Date().toISOString().split("T")[0]
                                        } // Restricts past dates
                                        value={
                                          values?.nationalIdExpiry
                                            ? formatDateToYYYYMMDD(
                                                values.nationalIdExpiry
                                              )
                                            : ""
                                        }
                                        onChange={(e) =>
                                          setFieldValue(
                                            "nationalIdExpiry",
                                            e.target.value
                                          )
                                        }
                                        onBlur={handleBlur}
                                      />

                                      <img
                                        src={dateIcon}
                                        alt="date icon"
                                        className="add-date-input-in"
                                      />
                                    </div>
                                  </div>
                                  <CustomErrorMessage
                                    name="nationalIdExpiry"
                                    errors={errors}
                                    touched={touched}
                                  />
                                </div>
                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="dobGregorian"
                                      >
                                        {t("Date Of Birth")}
                                      </label>
                                    </div>
                                    <div className="add-input-wrapper">
                                      <input
                                        disabled
                                        type="date"
                                        id="dobGregorian"
                                        name="dobGregorian"
                                        className={`add-wrap-input ${
                                          !values?.dobGregorian ||
                                          values.dobGregorian === "DD-MM-YYYY"
                                            ? "empty"
                                            : ""
                                        } bg-gray-100 text-gray-400 border border-gray-300 cursor-not-allowed`}
                                        placeholder="DD/MM/YYYY"
                                        value={
                                          values?.dobGregorian
                                            ? formatDateToYYYYMMDD(
                                                values.dobGregorian
                                              )
                                            : ""
                                        }
                                        onChange={(e) =>
                                          setFieldValue(
                                            "dobGregorian",
                                            e.target.value
                                          )
                                        }
                                        onBlur={handleBlur}
                                      />
                                      <img
                                        src={dateIcon}
                                        alt="date icon"
                                        className="add-date-input-in"
                                      />
                                    </div>
                                  </div>
                                  <CustomErrorMessage
                                    name="dobGregorian"
                                    errors={errors}
                                    touched={touched}
                                  />
                                </div>
                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="placeOfBirth"
                                      >
                                        {t("Place of Birth")}
                                      </label>
                                    </div>
                                    <input
                                      id="placeOfBirth"
                                      name="placeOfBirth"
                                      className="add-input"
                                      placeholder={t("Enter Place of Birth")}
                                      value={values?.placeOfBirth}
                                      onChange={(e) =>
                                        setFieldValue(
                                          "placeOfBirth",
                                          e.target.value
                                        )
                                      }
                                      onBlur={handleBlur}
                                    />
                                  </div>
                                  <CustomErrorMessage
                                    name="placeOfBirth"
                                    errors={errors}
                                    touched={touched}
                                  />
                                </div>
                              </div>

                              <DocumentUploadDisplay
                                values={values}
                                frontDocKey="nationalDocFront"
                                backDocKey="nationalDocBack"
                                handleRemoveDocument={handleRemoveDocument}
                                setFieldValue={setFieldValue}
                                onDocModal={onDocModal}
                                errors={errors}
                                touched={touched}
                              />

                              {docModal && (
                                <>
                                  <div className="upload-modal-overlay">
                                    <div className="upload-modal-content">
                                      <div className="upload-modal-header">
                                        <span className="upload-modal-title">
                                          {t("Upload Documents")}
                                        </span>
                                        <div
                                          className="upload-modal-icon-container"
                                          onClick={() =>
                                            closeDocModal(setFieldValue)
                                          }
                                        >
                                          <img
                                            src={arrowIcon}
                                            alt="arrow icon"
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-body">
                                        <p className="upload-desc">
                                          {t(
                                            "Please select the import file from your device"
                                          )}
                                        </p>
                                        <div className="upload-file-input-container">
                                          <div className="upload-file-input-container2">
                                            <div className="upload-label-container">
                                              <label
                                                htmlFor="nationalDocFront"
                                                className="upload-label"
                                              >
                                                {t("Front Document")}
                                              </label>
                                              {/* <span className="upload-req-mark">
                                            *
                                          </span> */}
                                            </div>
                                            <div
                                              className="upload-file-input-wrapper"
                                              onClick={handleOpenFileInput}
                                            >
                                              <span className="upload-file-input-replacer">
                                                {values?.nationalDocFront
                                                  ? values?.nationalDocFront
                                                      ?.name
                                                  : t("Upload Document")}
                                              </span>
                                              <input
                                                name="nationalDocFront"
                                                // value={values.nationalDocFront}
                                                ref={fileInputRef1}
                                                id="nationalDocFront"
                                                type="file"
                                                className="upload-file-hidden-input"
                                                onChange={(e) => {
                                                  setFieldValue(
                                                    "nationalDocFront",
                                                    e.target.files[0]
                                                  );
                                                }}
                                              />
                                              <button
                                                type="button"
                                                className="upload-btn"
                                              >
                                                {t("Upload File")}
                                              </button>
                                            </div>
                                            <CustomErrorMessage
                                              name="nationalDocFront"
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>
                                        </div>
                                        <div className="upload-file-input-container">
                                          <div className="upload-file-input-container2">
                                            <div className="upload-label-container">
                                              <label
                                                htmlFor="nationalDocBack"
                                                className="upload-label"
                                              >
                                                {t("Back Document")}
                                              </label>
                                              {/* <span className="upload-req-mark">
                                            *
                                          </span> */}
                                            </div>
                                            <div
                                              className="upload-file-input-wrapper"
                                              onClick={handleOpenFileInput2}
                                            >
                                              <span className="upload-file-input-replacer">
                                                {values?.nationalDocBack
                                                  ? values?.nationalDocBack
                                                      ?.name
                                                  : t("Upload Document")}
                                              </span>
                                              <input
                                                name="nationalDocBack"
                                                // value={values.nationalDocBack}
                                                ref={fileInputRef2}
                                                id="nationalDocBack"
                                                type="file"
                                                className="upload-file-hidden-input"
                                                onChange={(e) => {
                                                  setFieldValue(
                                                    "nationalDocBack",
                                                    e.target.files[0]
                                                  );
                                                }}
                                              />
                                              <button
                                                type="button"
                                                className="upload-btn"
                                              >
                                                {t("Upload File")}
                                              </button>
                                            </div>
                                            <CustomErrorMessage
                                              name="nationalDocBack"
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="upload-footer">
                                        <button
                                          type="button"
                                          className="upload-footer-btn"
                                          disabled={docUploadLoading}
                                          onClick={() =>
                                            handleSubmitDocument(
                                              values,
                                              "nationalDoc"
                                            )
                                          }
                                        >
                                          {!docUploadLoading ? (
                                            t("Submit")
                                          ) : (
                                            <ButtonLoading />
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          ) : documentTab === "Account" ? (
                            <div className="add-body-content-container">
                              <div className="add-body-content-header">
                                <h3 className="add-body-content-heading">
                                  {t("Bank Account")}
                                </h3>
                                {/* <div className="relative">
                                  <select
                                    value={values.lang}
                                    onChange={(e) =>
                                      setFieldValue("lang", e.target.value)
                                    }
                                    className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                  >
                                    <option value="en">English</option>
                                    <option value="ar">Arabic</option>
                                  </select>
                                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                    <DropDownIcon />
                                  </span>
                                </div> */}
                              </div>
                              <div className="add-body-content-flex">
                                <div className="form-group">
                                  <div className="add-body-input-section-full">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="bank"
                                      >
                                        {t("Bank")}
                                      </label>
                                      <span className="add-req-mark">*</span>
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.bank?.label || "-"}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <AsyncSelect
                                          id="bank"
                                          name="bank"
                                          value={values.bank}
                                          onChange={(selectedOption) =>
                                            setFieldValue(
                                              "bank",
                                              selectedOption
                                            )
                                          }
                                          loadOptions={onSearchBankDebounce}
                                          defaultOptions={bank}
                                          styles={asyncSelectStyles}
                                          cacheOptions
                                          placeholder={t("Select Bank")}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {!currentEmployeeEditing && (
                                    <CustomErrorMessage
                                      name="bank"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  )}
                                </div>

                                {/* Account Holder Name */}
                                <div className="form-group">
                                  <div className="add-body-input-section-full">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="accountHolderName"
                                      >
                                        {t("Account Holder Name")}
                                      </label>
                                      <span className="add-req-mark">*</span>
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.accountHolderName || "-"}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          id="accountHolderName"
                                          name="accountHolderName"
                                          className="add-input-full"
                                          placeholder={t("Enter Holder Name")}
                                          value={values?.accountHolderName}
                                          onChange={(e) =>
                                            setFieldValue(
                                              "accountHolderName",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {!currentEmployeeEditing && (
                                    <CustomErrorMessage
                                      name="accountHolderName"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  )}
                                </div>

                                <div className="add-body-content-grid">
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="ibanNo"
                                        >
                                          {t("IBAN Number")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>{values?.ibanNo || "-"}</span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            id="ibanNo"
                                            name="ibanNo"
                                            className="add-wrap-input"
                                            placeholder={t("Enter IBAN Number")}
                                            value={values?.ibanNo}
                                            onChange={(e) =>
                                              handleIbanNoChange(
                                                e,
                                                setFieldValue
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <>
                                        <ValidateIndicators
                                          isSearching={ibanNoSearch.isSearching}
                                          validationResult={
                                            ibanNoSearch.validationResult
                                          }
                                          error={ibanNoSearch.error}
                                        />
                                        <CustomErrorMessage
                                          name="ibanNo"
                                          errors={errors}
                                          touched={touched}
                                        />
                                      </>
                                    )}
                                  </div>

                                  {/* Confirm IBAN Number */}
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="confirmIban"
                                        >
                                          {t("Confirm IBAN Number")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.confirmIban || "-"}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            id="confirmIban"
                                            name="confirmIban"
                                            className="add-wrap-input"
                                            placeholder="0"
                                            onPaste={(e) => e.preventDefault()}
                                            value={values?.confirmIban}
                                            onChange={(e) =>
                                              setFieldValue(
                                                "confirmIban",
                                                e.target.value
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="confirmIban"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                  </div>
                                </div>
                                <div className="form-group">
                                  <div className="add-body-input-section-full">
                                    <div className="add-label-container">
                                      <label
                                        className="add-label"
                                        htmlFor="ifscCode"
                                      >
                                        {t("IFSC Code")}{" "}
                                        <span
                                          style={{
                                            color: "#6c757d",
                                            fontSize: "12px",
                                          }}
                                        >
                                          (e.g., HDFC0CAG001)
                                        </span>
                                      </label>
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>{values?.ifscCode || "-"}</span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-input-wrapper">
                                        <input
                                          id="ifscCode"
                                          name="ifscCode"
                                          className="add-input-full"
                                          placeholder={t("Enter IFSC Code")}
                                          value={values?.ifscCode}
                                          onChange={(e) =>
                                            setFieldValue(
                                              "ifscCode",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {!currentEmployeeEditing && (
                                    <CustomErrorMessage
                                      name="ifscCode"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  )}
                                </div>
                              </div>

                              <DocumentUploadDisplay
                                values={values}
                                frontDocKey="accountFront"
                                backDocKey="accountBack"
                                handleRemoveDocument={handleRemoveDocument}
                                setFieldValue={setFieldValue}
                                currentEmployeeEditing={currentEmployeeEditing}
                                onDocModal={onDocModal}
                                errors={errors}
                                touched={touched}
                              />
                              {docModal && (
                                <div className="upload-modal-overlay">
                                  <div className="upload-modal-content">
                                    <div className="upload-modal-header">
                                      <span className="upload-modal-title">
                                        {t("Upload Documents")}
                                      </span>
                                      <div className="upload-modal-icon-container">
                                        <img
                                          src={arrowIcon}
                                          alt="arrow icon"
                                          onClick={() =>
                                            closeDocModalAccount(setFieldValue)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="upload-body">
                                      <p className="upload-desc">
                                        {t(
                                          "Please select the import file from your device"
                                        )}
                                      </p>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="accountFront"
                                              className="upload-label"
                                            >
                                              {t("Front Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.accountFront
                                                ? values?.accountFront?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="accountFront"
                                              ref={fileInputRef1}
                                              id="accountFront"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "accountFront",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="accountFront"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="accountDocBack"
                                              className="upload-label"
                                            >
                                              {t("Back Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput2}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.accountBack
                                                ? values?.accountBack?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="accountBack"
                                              // value={values.insuranceDocBack}
                                              ref={fileInputRef2}
                                              id="accountBack"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "accountBack",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="accountBack"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="upload-footer">
                                      <button
                                        type="button"
                                        disabled={docUploadLoading}
                                        className="upload-footer-btn"
                                        onClick={() =>
                                          handleSubmitDocument(
                                            values,
                                            "accountDoc"
                                          )
                                        }
                                      >
                                        {!docUploadLoading ? (
                                          t("Submit")
                                        ) : (
                                          <ButtonLoading />
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          ) : documentTab === "Health Insurance" ? (
                            <>
                              <div className="add-body-content-container">
                                <div className="add-body-content-header">
                                  <h3 className="add-body-content-heading">
                                    {t("Health Insurance")}
                                  </h3>
                                  {/* <div className="relative">
                                    <select
                                      value={values.lang}
                                      onChange={(e) =>
                                        setFieldValue("lang", e.target.value)
                                      }
                                      className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                    >
                                      <option value="en">English</option>
                                      <option value="ar">Arabic</option>
                                    </select>
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                      <DropDownIcon />
                                    </span>
                                  </div> */}
                                </div>
                                <div className="add-body-content-flex">
                                  <div className="form-group">
                                    <div className="add-body-input-section-full">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="insuranceClass"
                                        >
                                          {t("Health Insurance Class")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.insuranceClass || "-"}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            id="insuranceClass"
                                            name="insuranceClass"
                                            className="add-input"
                                            placeholder={t(
                                              "Enter Health Insurance"
                                            )}
                                            value={values?.insuranceClass}
                                            onChange={(e) =>
                                              setFieldValue(
                                                "insuranceClass",
                                                e.target.value
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="insuranceClass"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                  </div>

                                  <div className="add-body-content-grid">
                                    <div className="form-group">
                                      <div className="add-body-input-section">
                                        <div className="add-label-container">
                                          <label
                                            className="add-label"
                                            htmlFor="insuranceNo"
                                          >
                                            {t("Health Insurance Number")}
                                          </label>
                                          <span className="add-req-mark">
                                            *
                                          </span>
                                        </div>
                                        {currentEmployeeEditing ? (
                                          <div className="add-input-value">
                                            <span>
                                              {values?.insuranceNo || "-"}
                                            </span>
                                            <span className="add-input-badge">
                                              {noEditingMsg}
                                            </span>
                                          </div>
                                        ) : (
                                          <div className="add-input-wrapper">
                                            <input
                                              id="insuranceNo"
                                              name="insuranceNo"
                                              className="add-input"
                                              placeholder={t(
                                                "Enter Health Insurance Number"
                                              )}
                                              value={values?.insuranceNo}
                                              onChange={(e) =>
                                                handleInsuranceNoChange(
                                                  e,
                                                  setFieldValue
                                                )
                                              }
                                              onBlur={handleBlur}
                                            />
                                          </div>
                                        )}
                                      </div>
                                      {!currentEmployeeEditing && (
                                        <>
                                          <ValidateIndicators
                                            isSearching={
                                              insuranceNoSearch.isSearching
                                            }
                                            validationResult={
                                              insuranceNoSearch.validationResult
                                            }
                                            error={insuranceNoSearch.error}
                                          />
                                          <CustomErrorMessage
                                            name="insuranceNo"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </>
                                      )}
                                    </div>

                                    {/* Insurance Expiry */}
                                    <div className="form-group">
                                      <div className="add-body-input-section">
                                        <div className="add-label-container">
                                          <label
                                            className="add-label"
                                            htmlFor="insuranceExpiry"
                                          >
                                            {t("Insurance Expiry")}
                                          </label>
                                          <span className="add-req-mark">
                                            *
                                          </span>
                                        </div>
                                        {currentEmployeeEditing ? (
                                          <div className="add-input-value">
                                            <span>
                                              {values?.insuranceExpiry || "-"}
                                            </span>
                                            <span className="add-input-badge">
                                              {noEditingMsg}
                                            </span>
                                          </div>
                                        ) : (
                                          <div className="add-input-wrapper">
                                            <input
                                              id="insuranceExpiry"
                                              type="date"
                                              name="insuranceExpiry"
                                              className={`add-wrap-input ${
                                                !values?.insuranceExpiry ||
                                                values.insuranceExpiry ===
                                                  "DD-MM-YYYY"
                                                  ? "empty"
                                                  : ""
                                              }`}
                                              placeholder="DD/MM/YYYY"
                                              min={
                                                new Date()
                                                  .toISOString()
                                                  .split("T")[0]
                                              }
                                              value={
                                                values?.insuranceExpiry
                                                  ? formatDateToYYYYMMDD(
                                                      values.insuranceExpiry
                                                    )
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "insuranceExpiry",
                                                  e.target.value
                                                )
                                              }
                                              onBlur={handleBlur}
                                            />
                                            <img
                                              src={dateIcon}
                                              alt="date icon"
                                              className="add-date-input-in"
                                            />
                                          </div>
                                        )}
                                      </div>
                                      {!currentEmployeeEditing && (
                                        <CustomErrorMessage
                                          name="insuranceExpiry"
                                          errors={errors}
                                          touched={touched}
                                        />
                                      )}
                                    </div>
                                  </div>

                                  {/* <div className="form-group">
                                <div className="add-body-input-section-full">
                                  <div className="add-label-container">
                                    <label className="add-label" htmlFor="ifsc">
                                      IFSC Code
                                    </label>
                                    <span className="add-req-mark">*</span>
                                  </div>
                                  <div className="add-input-wrapper">
                                    <input
                                      id="ifsc"
                                      name="ifsc"
                                      className="add-input-full"
                                      placeholder="Enter IFSC Code"
                                      value={values?.ifsc}
                                      onChange={(e) =>
                                        setFieldValue("ifsc", e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <CustomErrorMessage
                                  name="ifsc"
                                  errors={errors}
                                  touched={touched}
                                />
                              </div> */}
                                </div>
                              </div>
                              <div
                                className="add-body-content-container"
                                style={{ marginTop: "12px" }}
                              >
                                <DocumentUploadDisplay
                                  values={values}
                                  frontDocKey="insuranceDocFront"
                                  backDocKey="insuranceDocBack"
                                  handleRemoveDocument={handleRemoveDocument}
                                  setFieldValue={setFieldValue}
                                  currentEmployeeEditing={
                                    currentEmployeeEditing
                                  }
                                  onDocModal={onDocModal}
                                  errors={errors}
                                  touched={touched}
                                />
                                {docModal && (
                                  <div className="upload-modal-overlay">
                                    <div className="upload-modal-content">
                                      <div className="upload-modal-header">
                                        <span className="upload-modal-title">
                                          {t("Upload Documents")}
                                        </span>
                                        <div className="upload-modal-icon-container">
                                          <img
                                            src={arrowIcon}
                                            alt="arrow icon"
                                            onClick={() =>
                                              closeDocModalInsurance(
                                                setFieldValue
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-body">
                                        <p className="upload-desc">
                                          {t(
                                            "Please select the import file from your device"
                                          )}
                                        </p>
                                        <div className="upload-file-input-container">
                                          <div className="upload-file-input-container2">
                                            <div className="upload-label-container">
                                              <label
                                                htmlFor="insuranceDocFront"
                                                className="upload-label"
                                              >
                                                {t("Front Document")}
                                              </label>
                                              {/* <span className="upload-req-mark">
                                            *
                                          </span> */}
                                            </div>
                                            <div
                                              className="upload-file-input-wrapper"
                                              onClick={handleOpenFileInput}
                                            >
                                              <span className="upload-file-input-replacer">
                                                {values?.insuranceDocFront?.name
                                                  ? values?.insuranceDocFront
                                                      ?.name
                                                  : t("Upload Document")}
                                              </span>
                                              <input
                                                name="insuranceDocFront"
                                                ref={fileInputRef1}
                                                id="insuranceDocFront"
                                                type="file"
                                                className="upload-file-hidden-input"
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    "insuranceDocFront",
                                                    e.target.files[0]
                                                  )
                                                }
                                              />
                                              <button
                                                type="button"
                                                className="upload-btn"
                                              >
                                                {t("Upload File")}
                                              </button>
                                            </div>
                                            <CustomErrorMessage
                                              name="insuranceDocFront"
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>
                                        </div>
                                        <div className="upload-file-input-container">
                                          <div className="upload-file-input-container2">
                                            <div className="upload-label-container">
                                              <label
                                                htmlFor="insuranceDocBack"
                                                className="upload-label"
                                              >
                                                {t("Back Document")}
                                              </label>
                                              {/* <span className="upload-req-mark">
                                            *
                                          </span> */}
                                            </div>
                                            <div
                                              className="upload-file-input-wrapper"
                                              onClick={handleOpenFileInput2}
                                            >
                                              <span className="upload-file-input-replacer">
                                                {values?.insuranceDocBack
                                                  ? values?.insuranceDocBack
                                                      ?.name
                                                  : t("Upload Document")}
                                              </span>
                                              <input
                                                name="insuranceDocBack"
                                                // value={values.i}
                                                ref={fileInputRef2}
                                                id="i"
                                                type="file"
                                                className="upload-file-hidden-input"
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    "insuranceDocBack",
                                                    e.target.files[0]
                                                  )
                                                }
                                              />
                                              <button
                                                type="button"
                                                className="upload-btn"
                                              >
                                                {t("Upload File")}
                                              </button>
                                            </div>
                                            <CustomErrorMessage
                                              name="insuranceDocBack"
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="upload-footer">
                                        <button
                                          type="button"
                                          className="upload-footer-btn"
                                          disabled={docUploadLoading}
                                          onClick={() =>
                                            handleSubmitDocument(
                                              values,
                                              "insuranceDoc"
                                            )
                                          }
                                        >
                                          {!docUploadLoading ? (
                                            t("Submit")
                                          ) : (
                                            <ButtonLoading />
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </>
                          ) : documentTab === "Health Card" ? (
                            <>
                              <div
                                className="add-body-content-container"
                                style={{ marginTop: "12px" }}
                              >
                                <div className="add-body-content-header">
                                  <h3 className="add-body-content-heading">
                                    {t("Health Card")}
                                  </h3>
                                  {/* <div className="relative">
                                    <select
                                      value={values.lang}
                                      onChange={(e) =>
                                        setFieldValue("lang", e.target.value)
                                      }
                                      className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                    >
                                      <option value="en">English</option>
                                      <option value="ar">Arabic</option>
                                    </select>
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                      <DropDownIcon />
                                    </span>
                                  </div> */}
                                </div>
                                <div className="form-group">
                                  <div className="add-body-input-section">
                                    <div className="add-label-container">
                                      <label className="add-label">
                                        {t("Health Card")}
                                      </label>
                                      <span className="upload-req-mark">*</span>
                                    </div>
                                    {currentEmployeeEditing ? (
                                      <div className="add-input-value">
                                        <span>
                                          {values?.healthCard === "true"
                                            ? t("Yes")
                                            : t("No")}
                                        </span>
                                        <span className="add-input-badge">
                                          {noEditingMsg}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="add-radio-input-container">
                                        <div className="add-radio-container">
                                          <input
                                            id="yes"
                                            type="radio"
                                            name="healthCard"
                                            className="add-radio-input"
                                            value="true"
                                            onChange={(e) =>
                                              setFieldValue(
                                                "healthCard",
                                                e.target.value
                                              )
                                            }
                                            checked={
                                              values?.healthCard === "true"
                                            }
                                          />
                                          <label
                                            htmlFor="yes"
                                            className="add-label"
                                          >
                                            {t("Yes")}
                                          </label>
                                        </div>
                                        <div className="add-radio-container">
                                          <input
                                            id="no"
                                            type="radio"
                                            name="healthCard"
                                            className="add-radio-input"
                                            value="false"
                                            onChange={(e) =>
                                              setFieldValue(
                                                "healthCard",
                                                e.target.value
                                              )
                                            }
                                            checked={
                                              values?.healthCard === "false"
                                            }
                                          />
                                          <label
                                            htmlFor="no"
                                            className="add-label"
                                          >
                                            {t("No")}
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  {!currentEmployeeEditing && (
                                    <CustomErrorMessage
                                      name="healthCard"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  )}
                                </div>
                                <div className="add-body-content-flex">
                                  <div className="add-body-content-grid">
                                    <div className="form-group">
                                      <div className="add-body-input-section">
                                        <div className="add-label-container">
                                          <label
                                            className="add-label"
                                            htmlFor="healthCardNo"
                                          >
                                            {t("Health Card Number")}
                                          </label>
                                          <span className="add-req-mark">
                                            *
                                          </span>
                                        </div>
                                        {currentEmployeeEditing ? (
                                          <div className="add-input-value">
                                            <span>
                                              {values?.healthCardNo || "-"}
                                            </span>
                                            <span className="add-input-badge">
                                              {noEditingMsg}
                                            </span>
                                          </div>
                                        ) : (
                                          <div className="add-input-wrapper">
                                            <input
                                              id="healthCardNo"
                                              name="healthCardNo"
                                              className="add-input"
                                              placeholder={t(
                                                "Enter Health Card Number"
                                              )}
                                              value={values?.healthCardNo}
                                              onChange={(e) =>
                                                handleHealthCardNoChange(
                                                  e,
                                                  setFieldValue
                                                )
                                              }
                                              onBlur={handleBlur}
                                            />
                                          </div>
                                        )}
                                      </div>
                                      {!currentEmployeeEditing && (
                                        <>
                                          <ValidateIndicators
                                            isSearching={
                                              healthCardNoSearch.isSearching
                                            }
                                            validationResult={
                                              healthCardNoSearch.validationResult
                                            }
                                            error={healthCardNoSearch.error}
                                          />
                                          <CustomErrorMessage
                                            name="healthCardNo"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </>
                                      )}
                                    </div>

                                    {/* Health Card Expiry */}
                                    <div className="form-group">
                                      <div className="add-body-input-section">
                                        <div className="add-label-container">
                                          <label
                                            className="add-label"
                                            htmlFor="healthCardExpiry"
                                          >
                                            {t("Health Card Expiry")}
                                          </label>
                                          <span className="add-req-mark">
                                            *
                                          </span>
                                        </div>
                                        {currentEmployeeEditing ? (
                                          <div className="add-input-value">
                                            <span>
                                              {values?.healthCardExpiry || "-"}
                                            </span>
                                            <span className="add-input-badge">
                                              {noEditingMsg}
                                            </span>
                                          </div>
                                        ) : (
                                          <div className="add-input-wrapper">
                                            <input
                                              type="date"
                                              id="healthCardExpiry"
                                              name="healthCardExpiry"
                                              className={`add-wrap-input ${
                                                !values?.healthCardExpiry ||
                                                values.healthCardExpiry ===
                                                  "DD-MM-YYYY"
                                                  ? "empty"
                                                  : ""
                                              }`}
                                              placeholder="DD/MM/YYYY"
                                              min={
                                                new Date()
                                                  .toISOString()
                                                  .split("T")[0]
                                              }
                                              value={
                                                values?.healthCardExpiry
                                                  ? formatDateToYYYYMMDD(
                                                      values.healthCardExpiry
                                                    )
                                                  : ""
                                              }
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "healthCardExpiry",
                                                  e.target.value
                                                )
                                              }
                                              onBlur={handleBlur}
                                            />
                                            <img
                                              src={dateIcon}
                                              alt="date icon"
                                              className="add-date-input-in"
                                            />
                                          </div>
                                        )}
                                      </div>
                                      {!currentEmployeeEditing && (
                                        <CustomErrorMessage
                                          name="healthCardExpiry"
                                          errors={errors}
                                          touched={touched}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <DocumentUploadDisplay
                                  values={values}
                                  frontDocKey="healthCardDocFront"
                                  backDocKey="healthCardDocBack"
                                  handleRemoveDocument={handleRemoveDocument}
                                  setFieldValue={setFieldValue}
                                  currentEmployeeEditing={
                                    currentEmployeeEditing
                                  }
                                  onDocModal={onDocModal}
                                  errors={errors}
                                  touched={touched}
                                />

                                {docModal && (
                                  <div className="upload-modal-overlay">
                                    <div className="upload-modal-content">
                                      <div className="upload-modal-header">
                                        <span className="upload-modal-title">
                                          {t("Upload Documents")}
                                        </span>
                                        <div className="upload-modal-icon-container">
                                          <img
                                            src={arrowIcon}
                                            alt="arrow icon"
                                            onClick={() =>
                                              closeDocModalHealthCard(
                                                setFieldValue
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-body">
                                        <p className="upload-desc">
                                          {t(
                                            "Please select the import file from your device"
                                          )}
                                        </p>
                                        <div className="upload-file-input-container">
                                          <div className="upload-file-input-container2">
                                            <div className="upload-label-container">
                                              <label
                                                htmlFor="healthCardDocFront"
                                                className="upload-label"
                                              >
                                                {t("Front Document")}
                                              </label>
                                              {/* <span className="upload-req-mark">
                                            *
                                          </span> */}
                                            </div>
                                            <div
                                              className="upload-file-input-wrapper"
                                              onClick={handleOpenFileInput}
                                            >
                                              <span className="upload-file-input-replacer">
                                                {values?.healthCardDocFront
                                                  ?.name
                                                  ? values?.healthCardDocFront
                                                      ?.name
                                                  : t("Upload Document")}
                                              </span>
                                              <input
                                                name="healthCardDocFront"
                                                ref={fileInputRef1}
                                                id="healthCardDocFront"
                                                type="file"
                                                className="upload-file-hidden-input"
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    "healthCardDocFront",
                                                    e.target.files[0]
                                                  )
                                                }
                                              />
                                              <button
                                                type="button"
                                                className="upload-btn"
                                              >
                                                {t("Upload File")}
                                              </button>
                                            </div>
                                            <CustomErrorMessage
                                              name="healthCardDocFront"
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>
                                        </div>
                                        <div className="upload-file-input-container">
                                          <div className="upload-file-input-container2">
                                            <div className="upload-label-container">
                                              <label
                                                htmlFor="healthCardDocBack"
                                                className="upload-label"
                                              >
                                                {t("Back Document")}
                                              </label>
                                              {/* <span className="upload-req-mark">
                                            *
                                          </span> */}
                                            </div>
                                            <div
                                              className="upload-file-input-wrapper"
                                              onClick={handleOpenFileInput2}
                                            >
                                              <span className="upload-file-input-replacer">
                                                {values?.healthCardDocBack
                                                  ? values?.healthCardDocBack
                                                      ?.name
                                                  : t("Upload Document")}
                                              </span>
                                              <input
                                                name="healthCardDocBack"
                                                // value={values.i}
                                                ref={fileInputRef2}
                                                id="i"
                                                type="file"
                                                className="upload-file-hidden-input"
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    "healthCardDocBack",
                                                    e.target.files[0]
                                                  )
                                                }
                                              />
                                              <button
                                                type="button"
                                                className="upload-btn"
                                              >
                                                {t("Upload File")}
                                              </button>
                                            </div>
                                            <CustomErrorMessage
                                              name="healthCardDocBack"
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="upload-footer">
                                        <button
                                          type="button"
                                          className="upload-footer-btn"
                                          disabled={docUploadLoading}
                                          onClick={() =>
                                            handleSubmitDocument(
                                              values,
                                              "healthCardDoc"
                                            )
                                          }
                                        >
                                          {!docUploadLoading ? (
                                            t("Submit")
                                          ) : (
                                            <ButtonLoading />
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </>
                          ) : documentTab === "Passport" ? (
                            <>
                              <div className="add-body-content-container">
                                <div className="add-body-content-header">
                                  <h3 className="add-body-content-heading">
                                    {t("Passport")}
                                  </h3>
                                  {/* <div className="relative">
                                    <select
                                      value={values.lang}
                                      onChange={(e) =>
                                        setFieldValue("lang", e.target.value)
                                      }
                                      className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                    >
                                      <option value="en">English</option>
                                      <option value="ar">Arabic</option>
                                    </select>
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                      <DropDownIcon />
                                    </span>
                                  </div> */}
                                </div>
                                <div className="add-body-content-grid">
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="passportNo"
                                        >
                                          {t("Passport Number")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      <div className="add-input-wrapper">
                                        <input
                                          id="passportNo"
                                          name="passportNo"
                                          className="add-input"
                                          placeholder={t(
                                            "Enter Passport Number"
                                          )}
                                          value={values?.passportNo}
                                          onChange={(e) =>
                                            handlePassportNoChange(
                                              e,
                                              setFieldValue
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                      </div>
                                    </div>

                                    <ValidateIndicators
                                      isSearching={passportNoSearch.isSearching}
                                      validationResult={
                                        passportNoSearch.validationResult
                                      }
                                      error={passportNoSearch.error}
                                    />

                                    <CustomErrorMessage
                                      name="passportNo"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="passportExpiry"
                                        >
                                          {t("Passport Expiry")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      <div className="add-input-wrapper">
                                        <input
                                          type="date"
                                          id="passportExpiry"
                                          name="passportExpiry"
                                          className={`add-wrap-input ${
                                            !values?.passportExpiry ||
                                            values.passportExpiry ===
                                              "DD-MM-YYYY"
                                              ? "empty"
                                              : ""
                                          }`}
                                          placeholder="DD/MM/YYYY"
                                          min={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                          value={
                                            values?.passportExpiry
                                              ? formatDateToYYYYMMDD(
                                                  values.passportExpiry
                                                )
                                              : ""
                                          }
                                          onChange={(e) =>
                                            setFieldValue(
                                              "passportExpiry",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                        <img
                                          src={dateIcon}
                                          alt="date icon"
                                          className="add-date-input-in"
                                        />
                                      </div>
                                    </div>
                                    <CustomErrorMessage
                                      name="passportExpiry"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  </div>

                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="passportIssue"
                                        >
                                          {t("Passport Issue")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      <div className="add-input-wrapper">
                                        <input
                                          type="date"
                                          id="passportIssue"
                                          name="passportIssue"
                                          max={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                          className={`add-wrap-input ${
                                            !values?.passportIssue ||
                                            values.passportIssue ===
                                              "DD-MM-YYYY"
                                              ? "empty"
                                              : ""
                                          }`}
                                          placeholder="DD/MM/YYYY"
                                          value={
                                            values?.passportIssue
                                              ? formatDateToYYYYMMDD(
                                                  values.passportIssue
                                                )
                                              : ""
                                          }
                                          onChange={(e) =>
                                            setFieldValue(
                                              "passportIssue",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                        <img
                                          src={dateIcon}
                                          alt="date icon"
                                          className="add-date-input-in"
                                        />
                                      </div>
                                    </div>
                                    <CustomErrorMessage
                                      name="passportIssue"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  </div>

                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="issuePlace"
                                        >
                                          {t("Place of Issue")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      <div className="add-input-wrapper">
                                        <input
                                          id="issuePlace"
                                          name="issuePlace"
                                          className="add-input"
                                          placeholder={t(
                                            "Enter Place Of Issue"
                                          )}
                                          value={values?.issuePlace}
                                          onChange={(e) =>
                                            setFieldValue(
                                              "issuePlace",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                      </div>
                                    </div>
                                    <CustomErrorMessage
                                      name="issuePlace"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  </div>
                                </div>
                              </div>

                              <DocumentUploadDisplay
                                values={values}
                                frontDocKey="passportDocFront"
                                backDocKey="passportDocBack"
                                handleRemoveDocument={handleRemoveDocument}
                                setFieldValue={setFieldValue}
                                onDocModal={onDocModal}
                                errors={errors}
                                touched={touched}
                                customStyle={{ marginTop: "12px" }}
                              />

                              {docModal && (
                                <div className="upload-modal-overlay">
                                  <div className="upload-modal-content">
                                    <div className="upload-modal-header">
                                      <span className="upload-modal-title">
                                        {t("Upload Documents")}
                                      </span>
                                      <div className="upload-modal-icon-container">
                                        <img
                                          src={arrowIcon}
                                          alt="arrow icon"
                                          onClick={() =>
                                            closeDocModalPassport(setFieldValue)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="upload-body">
                                      <p className="upload-desc">
                                        {t(
                                          "Please select the import file from your device"
                                        )}
                                      </p>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="passportDocFront"
                                              className="upload-label"
                                            >
                                              {t("Front Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.passportDocFront
                                                ? values?.passportDocFront?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="passportDocFront"
                                              ref={fileInputRef1}
                                              id="passportDocFront"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "passportDocFront",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="passportDocFront"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="passportDocBack"
                                              className="upload-label"
                                            >
                                              {t("Back Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput2}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.passportDocBack
                                                ? values?.passportDocBack?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="passportDocBack"
                                              // value={values.i}
                                              ref={fileInputRef2}
                                              id="i"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "passportDocBack",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="passportDocBack"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="upload-footer">
                                      <button
                                        type="button"
                                        className="upload-footer-btn"
                                        disabled={docUploadLoading}
                                        onClick={() =>
                                          handleSubmitDocument(
                                            values,
                                            "passportDoc"
                                          )
                                        }
                                      >
                                        {!docUploadLoading ? (
                                          t("Submit")
                                        ) : (
                                          <ButtonLoading />
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : documentTab === "Visa" ? (
                            <>
                              <div className="add-body-content-container">
                                <div className="add-body-content-header">
                                  <h3 className="add-body-content-heading">
                                    {t("Visa")}
                                  </h3>
                                  {/* <div className="relative">
                                    <select
                                      value={values.lang}
                                      onChange={(e) =>
                                        setFieldValue("lang", e.target.value)
                                      }
                                      className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                    >
                                      <option value="en">English</option>
                                      <option value="ar">Arabic</option>
                                    </select>
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                      <DropDownIcon />
                                    </span>
                                  </div> */}
                                </div>
                                <div className="add-body-content-grid">
                                  {/* Visa Number */}
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="visaNo"
                                        >
                                          {t("Visa Number")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>{values?.visaNo || "-"}</span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            id="visaNo"
                                            name="visaNo"
                                            className="add-input"
                                            placeholder={t("Enter Visa Number")}
                                            value={values?.visaNo}
                                            onChange={(e) =>
                                              handleVisaNoChange(
                                                e,
                                                setFieldValue
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <>
                                        <ValidateIndicators
                                          isSearching={visaNoSearch.isSearching}
                                          validationResult={
                                            visaNoSearch.validationResult
                                          }
                                          error={visaNoSearch.error}
                                        />

                                        <CustomErrorMessage
                                          name="visaNo"
                                          errors={errors}
                                          touched={touched}
                                        />
                                      </>
                                    )}
                                  </div>

                                  {/* Visa Expiry */}
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="visaExpiry"
                                        >
                                          {t("Visa Expiry")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.visaExpiry || "-"}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            type="date"
                                            id="visaExpiry"
                                            name="visaExpiry"
                                            className={`add-wrap-input ${
                                              !values?.visaExpiry ||
                                              values.visaExpiry === "DD-MM-YYYY"
                                                ? "empty"
                                                : ""
                                            }`}
                                            placeholder="DD/MM/YYYY"
                                            min={
                                              new Date()
                                                .toISOString()
                                                .split("T")[0]
                                            }
                                            value={
                                              values?.visaExpiry
                                                ? formatDateToYYYYMMDD(
                                                    values.visaExpiry
                                                  )
                                                : ""
                                            }
                                            onChange={(e) =>
                                              setFieldValue(
                                                "visaExpiry",
                                                e.target.value
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                          <img
                                            src={dateIcon}
                                            alt="date icon"
                                            className="add-date-input-in"
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="visaExpiry"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                  </div>

                                  {/* Visa Issue */}
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="visaIssue"
                                        >
                                          {t("Visa Issue")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.visaIssue || "-"}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            type="date"
                                            id="visaIssue"
                                            name="visaIssue"
                                            className={`add-wrap-input ${
                                              !values?.visaIssue ||
                                              values.visaIssue === "DD-MM-YYYY"
                                                ? "empty"
                                                : ""
                                            }`}
                                            placeholder="DD/MM/YYYY"
                                            max={
                                              new Date()
                                                .toISOString()
                                                .split("T")[0]
                                            }
                                            value={
                                              values?.visaIssue
                                                ? formatDateToYYYYMMDD(
                                                    values.visaIssue
                                                  )
                                                : ""
                                            }
                                            onChange={(e) =>
                                              setFieldValue(
                                                "visaIssue",
                                                e.target.value
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                          <img
                                            src={dateIcon}
                                            alt="date icon"
                                            className="add-date-input-in"
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="visaIssue"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                  </div>

                                  {/* Place of Issue */}
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="visaIssuePlace"
                                        >
                                          {t("Place of Issue")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.visaIssuePlace || "-"}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            id="visaIssuePlace"
                                            name="visaIssuePlace"
                                            className="add-input"
                                            placeholder={t(
                                              "Enter Place Of Issue"
                                            )}
                                            value={values?.visaIssuePlace}
                                            onChange={(e) =>
                                              setFieldValue(
                                                "visaIssuePlace",
                                                e.target.value
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="visaIssuePlace"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                  </div>

                                  {/* Visa Type */}
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="visaType"
                                        >
                                          {t("Visa Type")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.visaType?.label || "-"}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <AsyncSelect
                                            id="visaType"
                                            name="visaType"
                                            value={values.visaType}
                                            onChange={(selectedOption) =>
                                              setFieldValue(
                                                "visaType",
                                                selectedOption
                                              )
                                            }
                                            loadOptions={loadVisaTypeOptions}
                                            defaultOptions={visaType}
                                            styles={asyncSelectStyles}
                                            cacheOptions
                                            placeholder={t("Select Visa Type")}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="visaType"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>

                              <DocumentUploadDisplay
                                values={values}
                                frontDocKey="visaDocFront"
                                backDocKey="visaDocBack"
                                handleRemoveDocument={handleRemoveDocument}
                                setFieldValue={setFieldValue}
                                t={t}
                                currentEmployeeEditing={currentEmployeeEditing}
                                onDocModal={onDocModal}
                                errors={errors}
                                touched={touched}
                                customStyle={{ marginTop: "12px" }}
                              />

                              {docModal && (
                                <div className="upload-modal-overlay">
                                  <div className="upload-modal-content">
                                    <div className="upload-modal-header">
                                      <span className="upload-modal-title">
                                        {t("Upload Documents")}
                                      </span>
                                      <div className="upload-modal-icon-container">
                                        <img
                                          src={arrowIcon}
                                          alt="arrow icon"
                                          onClick={() =>
                                            closeDocModalVisa(setFieldValue)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="upload-body">
                                      <p className="upload-desc">
                                        {t(
                                          "Please select the import file from your device"
                                        )}
                                      </p>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="visaDocFront"
                                              className="upload-label"
                                            >
                                              {t("Front Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.visaDocFront
                                                ? values?.visaDocFront?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="visaDocFront"
                                              ref={fileInputRef1}
                                              id="visaDocFront"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "visaDocFront",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="visaDocFront"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="visaDocBack"
                                              className="upload-label"
                                            >
                                              {t("Back Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput2}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.visaDocBack
                                                ? values?.visaDocBack?.name
                                                : "Upload Document"}
                                            </span>
                                            <input
                                              name="visaDocBack"
                                              // value={values.i}
                                              ref={fileInputRef2}
                                              id="i"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "visaDocBack",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>

                                          <CustomErrorMessage
                                            name="visaDocBack"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="upload-footer">
                                      <button
                                        type="button"
                                        className="upload-footer-btn"
                                        disabled={docUploadLoading}
                                        onClick={() =>
                                          handleSubmitDocument(
                                            values,
                                            "visaDoc"
                                          )
                                        }
                                      >
                                        {!docUploadLoading ? (
                                          t("Submit")
                                        ) : (
                                          <ButtonLoading />
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : documentTab === "Contract" ? (
                            <>
                              <div className="add-body-content-container">
                                <div className="add-body-content-header">
                                  <h3 className="add-body-content-heading">
                                    {t("Contract")}
                                  </h3>
                                  {/* <div className="relative">
                                    <select
                                      value={values.lang}
                                      onChange={(e) =>
                                        setFieldValue("lang", e.target.value)
                                      }
                                      className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                    >
                                      <option value="en">English</option>
                                      <option value="ar">Arabic</option>
                                    </select>
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                      <DropDownIcon />
                                    </span>
                                  </div> */}
                                </div>
                                <div className="add-body-content-grid">
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="contractNo"
                                        >
                                          {t("Contract Number")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.contractNo || "-"}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            id="contractNo"
                                            name="contractNo"
                                            className="add-input"
                                            placeholder={t(
                                              "Enter QIWA Contract Number"
                                            )}
                                            value={values?.contractNo}
                                            onChange={(e) =>
                                              handleContractNoChange(
                                                e,
                                                setFieldValue
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <>
                                        <ValidateIndicators
                                          isSearching={
                                            contractNoSearch.isSearching
                                          }
                                          validationResult={
                                            contractNoSearch.validationResult
                                          }
                                          error={contractNoSearch.error}
                                        />

                                        <CustomErrorMessage
                                          name="contractNo"
                                          errors={errors}
                                          touched={touched}
                                        />
                                      </>
                                    )}
                                  </div>

                                  {/* Contract End */}
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="contractEnd"
                                        >
                                          {t("Contract End")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.contractEnd || "-"}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            type="date"
                                            id="contractEnd"
                                            name="contractEnd"
                                            className={`add-wrap-input ${
                                              !values?.contractEnd ||
                                              values.contractEnd ===
                                                "DD-MM-YYYY"
                                                ? "empty"
                                                : ""
                                            }`}
                                            placeholder="DD/MM/YYYY"
                                            min={
                                              new Date()
                                                .toISOString()
                                                .split("T")[0]
                                            }
                                            value={
                                              values?.contractEnd
                                                ? formatDateToYYYYMMDD(
                                                    values.contractEnd
                                                  )
                                                : ""
                                            }
                                            onChange={(e) =>
                                              setFieldValue(
                                                "contractEnd",
                                                e.target.value
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                          <img
                                            src={dateIcon}
                                            alt="date icon"
                                            className="add-date-input-in"
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="contractEnd"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <DocumentUploadDisplay
                                values={values}
                                frontDocKey="contractDocFront"
                                backDocKey="contractDocBack"
                                handleRemoveDocument={handleRemoveDocument}
                                setFieldValue={setFieldValue}
                                currentEmployeeEditing={currentEmployeeEditing}
                                onDocModal={onDocModal}
                                errors={errors}
                                touched={touched}
                                customStyle={{ marginTop: "12px" }}
                              />

                              {docModal && (
                                <div className="upload-modal-overlay">
                                  <div className="upload-modal-content">
                                    <div className="upload-modal-header">
                                      <span className="upload-modal-title">
                                        {t("Upload Documents")}
                                      </span>
                                      <div className="upload-modal-icon-container">
                                        <img
                                          src={arrowIcon}
                                          alt="arrow icon"
                                          onClick={() =>
                                            closeDocModalContract(setFieldValue)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="upload-body">
                                      <p className="upload-desc">
                                        {t(
                                          "Please select the import file from your device"
                                        )}
                                      </p>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="contractDocFront"
                                              className="upload-label"
                                            >
                                              {t("Front Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.contractDocFront
                                                ? values?.contractDocFront?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="contractDocFront"
                                              ref={fileInputRef1}
                                              id="contractDocFront"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "contractDocFront",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="contractDocFront"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="contractDocBack"
                                              className="upload-label"
                                            >
                                              {t("Back Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput2}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.contractDocBack
                                                ? values?.contractDocBack?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="contractDocBack"
                                              // value={values.i}
                                              ref={fileInputRef2}
                                              id="i"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "contractDocBack",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="contractDocBack"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="upload-footer">
                                      <button
                                        type="button"
                                        className="upload-footer-btn"
                                        disabled={docUploadLoading}
                                        onClick={() =>
                                          handleSubmitDocument(
                                            values,
                                            "contractDoc"
                                          )
                                        }
                                      >
                                        {!docUploadLoading ? (
                                          t("Submit")
                                        ) : (
                                          <ButtonLoading />
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : documentTab === "Driving License" ? (
                            <>
                              <div className="add-body-content-container">
                                <div className="add-body-content-header">
                                  <h3 className="add-body-content-heading">
                                    {t("Driving License")}
                                  </h3>
                                  {/* <div className="relative">
                                    <select
                                      value={values.lang}
                                      onChange={(e) =>
                                        setFieldValue("lang", e.target.value)
                                      }
                                      className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                    >
                                      <option value="en">English</option>
                                      <option value="ar">Arabic</option>
                                    </select>
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                      <DropDownIcon />
                                    </span>
                                  </div> */}
                                </div>
                                <div className="add-body-content-grid">
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="drivingLicenseNo"
                                        >
                                          {t("Driving License Number")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      <div className="add-input-wrapper">
                                        <input
                                          id="drivingLicenseNo"
                                          name="drivingLicenseNo"
                                          className="add-input"
                                          placeholder={t(
                                            "Enter Driving License Number"
                                          )}
                                          value={values?.drivingLicenseNo}
                                          onChange={(e) =>
                                            handleDrivingLicenseNoChange(
                                              e,
                                              setFieldValue
                                            )
                                          }
                                          onBlur={handleBlur}
                                          // onChange={(e) => {
                                          //   const value = e.target.value;
                                          //   // if (/^[0-9]*$/.test(value)) {
                                          //   //   setFieldValue(
                                          //   //     "drivingLicenseNo",
                                          //   //     value
                                          //   //   );
                                          //   // }
                                          //   // For alphanumeric with specific format (e.g., ABC12345), use:
                                          //   if (/^[A-Za-z0-9]*$/.test(value)) {
                                          //     setFieldValue(
                                          //       "drivingLicenseNo",
                                          //       value
                                          //     );
                                          //   }
                                          // }}
                                        />
                                      </div>
                                    </div>
                                    <ValidateIndicators
                                      isSearching={
                                        drivingLicenseNoSearch.isSearching
                                      }
                                      validationResult={
                                        drivingLicenseNoSearch.validationResult
                                      }
                                      error={drivingLicenseNoSearch.error}
                                    />
                                    <CustomErrorMessage
                                      name="drivingLicenseNo"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="licenseValidity"
                                        >
                                          {t("Driving License Validity")}
                                        </label>
                                        <span className="add-req-mark">*</span>
                                      </div>
                                      <div className="add-input-wrapper">
                                        <input
                                          type="date"
                                          id="licenseValidity"
                                          name="licenseValidity"
                                          className={`add-wrap-input ${
                                            !values?.licenseValidity ||
                                            values.licenseValidity ===
                                              "DD-MM-YYYY"
                                              ? "empty"
                                              : ""
                                          }`}
                                          placeholder="DD/MM/YYYY"
                                          min={
                                            new Date()
                                              .toISOString()
                                              .split("T")[0]
                                          }
                                          value={
                                            values?.licenseValidity
                                              ? formatDateToYYYYMMDD(
                                                  values.licenseValidity
                                                )
                                              : ""
                                          }
                                          onChange={(e) =>
                                            setFieldValue(
                                              "licenseValidity",
                                              e.target.value
                                            )
                                          }
                                          onBlur={handleBlur}
                                        />
                                        <img
                                          src={dateIcon}
                                          alt="date icon"
                                          className="add-date-input-in"
                                        />
                                      </div>
                                    </div>
                                    <CustomErrorMessage
                                      name="licenseValidity"
                                      errors={errors}
                                      touched={touched}
                                    />
                                  </div>
                                </div>
                              </div>

                              <DocumentUploadDisplay
                                values={values}
                                frontDocKey="drivingLicenseDocFront"
                                backDocKey="drivingLicenseDocBack"
                                handleRemoveDocument={handleRemoveDocument}
                                setFieldValue={setFieldValue}
                                onDocModal={onDocModal}
                                errors={errors}
                                touched={touched}
                                customStyle={{ marginTop: "12px" }}
                              />

                              {docModal && (
                                <div className="upload-modal-overlay">
                                  <div className="upload-modal-content">
                                    <div className="upload-modal-header">
                                      <span className="upload-modal-title">
                                        {t("Upload Documents")}
                                      </span>
                                      <div className="upload-modal-icon-container">
                                        <img
                                          src={arrowIcon}
                                          alt="arrow icon"
                                          onClick={() =>
                                            closeDocModalLicense(setFieldValue)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="upload-body">
                                      <p className="upload-desc">
                                        {t(
                                          "Please select the import file from your device"
                                        )}
                                      </p>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="drivingLicenseDocFront"
                                              className="upload-label"
                                            >
                                              {t("Front Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.drivingLicenseDocFront
                                                ? values?.drivingLicenseDocFront
                                                    ?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="drivingLicenseDocFront"
                                              ref={fileInputRef1}
                                              id="drivingLicenseDocFront"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "drivingLicenseDocFront",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="drivingLicenseDocFront"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="drivingLicenseDocBack"
                                              className="upload-label"
                                            >
                                              {t("Back Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput2}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.drivingLicenseDocBack
                                                ? values?.drivingLicenseDocBack
                                                    ?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="drivingLicenseDocBack"
                                              // value={values.i}
                                              ref={fileInputRef2}
                                              id="i"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "drivingLicenseDocBack",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="drivingLicenseDocBack"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="upload-footer">
                                      <button
                                        type="button"
                                        className="upload-footer-btn"
                                        disabled={docUploadLoading}
                                        onClick={() =>
                                          handleSubmitDocument(
                                            values,
                                            "drivingLicenseDoc"
                                          )
                                        }
                                      >
                                        {!docUploadLoading ? (
                                          t("Submit")
                                        ) : (
                                          <ButtonLoading />
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : documentTab === "Subscription" ? (
                            <>
                              <div className="add-body-content-container">
                                <div className="add-body-content-header">
                                  <h3 className="add-body-content-heading">
                                    {t("Registrations")}
                                  </h3>
                                  {/* <div className="relative">
                                    <select
                                      value={values.lang}
                                      onChange={(e) =>
                                        setFieldValue("lang", e.target.value)
                                      }
                                      className="appearance-none w-full bg-[#F9FAFB] text-[#04080B] border border-[#F2F4F7] rounded-lg py-2 pl-4 pr-10 focus:outline-none focus:ring-2 focus:ring-gray-300"
                                    >
                                      <option value="en">English</option>
                                      <option value="ar">Arabic</option>
                                    </select>
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#F9FAFB] pointer-events-none">
                                      <DropDownIcon />
                                    </span>
                                  </div> */}
                                </div>
                                <div className="add-body-content-grid">
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="gosiRegNo"
                                        >
                                          {t("GOSI Registration Number")}
                                        </label>
                                        <span className="upload-req-mark">
                                          *
                                        </span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.gosiRegNo || "-"}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            id="gosiRegNo"
                                            name="gosiRegNo"
                                            className="add-input"
                                            placeholder={t(
                                              "Enter Registration Number"
                                            )}
                                            value={values?.gosiRegNo}
                                            onChange={(e) =>
                                              handleGosiRegNoChange(
                                                e,
                                                setFieldValue
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <>
                                        <ValidateIndicators
                                          isSearching={
                                            gosiRegNoSearch.isSearching
                                          }
                                          validationResult={
                                            gosiRegNoSearch.validationResult
                                          }
                                          error={gosiRegNoSearch.error}
                                        />

                                        <CustomErrorMessage
                                          name="gosiRegNo"
                                          errors={errors}
                                          touched={touched}
                                        />
                                      </>
                                    )}
                                  </div>

                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label className="add-label">
                                          {t("GOSI Registration")}
                                        </label>
                                        <span className="upload-req-mark">
                                          *
                                        </span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.gosiReg === "true"
                                              ? t("Yes")
                                              : t("No")}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-radio-input-container">
                                          <div className="add-radio-container">
                                            <input
                                              id="yes"
                                              type="radio"
                                              name="gosiReg"
                                              className="add-radio-input"
                                              value="true"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "gosiReg",
                                                  e.target.value
                                                )
                                              }
                                              checked={
                                                values?.gosiReg === "true"
                                              }
                                            />
                                            <label
                                              htmlFor="yes"
                                              className="add-label"
                                            >
                                              {t("Yes")}
                                            </label>
                                          </div>
                                          <div className="add-radio-container">
                                            <input
                                              id="no"
                                              type="radio"
                                              name="gosiReg"
                                              className="add-radio-input"
                                              value="false"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "gosiReg",
                                                  e.target.value
                                                )
                                              }
                                              checked={
                                                values?.gosiReg === "false"
                                              }
                                            />
                                            <label
                                              htmlFor="no"
                                              className="add-label"
                                            >
                                              {t("No")}
                                            </label>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="gosiReg"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                  </div>
                                </div>

                                <DocumentUploadDisplay
                                  values={values}
                                  frontDocKey="gosiDocFront"
                                  backDocKey="gosiDocBack"
                                  handleRemoveDocument={handleRemoveDocument}
                                  setFieldValue={setFieldValue}
                                  currentEmployeeEditing={
                                    currentEmployeeEditing
                                  }
                                  onDocModal={onDocModalGosi}
                                  errors={errors}
                                  touched={touched}
                                  customStyle={{ marginTop: "12px" }}
                                  headerText="Upload GOSI Documents"
                                />

                                {/* Mudad Registration Number (conditional) */}
                                <div className="add-body-content-grid">
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label
                                          className="add-label"
                                          htmlFor="mudadRegNo"
                                        >
                                          {t("Mudad Registration Number")}
                                        </label>
                                        <span className="upload-req-mark">
                                          *
                                        </span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.mudadRegNo || "-"}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-input-wrapper">
                                          <input
                                            id="mudadRegNo"
                                            name="mudadRegNo"
                                            className="add-input"
                                            placeholder={t(
                                              "Enter Registration Number"
                                            )}
                                            value={values?.mudadRegNo}
                                            onChange={(e) =>
                                              handleMudadRegNoChange(
                                                e,
                                                setFieldValue
                                              )
                                            }
                                            onBlur={handleBlur}
                                          />
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <>
                                        <ValidateIndicators
                                          isSearching={
                                            mudadRegNoSearch.isSearching
                                          }
                                          validationResult={
                                            mudadRegNoSearch.validationResult
                                          }
                                          error={mudadRegNoSearch.error}
                                        />
                                        <CustomErrorMessage
                                          name="mudadRegNo"
                                          errors={errors}
                                          touched={touched}
                                        />
                                      </>
                                    )}
                                  </div>

                                  {/* Mudad Registration Radio */}
                                  <div className="form-group">
                                    <div className="add-body-input-section">
                                      <div className="add-label-container">
                                        <label className="add-label">
                                          {t("Mudad Registration")}
                                        </label>
                                        <span className="upload-req-mark">
                                          *
                                        </span>
                                      </div>
                                      {currentEmployeeEditing ? (
                                        <div className="add-input-value">
                                          <span>
                                            {values?.mudadReg === "true"
                                              ? t("Yes")
                                              : t("No")}
                                          </span>
                                          <span className="add-input-badge">
                                            {noEditingMsg}
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="add-radio-input-container">
                                          <div className="add-radio-container">
                                            <input
                                              id="yes"
                                              type="radio"
                                              name="mudadReg"
                                              className="add-radio-input"
                                              value="true"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "mudadReg",
                                                  e.target.value
                                                )
                                              }
                                              checked={
                                                values?.mudadReg === "true"
                                              }
                                            />
                                            <label
                                              htmlFor="yes"
                                              className="add-label"
                                            >
                                              {t("Yes")}
                                            </label>
                                          </div>
                                          <div className="add-radio-container">
                                            <input
                                              id="no"
                                              type="radio"
                                              name="mudadReg"
                                              className="add-radio-input"
                                              value="false"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "mudadReg",
                                                  e.target.value
                                                )
                                              }
                                              checked={
                                                values?.mudadReg === "false"
                                              }
                                            />
                                            <label
                                              htmlFor="no"
                                              className="add-label"
                                            >
                                              {t("No")}
                                            </label>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    {!currentEmployeeEditing && (
                                      <CustomErrorMessage
                                        name="mudadReg"
                                        errors={errors}
                                        touched={touched}
                                      />
                                    )}
                                  </div>
                                </div>
                                <DocumentUploadDisplay
                                  values={values}
                                  frontDocKey="subscriptionDocFront"
                                  backDocKey="subscriptionDocBack"
                                  handleRemoveDocument={handleRemoveDocument}
                                  setFieldValue={setFieldValue}
                                  currentEmployeeEditing={
                                    currentEmployeeEditing
                                  }
                                  onDocModal={onDocModal}
                                  errors={errors}
                                  touched={touched}
                                  customStyle={{ marginTop: "12px" }}
                                  headerText="Upload Mudad Documents"
                                />
                              </div>

                              {docModalGosi && (
                                <div className="upload-modal-overlay">
                                  <div className="upload-modal-content">
                                    <div className="upload-modal-header">
                                      <span className="upload-modal-title">
                                        {t("Upload Documents")}
                                      </span>
                                      <div className="upload-modal-icon-container">
                                        <img
                                          src={arrowIcon}
                                          alt="arrow icon"
                                          onClick={() =>
                                            closeDocModalGosi(setFieldValue)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="upload-body">
                                      <p className="upload-desc">
                                        {t(
                                          "Please select the import file from your device"
                                        )}
                                      </p>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="gosiDocFront"
                                              className="upload-label"
                                            >
                                              {t("GOSI Front Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInputGosi}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.gosiDocFront
                                                ? values?.gosiDocFront?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="gosiDocFront"
                                              ref={fileInputRef1Gosi}
                                              id="gosiDocFront"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "gosiDocFront",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="gosiDocFront"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="gosiDocBack"
                                              className="upload-label"
                                            >
                                              {t("GOSI Back Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput2Gosi}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.gosiDocBack
                                                ? values?.gosiDocBack?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="gosiDocBack"
                                              // value={values.i}
                                              ref={fileInputRef2Gosi}
                                              id="i"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "gosiDocBack",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="gosiDocBack"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="upload-footer">
                                      <button
                                        type="button"
                                        className="upload-footer-btn"
                                        disabled={docUploadLoading}
                                        onClick={() =>
                                          handleSubmitDocument(
                                            values,
                                            "gosiDoc",
                                            true
                                          )
                                        }
                                      >
                                        {!docUploadLoading ? (
                                          t("Submit")
                                        ) : (
                                          <ButtonLoading />
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {docModal && (
                                <div className="upload-modal-overlay">
                                  <div className="upload-modal-content">
                                    <div className="upload-modal-header">
                                      <span className="upload-modal-title">
                                        {t("Upload Documents")}
                                      </span>
                                      <div className="upload-modal-icon-container">
                                        <img
                                          src={arrowIcon}
                                          alt="arrow icon"
                                          onClick={() =>
                                            closeDocModalSubscription(
                                              setFieldValue
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="upload-body">
                                      <p className="upload-desc">
                                        {t(
                                          "Please select the import file from your device"
                                        )}
                                      </p>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="subscriptionDocFront"
                                              className="upload-label"
                                            >
                                              {t("Mudad Front Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.subscriptionDocFront
                                                ? values?.subscriptionDocFront
                                                    ?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="subscriptionDocFront"
                                              ref={fileInputRef1}
                                              id="subscriptionDocFront"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "subscriptionDocFront",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="subscriptionDocFront"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                      <div className="upload-file-input-container">
                                        <div className="upload-file-input-container2">
                                          <div className="upload-label-container">
                                            <label
                                              htmlFor="subscriptionDocBack"
                                              className="upload-label"
                                            >
                                              {t("Mudad Back Document")}
                                            </label>
                                            {/* <span className="upload-req-mark">
                                          *
                                        </span> */}
                                          </div>
                                          <div
                                            className="upload-file-input-wrapper"
                                            onClick={handleOpenFileInput2}
                                          >
                                            <span className="upload-file-input-replacer">
                                              {values?.subscriptionDocBack
                                                ? values?.subscriptionDocBack
                                                    ?.name
                                                : t("Upload Document")}
                                            </span>
                                            <input
                                              name="subscriptionDocBack"
                                              // value={values.i}
                                              ref={fileInputRef2}
                                              id="i"
                                              type="file"
                                              className="upload-file-hidden-input"
                                              onChange={(e) =>
                                                setFieldValue(
                                                  "subscriptionDocBack",
                                                  e.target.files[0]
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="upload-btn"
                                            >
                                              {t("Upload File")}
                                            </button>
                                          </div>
                                          <CustomErrorMessage
                                            name="subscriptionDocBack"
                                            errors={errors}
                                            touched={touched}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="upload-footer">
                                      <button
                                        type="button"
                                        className="upload-footer-btn"
                                        disabled={docUploadLoading}
                                        onClick={() =>
                                          handleSubmitDocument(
                                            values,
                                            "subscriptionDoc"
                                          )
                                        }
                                      >
                                        {!docUploadLoading ? (
                                          t("Submit")
                                        ) : (
                                          <ButtonLoading />
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : null}
                        </>
                      )}
                    </>
                  ) : detailsStep === 4 ? (
                    <>
                      <div className="add-body-content-container margin-rm">
                        <div className="add-body-content-header">
                          <h3 className="add-body-content-heading">
                            {t("Dependents Info")}
                          </h3>
                        </div>
                        <div className="add-body-content-grid">
                          <div className="form-group">
                            <div className="add-body-input-section">
                              <div className="add-label-container">
                                <label className="add-label">
                                  {t("Dependents")}
                                </label>
                                <span className="upload-req-mark">*</span>
                              </div>
                              <div className="add-radio-input-container">
                                <div className="add-radio-container">
                                  <input
                                    id="yes"
                                    type="radio"
                                    name="isDependents"
                                    className="add-radio-input"
                                    value="true" // Set the value directly
                                    onChange={(e) =>
                                      setFieldValue(
                                        "isDependents",
                                        e.target.value
                                      )
                                    }
                                    checked={values?.isDependents === "true"} // Bind checked state
                                  />
                                  <label htmlFor="yes" className="add-label">
                                    {t("Yes")}
                                  </label>
                                </div>
                                <div className="add-radio-container">
                                  <input
                                    id="no"
                                    type="radio"
                                    name="isDependents"
                                    className="add-radio-input"
                                    value="false"
                                    onChange={(e) =>
                                      setFieldValue(
                                        "isDependents",
                                        e.target.value
                                      )
                                    }
                                    checked={values?.isDependents === "false"} // Bind checked state
                                  />
                                  <label htmlFor="no" className="add-label">
                                    {t("No")}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <CustomErrorMessage
                              name="isDependents"
                              errors={errors}
                              touched={touched}
                            />
                          </div>
                        </div>
                      </div>
                      {values?.isDependents == "true" && (
                        <div className="add-body-content-container">
                          <div className="add-body-content-header">
                            <h3 className="add-body-content-heading">
                              {t("Add Dependents Info")}
                            </h3>
                            <div
                              className="add-member-btn-container"
                              onClick={handleClickAddMember}
                            >
                              <img src={addIcon} alt="plus icon" />
                              <span className="add-member-txt">
                                {t("Add Member")}
                              </span>
                            </div>
                          </div>
                          {/* <FieldArray name="members">
                   {({ push, remove }) => (
                     <>
                       <div
                         ref={addMemberRef}
                         className="add-member-btn-container-hidden"
                         onClick={() => push({ name: "" })} // Add a new member with an empty name
                       >
                         <img src={addIcon} alt="plus icon" />
                         <span className="add-member-txt">Add Member</span>
                       </div>

                       {values.members && values.members.length >= 0 && (
                         <div className="members-container">
                           {values.members.map((member, index) => (
                             <div key={index} className="member-row">
                               <div className="add-field-wrapper">
                                 <div className="add-member-input-wrap">
                                   <span className="member-no">
                                     {index + 1}.{" "}
                                   </span>

                                   <Field
                                     name={`members[${index}].name`}
                                     placeholder="Enter name"
                                     className="member-input"
                                   />
                                   <button
                                     type="button"
                                     className="remove-member-btn"
                                     onClick={() => remove(index)} // Remove the member
                                   >
                                     Remove Member
                                   </button>
                                 </div>
                                 <CustomErrorMessage
                                   name={`members[${index}].name`}
                                   errors={errors}
                                   touched={touched}
                                 />
                               </div>
                             </div>
                           ))}
                         </div>
                       )}
                     </>
                   )}
                 </FieldArray> */}

                          <FieldArray name="members">
                            {({ push, remove }) => (
                              <>
                                {/* Members Summary Section */}
                                {values?.members?.length > 0 && (
                                  <div className="members-summary-container">
                                    {values.members &&
                                      values.members.map((member, index) => (
                                        <>
                                          {!dependentEditing ? (
                                            <div
                                              key={index}
                                              className="member-summary-row"
                                            >
                                              <>
                                                <span className="member-label">{`${t(
                                                  "Member"
                                                )} ${index + 1}`}</span>
                                                {activeMemberIndex > 0 &&
                                                  index !==
                                                    values?.members?.length -
                                                      1 && (
                                                    <button
                                                      type="button"
                                                      className="edit-member-btn"
                                                      onClick={() => {
                                                        setActiveMemberIndex(
                                                          index
                                                        );
                                                        setDependentEditing(
                                                          !dependentEditing
                                                        );
                                                      }} // Set the member to edit
                                                    >
                                                      {t("Edit")}
                                                    </button>
                                                  )}
                                                <button
                                                  type="button"
                                                  className="member-summary-remove"
                                                  onClick={() => {
                                                    remove(index);
                                                    if (
                                                      index ===
                                                      activeMemberIndex
                                                    ) {
                                                      // If the removed member was the active member
                                                      if (
                                                        values.members.length >
                                                        1
                                                      ) {
                                                        // Set the active member to the previous member
                                                        setActiveMemberIndex(
                                                          index > 0
                                                            ? index - 1
                                                            : 0
                                                        );
                                                      } else {
                                                        // No members left, reset active member
                                                        setActiveMemberIndex(
                                                          null
                                                        );
                                                      }
                                                    } else if (
                                                      index < activeMemberIndex
                                                    ) {
                                                      // If the removed member was before the active member
                                                      setActiveMemberIndex(
                                                        activeMemberIndex - 1
                                                      );
                                                    }
                                                  }}
                                                >
                                                  {t("Remove")}
                                                </button>
                                              </>
                                            </div>
                                          ) : (
                                            activeMemberIndex === index && (
                                              <>
                                                <div className="save-summary-container">
                                                  <span className="member-label">{`${t(
                                                    "Member"
                                                  )} ${index + 1}`}</span>

                                                  <div className="save-btn-container">
                                                    <button
                                                      onClick={() => {
                                                        setDependentEditing(
                                                          !dependentEditing
                                                        );
                                                        setActiveMemberIndex(
                                                          values?.members
                                                            ?.length - 1
                                                        );
                                                      }}
                                                      className="dep-save-btn"
                                                    >
                                                      {t("Save")}
                                                    </button>
                                                  </div>
                                                </div>
                                              </>
                                            )
                                          )}
                                        </>
                                      ))}
                                  </div>
                                )}

                                {/* Input Section for Active Member */}

                                {values?.members?.length > 0 && (
                                  <div className="active-member-input-section">
                                    {activeMemberIndex !== null && (
                                      <>
                                        <div className="row gx-4 gy-4">
                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  htmlFor={`members[${activeMemberIndex}].depFirstName`}
                                                >
                                                  {t("First Name")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <input
                                                name={`members[${activeMemberIndex}].depFirstName`}
                                                placeholder={t(
                                                  "Enter Dependent Name"
                                                )}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depFirstName
                                                }
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depFirstName`,
                                                    e.target.value
                                                  )
                                                }
                                                onBlur={handleBlur}
                                                className="member-input"
                                              />
                                              <CustomErrorMsgArray
                                                name={`members[${activeMemberIndex}].depFirstName`}
                                                errors={errors}
                                                touched={touched}
                                              />
                                            </div>
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <label
                                                htmlFor={`members[${activeMemberIndex}].depSecondName`}
                                              >
                                                {t("Second Name")}
                                              </label>
                                              <input
                                                name={`members[${activeMemberIndex}].depSecondName`}
                                                placeholder={t(
                                                  "Enter Dependent Second Name"
                                                )}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depSecondName
                                                }
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depSecondName`,
                                                    e.target.value
                                                  )
                                                }
                                                onBlur={handleBlur}
                                                className="member-input"
                                              />
                                              <CustomErrorMsgArray
                                                name={`members[${activeMemberIndex}].depSecondName`}
                                                errors={errors}
                                                touched={touched}
                                              />
                                            </div>
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <label
                                                htmlFor={`members[${activeMemberIndex}].depThirdName`}
                                              >
                                                {t("Third Name")}
                                              </label>
                                              <input
                                                name={`members[${activeMemberIndex}].depThirdName`}
                                                placeholder={t(
                                                  "Enter Dependent Third Name"
                                                )}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depThirdName
                                                }
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depThirdName`,
                                                    e.target.value
                                                  )
                                                }
                                                onBlur={handleBlur}
                                                className="member-input"
                                              />
                                              <CustomErrorMsgArray
                                                name={`members[${activeMemberIndex}].depThirdName`}
                                                errors={errors}
                                                touched={touched}
                                              />
                                            </div>
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  htmlFor={`members[${activeMemberIndex}].depFourthName`}
                                                >
                                                  {t("Last Name")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <input
                                                name={`members[${activeMemberIndex}].depFourthName`}
                                                placeholder={t(
                                                  "Enter Dependent Last Name"
                                                )}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depFourthName
                                                }
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depFourthName`,
                                                    e.target.value
                                                  )
                                                }
                                                onBlur={handleBlur}
                                                className="member-input"
                                              />
                                              <CustomErrorMsgArray
                                                name={`members[${activeMemberIndex}].depFourthName`}
                                                errors={errors}
                                                touched={touched}
                                              />
                                            </div>
                                          </div>

                                          {/* <div className="col-md-3">
                                   <div className="add-body-input-section">
                                     <label
                                       htmlFor={`members[${activeMemberIndex}].depIdNumber`}
                                     >
                                       IQAMA / ID Number
                                     </label>
                                     <input
                                       name={`members[${activeMemberIndex}].depIdNumber`}
                                       placeholder="Enter Dependent Name"
                                       value={
                                         values.members[activeMemberIndex]
                                           ?.depIdNumber
                                       }
                                       onChange={(e) =>
                                         setFieldValue(
                                           `members[${activeMemberIndex}].depIdNumber`,
                                           e.target.value
                                         )
                                       }
                                       className="member-input"
                                     />
                                     <CustomErrorMsgArray
                                       name={`members[${activeMemberIndex}].depIdNumber`}
                                       errors={errors}
                                       touched={touched}
                                     />
                                   </div>
                                 </div> */}

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  className="add-label"
                                                  htmlFor={`members[${activeMemberIndex}].depPassportNo`}
                                                >
                                                  {t("Passport Number")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <input
                                                id={`members[${activeMemberIndex}].depPassportNo`}
                                                name={`members[${activeMemberIndex}].depPassportNo`}
                                                className="add-input"
                                                placeholder={t(
                                                  "Enter Passport Number"
                                                )}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depPassportNo
                                                }
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depPassportNo`,
                                                    e.target.value
                                                  )
                                                }
                                                onBlur={handleBlur}
                                              />
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depPassportNo`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  className="add-label"
                                                  htmlFor={`members[${activeMemberIndex}].depPassportExpiry`}
                                                >
                                                  {t("Passport Expiry")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <div className="add-input-wrapper">
                                                <input
                                                  type="date"
                                                  id={`members[${activeMemberIndex}].depPassportExpiry`}
                                                  name={`members[${activeMemberIndex}].depPassportExpiry`}
                                                  className={`add-wrap-input ${
                                                    !values?.members?.[
                                                      activeMemberIndex
                                                    ]?.depPassportExpiry ||
                                                    values.members[
                                                      activeMemberIndex
                                                    ]?.depPassportExpiry ===
                                                      "DD-MM-YYYY"
                                                      ? "empty"
                                                      : ""
                                                  }`}
                                                  placeholder="DD/MM/YYYY"
                                                  value={
                                                    values.members[
                                                      activeMemberIndex
                                                    ]?.depPassportExpiry
                                                      ? formatDateToYYYYMMDD(
                                                          values.members[
                                                            activeMemberIndex
                                                          ]?.depPassportExpiry
                                                        )
                                                      : ""
                                                  }
                                                  onChange={(e) =>
                                                    setFieldValue(
                                                      `members[${activeMemberIndex}].depPassportExpiry`,
                                                      e.target.value
                                                    )
                                                  }
                                                  onBlur={handleBlur}
                                                />
                                                <img
                                                  src={dateIcon}
                                                  alt="date icon"
                                                  className="add-date-input-in"
                                                />
                                              </div>
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depPassportExpiry`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  className="add-label"
                                                  htmlFor={`members[${activeMemberIndex}].depContactNo`}
                                                >
                                                  {t("Contact Number")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <input
                                                id={`members[${activeMemberIndex}].depContactNo`}
                                                name={`members[${activeMemberIndex}].depContactNo`}
                                                className="add-input"
                                                placeholder={t(
                                                  "Enter Contact Number"
                                                )}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depContactNo
                                                }
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depContactNo`,
                                                    e.target.value
                                                  )
                                                }
                                                onBlur={handleBlur}
                                              />
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depContactNo`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  className="add-label"
                                                  htmlFor={`members[${activeMemberIndex}].depDob`}
                                                >
                                                  {t("Date Of Birth")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <div className="add-input-wrapper">
                                                <input
                                                  type="date"
                                                  id={`members[${activeMemberIndex}].depDob`}
                                                  name={`members[${activeMemberIndex}].depDob`}
                                                  className={`add-wrap-input ${
                                                    !values?.members?.[
                                                      activeMemberIndex
                                                    ]?.depDob ||
                                                    values.members[
                                                      activeMemberIndex
                                                    ]?.depDob === "DD-MM-YYYY"
                                                      ? "empty"
                                                      : ""
                                                  }`}
                                                  placeholder="DD/MM/YYYY"
                                                  value={
                                                    values.members[
                                                      activeMemberIndex
                                                    ]?.depDob
                                                      ? formatDateToYYYYMMDD(
                                                          values.members[
                                                            activeMemberIndex
                                                          ]?.depDob
                                                        )
                                                      : ""
                                                  }
                                                  onChange={(e) =>
                                                    setFieldValue(
                                                      `members[${activeMemberIndex}].depDob`,
                                                      e.target.value
                                                    )
                                                  }
                                                  onBlur={handleBlur}
                                                />
                                                <img
                                                  src={dateIcon}
                                                  alt="date icon"
                                                  className="add-date-input-in"
                                                />
                                              </div>
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depDob`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  className="add-label"
                                                  htmlFor={`members[${activeMemberIndex}].depRelation`}
                                                >
                                                  {t("Relation")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <AsyncSelect
                                                id={`members[${activeMemberIndex}].depRelation`}
                                                name={`members[${activeMemberIndex}].depRelation`}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depRelation || ""
                                                }
                                                onChange={(selectedOption) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depRelation`,
                                                    selectedOption
                                                  )
                                                }
                                                loadOptions={
                                                  loadDepRelationOptions
                                                }
                                                defaultOptions={
                                                  depRelationOptions
                                                }
                                                styles={asyncSelectStyles}
                                                cacheOptions
                                                placeholder={t(
                                                  "Select Relation"
                                                )}
                                              />
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depRelation`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  className="add-label"
                                                  htmlFor={`members[${activeMemberIndex}].depReligion`}
                                                >
                                                  {t("Religion")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <AsyncSelect
                                                id={`members[${activeMemberIndex}].depReligion`}
                                                name={`members[${activeMemberIndex}].depReligion`}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depReligion || ""
                                                }
                                                onChange={(selectedOption) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depReligion`,
                                                    selectedOption
                                                  )
                                                }
                                                loadOptions={
                                                  onSearchReligionDebounce
                                                }
                                                defaultOptions={religionOptions}
                                                styles={asyncSelectStyles}
                                                cacheOptions
                                                placeholder={t(
                                                  "Select Religion"
                                                )}
                                              />
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depReligion`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  className="add-label"
                                                  htmlFor={`members[${activeMemberIndex}].depNationality`}
                                                >
                                                  {t("Nationality")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <AsyncSelect
                                                id={`members[${activeMemberIndex}].depNationality`}
                                                name={`members[${activeMemberIndex}].depNationality`}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depNationality || ""
                                                }
                                                onChange={(selectedOption) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depNationality`,
                                                    selectedOption
                                                  )
                                                }
                                                loadOptions={loadOptions}
                                                defaultOptions={countryOptions}
                                                styles={asyncSelectStyles}
                                                cacheOptions
                                                placeholder={t(
                                                  "Select Nationality"
                                                )}
                                              />
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depNationality`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  className="add-label"
                                                  htmlFor={`members[${activeMemberIndex}].depSponsorName`}
                                                >
                                                  {t("Sponsor Name")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <input
                                                id={`members[${activeMemberIndex}].depSponsorName`}
                                                name={`members[${activeMemberIndex}].depSponsorName`}
                                                className="add-input"
                                                placeholder={t(
                                                  "Enter Sponsor Name"
                                                )}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depSponsorName
                                                }
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depSponsorName`,
                                                    e.target.value
                                                  )
                                                }
                                                onBlur={handleBlur}
                                              />
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depSponsorName`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  className="add-label"
                                                  htmlFor={`members[${activeMemberIndex}].depSponsorId`}
                                                >
                                                  {t("Sponsor ID")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <input
                                                name={`members[${activeMemberIndex}].depSponsorId`}
                                                value={
                                                  values.members[
                                                    activeMemberIndex
                                                  ]?.depSponsorId || ""
                                                }
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    `members[${activeMemberIndex}].depSponsorId`,
                                                    e.target.value
                                                  )
                                                }
                                                onBlur={handleBlur}
                                                placeholder={t(
                                                  "Enter Sponsor ID"
                                                )}
                                                className="add-input"
                                              />
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depSponsorId`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label className="add-label">
                                                  {t("Citizen")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <div className="add-radio-input-container">
                                                <div className="add-radio-container">
                                                  <input
                                                    id={`members[${activeMemberIndex}].yes`}
                                                    type="radio"
                                                    name={`members[${activeMemberIndex}].depCitizen`}
                                                    className="add-radio-input"
                                                    value="true"
                                                    onChange={(e) =>
                                                      setFieldValue(
                                                        `members[${activeMemberIndex}].depCitizen`,
                                                        e.target.value
                                                      )
                                                    }
                                                    checked={
                                                      values.members[
                                                        activeMemberIndex
                                                      ]?.depCitizen === "true"
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`members[${activeMemberIndex}].yes`}
                                                    className="add-label"
                                                  >
                                                    {t("Yes")}
                                                  </label>
                                                </div>
                                                <div className="add-radio-container">
                                                  <input
                                                    id={`members[${activeMemberIndex}].no`}
                                                    type="radio"
                                                    name={`members[${activeMemberIndex}].depCitizen`}
                                                    className="add-radio-input"
                                                    value="false"
                                                    onChange={(e) =>
                                                      setFieldValue(
                                                        `members[${activeMemberIndex}].depCitizen`,
                                                        e.target.value
                                                      )
                                                    }
                                                    checked={
                                                      values.members[
                                                        activeMemberIndex
                                                      ]?.depCitizen === "false"
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`members[${activeMemberIndex}].no`}
                                                    className="add-label"
                                                  >
                                                    {t("No")}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depCitizen`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label
                                                  className="add-label"
                                                  htmlFor={`members[${activeMemberIndex}].depMaritalStatus`}
                                                >
                                                  {t("Marital Status")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <div className="add-radio-input-container">
                                                <div className="add-radio-container">
                                                  <input
                                                    id={`members[${activeMemberIndex}].married`}
                                                    type="radio"
                                                    name={`members[${activeMemberIndex}].depMaritalStatus`}
                                                    className="add-radio-input"
                                                    value="Married"
                                                    onChange={(e) =>
                                                      setFieldValue(
                                                        `members[${activeMemberIndex}].depMaritalStatus`,
                                                        e.target.value
                                                      )
                                                    }
                                                    checked={
                                                      values.members[
                                                        activeMemberIndex
                                                      ]?.depMaritalStatus ===
                                                      "Married"
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`members[${activeMemberIndex}].married`}
                                                    className="add-label"
                                                  >
                                                    {t("Married")}
                                                  </label>
                                                </div>
                                                <div className="add-radio-container">
                                                  <input
                                                    id={`members[${activeMemberIndex}].single`}
                                                    type="radio"
                                                    name={`members[${activeMemberIndex}].depMaritalStatus`}
                                                    className="add-radio-input"
                                                    value="Single"
                                                    onChange={(e) =>
                                                      setFieldValue(
                                                        `members[${activeMemberIndex}].depMaritalStatus`,
                                                        e.target.value
                                                      )
                                                    }
                                                    checked={
                                                      values.members[
                                                        activeMemberIndex
                                                      ]?.depMaritalStatus ===
                                                      "Single"
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`members[${activeMemberIndex}].single`}
                                                    className="add-label"
                                                  >
                                                    {t("Single")}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depMaritalStatus`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>

                                          <div className="col-md-3">
                                            <div className="add-body-input-section">
                                              <div className="add-label-container">
                                                <label className="add-label">
                                                  {t("Gender")}
                                                </label>
                                                {/* <span className="add-req-mark">*</span> */}
                                              </div>
                                              <div className="add-radio-input-container">
                                                <div className="add-radio-container">
                                                  <input
                                                    id={`members[${activeMemberIndex}].male`}
                                                    type="radio"
                                                    name={`members[${activeMemberIndex}].depGender`}
                                                    className="add-radio-input"
                                                    value="Male"
                                                    onChange={(e) =>
                                                      setFieldValue(
                                                        `members[${activeMemberIndex}].depGender`,
                                                        e.target.value
                                                      )
                                                    }
                                                    checked={
                                                      values.members[
                                                        activeMemberIndex
                                                      ]?.depGender === "Male"
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`members[${activeMemberIndex}].male`}
                                                    className="add-label"
                                                  >
                                                    {t("Male")}
                                                  </label>
                                                </div>
                                                <div className="add-radio-container">
                                                  <input
                                                    id={`members[${activeMemberIndex}].female`}
                                                    type="radio"
                                                    name={`members[${activeMemberIndex}].depGender`}
                                                    className="add-radio-input"
                                                    value="Female"
                                                    onChange={(e) =>
                                                      setFieldValue(
                                                        `members[${activeMemberIndex}].depGender`,
                                                        e.target.value
                                                      )
                                                    }
                                                    checked={
                                                      values.members[
                                                        activeMemberIndex
                                                      ]?.depGender === "Female"
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={`members[${activeMemberIndex}].female`}
                                                    className="add-label"
                                                  >
                                                    {t("Female")}
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                            <CustomErrorMsgArray
                                              name={`members[${activeMemberIndex}].depGender`}
                                              errors={errors}
                                              touched={touched}
                                            />
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                )}

                                {/* Add Member Button */}
                                <div
                                  className="add-member-btn-container"
                                  style={{ display: "none" }}
                                  ref={addMemberRef}
                                  onClick={() => {
                                    push({
                                      publicId: null,
                                      depFirstName: "",
                                      depSecondName: "",
                                      depThirdName: "",
                                      depFourthName: "",
                                      depIdNumber: "",
                                      idExpiry: null,
                                      depPassportNo: "",
                                      depPassportExpiry: null,
                                      depContactNo: "",
                                      depDob: null,
                                      depGender: "",
                                      depCitizen: "",
                                      depNationality: null,
                                      depSponsorName: "",
                                      depSponsorId: "",
                                      depReligion: null,
                                      depMaritalStatus: "",
                                      depRelation: null,
                                    });
                                    setActiveMemberIndex(values.members.length); // Set the new member as active
                                  }}
                                >
                                  <img src={addIcon} alt="plus icon" />
                                  <span className="add-member-txt">
                                    {t("Add Member")}
                                  </span>
                                </div>
                              </>
                            )}
                          </FieldArray>
                        </div>
                      )}
                    </>
                  ) : null}
                </div>
                <div className="footer-wrapper">
                  {!currentEmployeeEditing &&
                    ((!latestPublicId && detailsStep === 4) ||
                    (personalInfo?.userInvitation !== "true" &&
                      detailsStep === 4) ? (
                      <div className="flex justify-end">
                        <div className="flex items-center gap-2 px-3 pb-3">
                          <label
                            htmlFor="userInvitation"
                            className="text-sm font-medium text-gray-700"
                          >
                            {t("Send Invitation")}
                          </label>
                          <CustomCheckbox
                            checked={values.userInvitation === "true"}
                            onChange={() =>
                              setFieldValue(
                                "userInvitation",
                                values.userInvitation === "true"
                                  ? "false"
                                  : "true"
                              )
                            }
                          />
                        </div>
                      </div>
                    ) : personalInfo?.userInvitation === "true" &&
                      !invitePending ? (
                      <div className="flex justify-end">
                        <div className="flex items-center gap-2 px-3 pb-3">
                          <span className="text-green-600 text-sm font-medium">
                            {t("User already invited")}
                          </span>
                          <CustomCheckbox
                            checked={true}
                            onChange={() => {}}
                            className="opacity-50 cursor-not-allowed"
                          />
                        </div>
                      </div>
                    ) : null)}

                  <div
                    className="add-employee-footer"
                    style={detailsStep === 1 ? { justifyContent: "end" } : {}}
                  >
                    {detailsStep > 1 && detailsStep < 4 && (
                      <div className="add-footer-left">
                        <button
                          type="button"
                          className="add-footer-cancel-btn"
                          onClick={() => {
                            const filteredTabs =
                              values?.citizen === "true"
                                ? docsTabs.filter(
                                    (tab) => tab !== "Iqama" && tab !== "Visa"
                                  )
                                : docsTabs.filter(
                                    (tab) => tab !== "National ID"
                                  );

                            const currentIndex =
                              filteredTabs.indexOf(documentTab);

                            if (detailsStep == 3) {
                              if (currentIndex == 0) {
                                setDetailsStep((prev) => prev - 1);
                              } else {
                                setDocumnetTab(filteredTabs[currentIndex - 1]);
                              }
                            } else if (detailsStep > 1) {
                              setDetailsStep((prev) => prev - 1);
                            }
                          }}
                          disabled={submitLoading || draftLoading}
                        >
                          {t("Back")}
                        </button>
                        {/* <button
                    type="button"
                    className="add-footer-cancel-btn"
                    onClick={() => setDetailsStep((prevState) => prevState + 1)}
                  >
                    Skip
                  </button> */}
                      </div>
                    )}
                    {detailsStep === 4 && (
                      <div className="add-footer-left">
                        <button
                          type="button"
                          className="add-footer-cancel-btn"
                          onClick={() => {
                            setDetailsStep((prevState) => prevState - 1);
                            setSkippedSections((prevSections) =>
                              prevSections.filter(
                                (section) => section !== "Subscription"
                              )
                            );
                          }}
                          disabled={submitLoading || draftLoading}
                        >
                          {t("Back")}
                        </button>
                      </div>
                    )}
                    <div className="add-footer-right">
                      {detailsStep < 4 &&
                        detailsStep > 1 &&
                        !shouldHideButtons && (
                          <button
                            type="button"
                            className="add-footer-cancel-btn"
                            onClick={() => {
                              setIsDraft(false);
                              let currentSection;
                              if (detailsStep === 2) {
                                currentSection = "employmentInfo";
                              } else if (detailsStep === 3) {
                                currentSection = documentTab;
                              }

                              // Add the current section to the skippedSections array
                              if (currentSection) {
                                setSkippedSections((prev) =>
                                  prev.includes(currentSection)
                                    ? prev
                                    : [...prev, currentSection]
                                );
                              }
                              const filteredTabs =
                                values?.citizen === "true"
                                  ? docsTabs.filter(
                                      (tab) => tab !== "Iqama" && tab !== "Visa"
                                    )
                                  : docsTabs.filter(
                                      (tab) => tab !== "National ID"
                                    );

                              const currentIndex =
                                filteredTabs.indexOf(documentTab);
                              const isLastTab =
                                currentIndex === filteredTabs.length - 1;
                              if (detailsStep == 3) {
                                if (isLastTab) {
                                  setDetailsStep((prev) => prev + 1);
                                } else {
                                  setDocumnetTab(
                                    filteredTabs[currentIndex + 1]
                                  );
                                }
                              } else if (detailsStep < 4) {
                                setDetailsStep((prev) => prev + 1);
                              }
                            }}
                            disabled={submitLoading || draftLoading}
                          >
                            {t("Skip")}
                          </button>
                        )}
                      {(personalInfo?.status !== "active" ||
                        detailsStep !== 4) &&
                        !shouldHideButtons &&
                        ((!personalInfo || personalInfo?.status === "draft") &&
                        values.userInvitation === "true" &&
                        detailsStep === 4 ? null : (
                          <button
                            type="submit"
                            className="add-footer-cancel-btn"
                            onClick={() => {
                              setIsDraft(true);
                              if (
                                !personalInfo ||
                                personalInfo?.status === "draft"
                              ) {
                                setDraftAndExit(true);
                              } else if (personalInfo?.status === "active") {
                                setSaveAndExit(true);
                              }
                            }}
                            disabled={
                              submitLoading ||
                              draftLoading ||
                              hasValidationErrorInCurrentStep
                            }
                          >
                            {draftLoading ? (
                              <ButtonLoading thisColor={"#475467"} />
                            ) : !personalInfo ||
                              personalInfo?.status === "draft" ? (
                              detailsStep === 4 ? (
                                t("Save As Draft")
                              ) : (
                                t("Draft & Exit")
                              )
                            ) : (
                              personalInfo?.status === "active" &&
                              t("Save & Exit")
                            )}
                          </button>
                        ))}
                      <button
                        type={!shouldHideButtons ? "submit" : "button"}
                        className="add-footer-submit-btn"
                        disabled={
                          submitLoading ||
                          draftLoading ||
                          hasValidationErrorInCurrentStep
                        }
                        onClick={(e) => {
                          setIsDraft(false);

                          if (shouldHideButtons) {
                            // CRITICAL: Prevent form submission
                            e.preventDefault();
                            e.stopPropagation();

                            let currentSection;
                            if (detailsStep === 2) {
                              currentSection = "employmentInfo";
                            } else if (detailsStep === 3) {
                              currentSection = documentTab;
                            }

                            // Add the current section to the skippedSections array
                            if (currentSection) {
                              setSkippedSections((prev) =>
                                prev.includes(currentSection)
                                  ? prev
                                  : [...prev, currentSection]
                              );
                            }

                            const filteredTabs =
                              values?.citizen === "true"
                                ? docsTabs.filter(
                                    (tab) => tab !== "Iqama" && tab !== "Visa"
                                  )
                                : docsTabs.filter(
                                    (tab) => tab !== "National ID"
                                  );

                            const currentIndex =
                              filteredTabs.indexOf(documentTab);
                            const isLastTab =
                              currentIndex === filteredTabs.length - 1;

                            if (detailsStep == 3) {
                              if (isLastTab) {
                                setDetailsStep((prev) => prev + 1);
                              } else {
                                const nextTab = filteredTabs[currentIndex + 1];

                                setDocumnetTab(nextTab);
                              }
                            } else if (detailsStep < 4) {
                              setDetailsStep((prev) => prev + 1);
                            }
                          }
                          // If shouldHideButtons is false, let the form submission proceed normally
                        }}
                      >
                        {detailsStep === 4 ? (
                          submitLoading ? (
                            <ButtonLoading />
                          ) : (
                            t("Submit")
                          )
                        ) : (
                          t("Next")
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Form>
        )}
      </Formik>
      {/* Add this at the end of your form component, before the last closing div/fragment */}
      <DocumentViewerNew
        isOpen={documentViewerState.isOpen}
        onClose={() =>
          setDocumentViewerState({ isOpen: false, url: "", fileName: "" })
        }
        documentUrl={documentViewerState.url}
        fileName={documentViewerState.fileName}
      />
    </div>
  );
}
